export default {
  welcome: "Добро пожаловать",
  request_processing: "Ваш запрос получен и обрабатывается...",
  start_typing_or_select: "Начните вводить или выберите из списка...",
  download: "Скачать",
  toc: "Содержание",
  view: "Отображать",
  find: "Найти",
  search: "Найти по наименованию или БИН или электронная почта...",
  compact: "Компактно",
  full: "Полностью",
  message_sent: "Ваше сообщение отправлено",
  more: "Подробнее",
  order_group_search: "Заказать бизнес справку",
  logout_counter_message:
    'Через 5 минут заканчивается сессия, нажмите "отмена" чтобы отменить',
  password_expires_in_3_days_title: "Через 3 дня нужно сменить пароль",
  password_expires_in_3_days_text:
    "В целях безопасности нужно менять пароль каждые 30 дней. Через 3 дня заканчивается срок действия вашего пароля. Смените пароль в Личном кабинете",
  password_expired_text:
    "В целях безопасности нужно менять пароль каждые 30 дней. Ваш пароль устарел. Смените пароль.",
  cancel: "Отмена",
  close: "Закрыть",
  clear: "Очистить",
  history: "История",
  analyze: "Анализировать",
  confirm: "Подтвердите действие",
  confirm_translation: "Хотите перевести запрос на китайский?",
  "email-confirmed":
    "E-mail подтвержден. Используйте его и пароль указанный при регистрации для входа",
  yes: "Да",
  no: "Нет",
  send: "Отправить",
  approve: "Принять",
  return: "Вернуть на доработку",
  save: "Сохранить",
  save_and_send: "Сохранить и отправить",
  save_and_sign: "Сохранить и подписать",
  delete: "Удалить",
  back: "Назад",
  edit: "Редактировать",
  select: "Выбрать по параметрам",
  deselect: "Скрыть",
  ok: "Ок",
  add: "Добавить",
  readmore: "Показать больше",
  unreadmore: "Скрыть",
  collapse: "Свернуть",
  expand: "Развернуть",
  wait: "Идет загрузка. Не закрывайте окно, пожалуйста",
  tnved_code: "Код ТН ВЭД",
  tnved_name: "ТН ВЭД",
  validate: "Валидация",
  validate_full: "Проверить все",
  export_xml: "Экспорт в XML",
  export_pdf: "Экспорт в PDF",
  can_add_file_after_saving:
    "Файл можно добавить только после сохранения документа",
  validate_success: "Валидация прошла успешно",
  form_has_errors: "Документ содержит ошибки",
  error: "Произошла ошибка при сохранении. Попробуйте ещё раз",
  "errors-at-tab": "Ошибки на вкладке: ",
  "errors-dialog-title": "Ошибки в документе",
  "errors-dialog":
    "Документ содержит ошибки, и его невозможно сохранить. Исправте ошибки на вкладках, указанных ниже, и повторите попытку сохранения.",
  message: {
    "invite-ok": "Приглашения отправлены успешно",
    "registration-successfull": "Регистрация прошла успешно",
    "registration-successfull-big":
      "Ваша Заявка на регистрацию будет рассмотрена в ближайшее время.",
    "login-successfull": "Авторизация прошла успешно",
    "login-unsuccessfull": "Авторизация не удалась",
    "contract-created": "Контракт успешно создан",
    "contract-not-created": "Сохранение контракта не удалось",
    "invoice-created": "Документ Инвойс успешно создан",
    "invoice-not-created": "Сохранение инвойса не удалось",
    "specification-created": "Документ Спецификация успешно создан",
    "specification-not-created": "Сохранение документа Спецификация не удалось",
    "formm-created": "Документ Форма М успешно создан",
    "formm-not-created": "Сохранение документа Форма М не удалось",
    "packaging-created": "Документ упаковочный лист успешно создан",
    "packaging-not-created": "Сохранение упаковочного листа не удалось",

    "cmr-created": "Документ CMR успешно создан",
    "cmr-not-created": "Сохранение CMR не удалось",
    "fm1-created": "Документ ФМ-1 успешно создан",
    "fm1-not-created": "Сохранение ФМ-1 не удалось",
    "epi-created": "Документ ЭПИ успешно создан",
    "epi-not-created": "Сохранение ЭПИ не удалось",
    "awb-created": "Документ AWB успешно создан",
    "awb-not-created": "Сохранение AWB не удалось",
    "ktg-ok": "Создание КТЖ прошло успешно",
    "ktg-nok": "Создание КТЖ не удалось",
    "decline_delivery_offer-ok": "Предложение отклонено",
    "decline_delivery_offer-nok": "Запрос не удался",
    "decline_broker_offer-ok": "Предложение отклонено",
    "decline_broker_offer-nok": "Запрос не удался",
    "create-delivery_offer-nok": "Создание оффера не удалось",
    "select-delivery_offer-nok": "Запрос не удался",
    "delivery_offer-ok": "Предложение принято",
    "create-delivery_offer-ok": "Создано успешно",
    "select-delivery_offer-ok": "Запрос удался",
    "create-broker_offer-ok": "Создано успешно",
    "create-broker_offer-nok": "Создание оффера не удалось",
    "broker_offer-ok": "Предложение принято",
    "broker_offer-nok": "Запрос не удался",
    "select-broker_offer-ok": "Запрос удался",
    "select-broker_offer-nok": "Запрос не удался",
    astana_1_ok: "Файл XML успешно сформирован",
    astana_1_nok: "Не удалось создать XML файл",
    d_selector_ok: "Файл XLSX успешно сформирован",
    d_selector_nok: "Не удалось создать XLSX файл",
    wsdl_astana_1_ok: "Запрос отправлен успешно",
    wsdl_astana_1_nok: "Запрос не удался",
    ktzh_sftp_ok: "Запрос отправлен успешно",
    ktzh_sftp_nok: "Запрос не удался",
    contract_signed: "Контракт успешно подписан.",
    contract_not_signed: "Подписание не удалось. Попробуйте еще раз.",
    contract_not_signed_cert_invalid:
      "Подпись не удалось. Ключ не верный. Если у вас поменялся ключ – установите его в личном кабинете",
    document_signature_is_wrong:
      "Подпись документа не верная. Либо документ был изменен, либо еще не был подписан.",
    document_signature_is_ok:
      "Подпись документа верная. Печатная форма сгененрирована.",
    document_signed: "Документ успешно подписан",
    document_not_signed: "Документ не удалось подписать",
    document_not_signed_cert_invalid:
      "Документ не удалось подписать. Ключ не верный. Если у вас поменялся ключ – установите его в личном кабинете",
    "save_pa_doc-ok": "Документ успешно сохранен",
    "save_pa_doc-nok": "Документ не сохранен",
    "update_pa_doc-ok": "Документ успешно обновлен",
    "update_pa_doc-nok": "Документ не обновлен",
    "remove_pa_doc-ok": "Документ успешно удален",
    "remove_pa_doc-nok": "Документ не удален",
    success: "Операция выполнена успешно",
    no_success: "Не удалось завершить операцию",
    "rwb-created": "Железнодорожная накладная сохранена успешно",
    "rwb-not-created": "Не удалось сохранить железнодорожную накладную",
    "insurance-created": "Страховка сохранена успешно",
    "insurance-not-created": "Не удалось сохранить страховку",
    signature_bin_is_not_found:
      "У вашей подписи не найден БИН. Используйте другую подпись",
    signature_bin_is_not_valid:
      "БИН вашей подписи не совпадает. Используйте другую подпись",
    signature_no_contragent:
      "Вы не можете подписать договор. Контрагент не выбран!",
    "offer-created": "Предложение успешно создано",
    "offer-not-created": "Предложение не создано",
    "offer-deleted": "Предложение успешно удалено",
    "offer-not-deleted": "Предложение не удаляется",
    login_request_not_approved:
      "Ваш запрос на регистрацию еще не прошел проверку",
    login_user_not_found: "Пользователь не найден",
    login_user_blocked: "Пользователь заблокирован",
    login_verification_needed: "Нужна верификация",
    login_wrong_credentials: "Неверный логин или пароль",
    login_ecp_invalid: "Недействительная ЭЦП",
    ktg_attorney_created: "КТЖ Доверенность создана успешно",
    ktg_attorney_not_created: "КТЖ Доверенность не оформляется",
    account_balance_is_low: "Текущий баланс вашего счёта: {balance}. Пожалуйста, примите меры, чтобы избежать перебоев в обслуживании.",
  },
  deals: {
    no: "Нет заключенных Сделок",
  },
  archive: {
    no: "Архив завершенных Сделок пуст",
  },
  aml: {
    aka: "Другие названия",
    key_data: "Ключевые данные",
    show_full: "Показать полные данные",
    fields: "Области",
    media: "Медиа",
    keywords: "Ключевые слова",
    field_name: "Название",
    field_source: "Источник",
    field_value: "Значение",
    noresults: "Совпадений нет",
    countries: "Страны",
    DOB: "Дата рождения",
    adverse_media_subtype: "Подтипы нежелательных медиа",
    related_url: "Связанный URL",
    created_at: "Дата назначения",
    other_info: "Другая информация",
    associates: "Аффилированный",

    full_name: "Полное название",
    entity_type: "Тип",
    listing: "Списки",
    additional_listings: "Дополнительные данные",

    currently_on: "Действующие",
    removed_from: "Снятые",
    ended_at: "Дата снятия",
  },
  notifications: {
    empty: "Нет уведомлений",
    showall: "Показать все уведомления",
    notifications_title: "Уведомления",
    view_title: "Просмотр уведомления",
    type_1_title:
      "Уведомление о поступлении предложения по Заявке №{{ObjectId}}",
    type_1_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку поступило предложение от {{CreatorName}}",
    type_2_title:
      "Уведомление о поступлении ответа на предложение по Заявке №{{ObjectId}}",
    type_2_text:
      "Уважаемый {{OrgName}}, на Ваше Предложение на Заявку поступил ответ от {{CreatorName}}",
    type_3_title:
      "Уведомление о согласии на совершение сделки по Заявке №{{ObjectId}}",
    type_3_text:
      "Уважаемый {{OrgName}}, на Ваше Предложение на Заявку поступило согласие о заключении сделки от {{CreatorName}}",
    type_4_title: "Уведомление об участии в Сделке",
    type_4_text:
      "Уважаемый {{OrgName}}, на Ваше Предложение на Заявку поступило Согласие об участии в Сделке от {{CreatorName}}",
    type_5_title: "Уведомление об отказе в участии в Сделке",
    type_5_text:
      "Уважаемый {{OrgName}}, на Ваше Предложение на Заявку поступил Отказ в заключении сделки от {{CreatorName}}",
    type_6_title: "Приглашение к перевозке товара по Заявке №{{ObjectId}}",
    type_6_text:
      "Уважаемый {{OrgName}}, Вам поступило предложение на перевозку товара от {{CreatorName}}",
    type_7_title: "Согласие на перевозку товара по Заявке №{{ObjectId}}",
    type_7_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку на перевозку от {{CreatorName}} поступило Согласие.",
    type_8_title: "Отказ от перевозки товара по Заявке №{{ObjectId}}",
    type_8_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку на перевозку товара от {{CreatorName}} поступил Отказ.",
    type_9_title: "Выбор перевозчика по Заявке №{{ObjectId}}",
    type_9_text:
      "Уважаемый {{OrgName}}, Ваша компания выбрана исполнителем на перевозку товара от {{CreatorName}}.",
    type_10_title: "Предложение брокеру по Заявке №{{ObjectId}}",
    type_10_text:
      "Уважаемый {{OrgName}}, Вам поступило предложение на оказание услуг таможенного брокера от {{CreatorName}}",
    type_11_title: "Выбор брокера по Заявке №{{ObjectId}}",
    type_11_text:
      "Уважаемый {{OrgName}}, Ваша компания выбрана исполнителем оказания услуг таможенного брокера {{CreatorName}}",
    type_12_title:
      "Согласие на оказание услуг таможенного Брокера по Заявке №{{ObjectId}}",
    type_12_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку на  оказание услуг таможенного брокера от {{CreatorName}} поступило Согласие.",
    type_13_title:
      "Отказ от оказания услуг таможенного Брокера по Заявке №{{ObjectId}}",
    type_13_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку на  оказание услуг таможенного брокера от {{CreatorName}} поступил Отказ.",
    type_14_title: "Выбор брокера по Заявке №{{ObjectId}}",
    type_14_text:
      "Уважаемый {{OrgName}}, Ваша компания выбрана исполнителем на перевозку товара от {{CreatorName}}",

    type_15_title: "Подписание сделки",
    type_15_text:
      "Уважаемый {{OrgName}}, Ваша Заявка подписана {{CreatorName}} ссылка на Заявку",

    type_16_title: "Новая заявка на регистрацию",
    type_16_text:
      "Уважаемый администратор, поступила новая заявка на регистрацию от {{ContractId}} {{CreatorName}}. Проверьте ее в разделе Регистрации",

    type_17_title: "Изменение договора оферты",
    type_17_text:
      "Уважаемый {{OrgName}}, В договоре оферты произошли изменения. ",

    type_18_title: "Страховой запрос одобрен",
    type_18_text: "Уважаемый {{OrgName}}, страховой запрос одобрен.",

    type_19_title: "Страховой запрос отклонен",
    type_19_text: "Уважаемый {{OrgName}}, страховой запрос отклонен.",

    type_20_title: "Новый страховой запрос",
    type_20_text:
      "Уважаемый {{OrgName}}. Вам отправлена анкета запроса на получение страховки от {{CreatorName}}.",

    type_21_title: "Подписание страхового договора",
    type_21_text:
      "Уважаемый {{OrgName}}. Ваше предложение по услугам страхования принято {{CreatorName}}.",

    type_22_title: "Страховой запрос отклонен",
    type_22_text: "Уважаемый {{OrgName}}, страховой запрос отклонен.",

    type_24_title: "Уведомление об изменениях в мониторинге СА",
    type_24_text:
      "Уважаемый {{OrgName}}. По отслеживаемому запросу в ComplyAdvantage появились изменения.",

    type_26_title: "Ответ на предложение по Заявке №{{ObjectId}}",
    type_26_text:
      "Уважаемый {{OrgName}}, на Вашу Заявку поступил ответ от {{CreatorName}}",
    type_30_title: "Новый предварительный контракт от импортёра / агента",
    type_30_text:
      "Уважаемый {{OrgName}}. Имеется новый предварительный контракт от импортера / агента.",
    type_31_title: "Форма M была создана",
    type_31_text: "Уважаемый {{OrgName}}. Форма M была успешно создана.",
    type_32_title: "Статус формы M был изменён",
    type_32_text: "Уважаемый {{OrgName}}. Статус формы М был изменен.",
    type_33_title: "Форма M была зарегистрирована в системе",
    type_33_text:
      "Уважаемый {{OrgName}}. Форма M (PAAR) была зарегистрирована в системе.",

    contragent: "Контрагент",
    offer: "Предложение",
    courieroffer: "Предложение доставки",
    contract: "Контракт",
    CreatorName: "От кого",
    OrgName: "Кому",
    Title: "Тема",
    CreationDate: "Дата",
    perPage: "Показать по",
    insurance_request: "Страховой запрос",
  },
  education: {
    videos: "Ролики",
    manuals: "Документы",
    examples: "Примеры поисков",
    links: "Полезные ссылки",
    choose_category: "Выберите категорию",
  },
  menu: {
    business_note_history: "История бизнес справок",
    partner_search_history: "История поиска контрагентов",
    all_records: "Все записи",
    ca_history: "История мониторинга запросов",
    home: "На портал",
    customers: `Клиентам`,
    about: `О нас`,
    partners: `Партнерам`,
    events: `События`,
    project: `О проекте`,
    board: `Менеджмент`,
    services: `Услуги`,
    contacts: `Контакты`,
    signin: `Вход`,
    register: `Регистрация`,
    find_partner: "Простой поиск контрагентов в Китае",
    find_person: "Найти человека",
    risk_control: "Контроль над рисками",
    business_score: "Бизнес Оценка",
    company_historical_sales: "Исторические продажи компании",
    case_filling_info: "Информация о подаче дела",
    find_partner_410: "Поиск контрагентов в Китае с рейтингами",
    "my-orders": "Мои Контракты",
    orders: "Контракты",
    deals: "Сделки",
    archive: "Архив",
    logout: "Выход",
    account: "Личный кабинет",
    twh: "Уведомления СВХ",
    comply_advantage: "Проверка и мониторинг контрагента",
    company_information: "Информация о компании",

    monitoring: "Мониторинг и проверки",
    business_note: "Бизнес справка по Китайской компании",
    education: "Обучение",
    back_to_home: "Вернуться на главную",
    ask_a_question: "Задать вопрос",
    short_search: "Краткая бизнес справка",
  },
  account: {
    atb_info:
      "Клиенты АТБ при первичной регистрации получают 3000 рублей на баланс",
    balance: "Баланс",
    topup_account: "Пополнить баланс",
    clientstatus: "Cтатус клиента",
    tarif: "типовой тариф",
    atb: "Клиент АТБ",
    topup_amount: "Сумма, руб",
    topup: "Получить счет",
    you_have: "На вашем счету: ",
    not_enough_funds_message:
      "На вашем счету не достаточно средств. Невозможно выполнить запрос.",
    operation_history: "История операций",
    history_action_description: "Стоимость операции (руб.)",
    admin_history_action_description: "Запрос",
    admin_history_action_created_by: "Email",

    bin: "БИН",
    "company-country": "Страна регистрации",
    iin: "ИИН",
    dob: "Дата рождения",
    gender: "Пол",
    male: "Мужской",
    female: "Женский",
    "user-section": "Пользователь",
    "company-section": "Компания",
    edit_profile: "Редактировать профиль",
    change_password: "Изменить пароль",
    contracts: "Мои контракты",
    offers: "Мои заявки",
    residency: "Резидентство",
    phone: "Телефон",
    email: "E-mail",
    position: "Должность",
    address: "Адрес",
    old_password: "Старый пароль",
    old_password_wrong: "Старый пароль не верный",
    insecure_new_password:
      "Пароль должен иметь, как минимум, одну цифру и один спецсимвол.",
    short_new_password: "Пароль должен иметь длинну 8 символов",
    new_password: "Новый пароль",
    confirm_password: "Подтвердить пароль",
    fill_all_fields: "Заполните все поля",
    passwords_not_equal: "Новый пароль и подтверждение пароля не совпадают",
    accounts_of_company: "Счета компании",
    documents_of_company: "Документы",
    addresses_of_company: "Адреса компании",
    founders_of_company: "Основатели компании",
    socials: "Социальные сети",
    org_name: "Наименование",
    org_custom_code: "Таможенный код",
    org_type: "Тип организации",
    company_website: "Веб-сайт",
    country: "Страна регистрации",
    bank: "Банк",
    account: "Р/С",
    currency: "Валюта счета",
    is_open: "Открыт",
    add_bank: "Добавить счет",
    save_bank: "Сохранить счет",
    org_founders_person_name: "ФИО",
    org_founders_company: "Компания",
    org_founders_share: "Доля",
    org_founders_country: "Страна резидентства",
    add_founder: "Добавить основателя",
    save_founder: "Сохранить основателя",
    jur_address: "Юридический адрес",
    post_address: "Почтовый адрес",
    fact_address: "Фактический адрес",
    post_addr_country: "Страна",
    index: "Индекс",
    region: "Регион",
    district: "Район",
    town: "Город",
    city: "Населенный пункт",
    street: "Улица",
    house: "Номер дома",
    room: "Номер помещения",
    number: "Номер (тел., e-mail)",
    org_oked: "ОКЕД",

    company_contacts: "Контакты",
    org_reg_date: "Дата первичной регистрации",
    org_reregdate: "Дата последней перерегистрации",
    company_status: "Статус ЮЛ",
    company_filials: "Сведения о филиалах (при наличии)",
    company_ceo: "Сведения о руководителе",
    company_ceo_date: "Сведения о дате назначения руководителя",
    organization_networks: "Соц. сети",

    org_is_broker: "Организация является брокером",
    org_is_carrier: "Организация является перевозчиком",
    org_is_bank: "Организация является банком",

    kpved: "Сферы деятельности",
    address_clone: "Скопировать из юридического адреса",
    document_number: "Номер документа",
    document_serial: "Серия документа",
    document_date: "Дата документа",
    document_issued_by: "Кем выдан",
    document_active: "Действующий",
    document_exp_date: "Дата истечения срока действия",
    add_document: "Сохранить документ",
    update_document: "Обновить документ",

    signatures: "Электронные подписи",
    cert_installed: "Сертификат подписи установлен",
    cert_start_date: "Дата начала действия сертификата",
    end_start_date: "Дата окончания действия сертификата",
    cert_bin: "БИН сертификата",
    add_new_cert: "Добавить новый сертификат",
    change_signature:
      "Вы собираетесь изменить электронную подпись. Старая подпись перестанет действовать. Вы уверены?",
    signature_is_not_valid_yet:
      "Сертификат подписи еще не начал действовать и не может быть установлен",
    signature_is_already_not_valid:
      "Сертификат подписи просрочен и не может быть установлен",
    pa_oferta: "Договор оферты",

    insurance_requests: "Запросы страховки",
    ceo_name: "ФИО Руководителя",
    status: "Статус заявки",
    statute: "Устав",
    registration_certificate: "Свидетельство о государственной регистрации",
    signature_right_certificate:
      "Приказ/документ на право подписи на Руководителя",
    ceo_passport: "Удостоверение личности/паспорт Руководителя",
    insurance_request_certificate: "Страховое свидетельство",
    insurance_request_insurer_message: "Сообщение о причине отказа",

    insurance_request_status_returned: "Возвращен страховщиком на доработку",
    insurance_request_status_new: "Новый",
    insurance_request_status_approved: "Одобрен",
    insurance_request_status_: "Новый",

    add_insurance_requests: "Добавить запрос страховки",
    contract: "Контракт",

    org_is_insurer: "Организация является страховщиком",
    amount: "Сумма",
    date_time: "Дата/время",
    insurance_type: "Тип заявки",
    insurance_type_6: "Страховка груза",
    insurance_type_7: "Страховка ответственности",
    transport_requests: "Запросы перевозки",
    broker_requests: "Запросы услуг брокера",
    insurance_requests: "Запросы страховки",
    insurers_list: "Страховые компании",
    insurers_list_empty:
      "Ни одна страховая компания еще не откликнулась на ваш запрос",
    insurers_list_insurer_name: "Страховой агент",
    insurers_list_insurer_orgname: "Страховая компания",
    insurers_list_insurer_message: "Комментарий",
    insurers_list_insurer_status: "Статус",
    insurers_list_insurer_price_franchise: "Цена и франшиза",
    insurers_list_insurer_select: "Выбрать и подписать",
    insurers_list_insurer_sign: "Подписать",
    edit_insurance_request: "Изменение страхового запроса",
    or_upload_new: "или загрузите новый",

    insurers_list_insurer_select_status: "Статус",
    insurers_list_insurer_select_status_0: "Не выбран",
    insurers_list_insurer_select_status_1: "Выбран",
    insurer_submit_details: "Отправить детали предложения",
    insurance_price: "Цена контракта",
    insurance_franchise: "Франшиза",
    insurance_submit: "Отправить предложение",

    insurance_request_signed: "Страховой запрос подписан",
    add_insurance_contract_details: "Укажите данные предложения страховки",

    offer_group_mine: "Мои",
    offer_group_for_me: "Мне",
    offer_requests: "Запросы",
    offers_full: "Предложения",

    pre_contracts: "Пре-контракты",

    admin_sad_builder: "Конструктор ГТД",

    auth_history: "Журнал входов",

    topup_step: "Шаг",
    topup_step_1_title: "Введите сумму к пополнению",
    topup_step_2_title: "Получите счёт",
    topup_step_3_title: "Оплатите счёт",
    topup_step_4_title:
      "Дождитесь пополнения баланса в личном кабинете (до 2-х рабочих дней после оплаты счёта)",
    topup_step_5_title: "Вернуться в личный кабинет",

    topup_history: "История платежей",

    topup_history_operation: "Пополнение/списание",
    topup_history_service: "Услуга",

    team_id: "#",
    team_email: "E-mail",
    team_phone: "Телефон",
    team_position: "Должность",
    team_first_name: "Имя",
    team_last_name: "Фамилия",
    team_password: "Временный пароль",
    team: "Пользователи",
    team_remove_confirm: "Вы уверены, что хотите удалить этого пользователя?",
    team_active_confirm:
      "Вы уверены, что хотите активировать этого пользователя?",
    team_add_user: "Добавить пользователя",
    team_edit_user: "Изменить пользователя",
    is_privileged: "Привелегированный",

    team_status: "Статус",
    team_status_active: "Активный",
    team_status_inactive: "Неактивный",
    team_analytics_total: "Всего пользователей",

    analytics_ca_clicks: "Кликов мониторинг",
    analytics_ca_cost: "Цена мониторинга",
    analytics_search_clicks: "Кликов поиск (простой)",
    analytics_search_cost: "Цена поисков (простой)",
    analytics_search_clicks410: "Кликов поиск (с рейтингом)",
    analytics_search_cost410: "Цена поисков (с рейтингом)",
    analytics_note_clicks: "Кликов справка",
    analytics_note_cost: "Цена справок",

    data_tab: "Данные пользователя",
    topup_tab: "Пополнить счет",
    logins_tab: "Журнал входов",
    administration_tab: "Администрирование",
    analytics_tab: "Аналитика пользователей",
    download_history: "Скачать историю в",
    users: "Пользователи",

    current_password: "Введите текущий пароль",
    new_password: "Придумайте новый пароль",
    repeat_new_password: "Повторите новый пароль",

    help_account: "Помощь в работе с личным кабинетом",
    help_account_line_1:
      "Для поиска Вам необходимо ввести наименование (или фрагмент наименования) юридического лица либо имя физического лица на английском или русском языках.",
    help_account_line_2:
      "Все результаты поиска сохраняются в истории. Вы можете получить доступ к сохраненным результатам, как для повторного просмотра, так и для вывода на печать.",
    help_account_line_3:
      "Здесь Вы сможете настроить бесплатный мониторинг по сформированному запросу. Что позволит Вам автоматически отслеживать изменения информации проверяемого объекта, и получать соответствующие уведомления об изменениях в Ваш личный кабинет.",
    demo_mode: "Демо режим",
  },
  home_slider: {
    header: `Трансграничная электронная торговая платформа`,
    subheader: `Интегрирующая Китай и Россию`,
  },
  home_adv: {
    base_title: `Основа`,
    base_text: `Проверенные и внедренные решения как фундамент`,
    standards_title: `Стандарты`,
    standards_text: `Использование мировых стандартов для крупномасштабного внедрения`,
    workflow_tilte: `Документооборот`,
    workflow_text: `Полная интеграция электронных документов по обе стороны границ`,
    integration_title: `Интеграция`,
    integration_text: `Интеграция всех игроков внешнеэкономической операции, государственных и финансовых институтов`,
    scale_title: `Масштаб`,
    scale_text: `Общая межгосударственная система транзита и расчетов`,
  },
  title: {
    news: `Последние События`,
  },
  reg_form: {
    email_login_place: "Укажите ваш логин",
    password_place: "Введите пароль",
    sure_cancel: `Точно отменить регистрацию?`,
    kompra: `Загрузить данные из stat.gov.kz`,
    egrul: "Поиск в ЕГРЮЛ/ЕГРИП",
    title: `Форма регистрации`,
    title_wf: `Регистрация`,
    customer_data: `Данные Клиента`,
    customer_id: `Укажите ИИН`,
    customer_id_not_kz: `Personal number`,
    customer_last_name: `Укажите фамилию`,
    customer_first_name: `Укажите имя`,
    customer_middlename: "Должность в компании", //`Укажите отчество (если есть)`,
    customer_email: `Укажите e-mail`,
    customer_password: `Укажите временный пароль`,
    customer_password_placeholder: `Не менее 8 символов, должен содержать числа, буквы и знаки препинания`,
    customer_birthdate: `Дата рождения`,
    customer_address: "Адрес проживания",
    customer_position: "Должность",
    customer_phone: "Телефон (+7 999 123 45 67)",
    customer_gender: `Пол`,
    customer_male: `Мужской`,
    customer_female: `Женский`,
    company_data: `Данные Компании`,
    company_id: `Укажите БИН`,
    company_id_not_kz: `Company code`,
    company_id_ru: "БИН",
    customer_id_ru: "БИН",
    company_title: `Укажите название компании`,
    company_regdate: "Дата первичной регистрации",
    company_status: "Статус ЮЛ",
    company_reregdate: "Дата последней перерегистрации",
    company_oked: "ОКЭД",
    company_oked_code: "Код",
    secondary_company_oked: "Дополнительный ОКЭД",
    secondary_company_oked_code: "Код",
    company_contacts: "Контакты (при наличии)",
    company_region: "Регион",
    company_main_sphere: "Основной вид деятельности",
    company_additional_sphere: "Вспомогательный вид деятельности (при наличии)",
    company_filials: "Сведения о филиалах (при наличии)",
    company_ceo: "Сведения о руководителе",
    company_ceo_date: "Сведения о дате назначения руководителя",
    company_founder: "Сведения об учредителе",
    company_number_of_founders: "Количество учредителей",
    company_social_networks: "Соц. сети",
    company_website: "Сайт",
    company_address: `Адрес`,
    company_accept: `С договором <a target="_blank" class="text-dark text-underline" href="[[offer_link]]">оферты</a> согласен`,
    policy_accept: `С политикой обработки <a target="_blank" class="text-dark text-underline" href="[[policy_link]]">персональных данных</a> согласен`,
    submit_button: `Отправить заявку`,

    inn_placeholder: `Укажите БИН`,
    company_name_placeholder: `Укажите название компании`,
    company_address_placeholder: `Юридический адрес компании`,
    position: `Должность`,
    position_placeholder: `Укажите должность в компании`,
    position_placeholder_user: `Укажите должность пользователя в компании`,
    last_name: `Фамилия`,
    last_name_placeholder: `Укажите фамилию представителя компании`,
    last_name_placeholder_user: `Укажите фамилию пользователя`,
    first_name: `Имя`,
    first_name_placeholder: `Укажите имя`,
    first_name_placeholder_user: `Укажите имя пользователя`,
    phone: `Телефон`,
    password_placeholder: `Укажите временный пароль`,
    password: "Пароль",
    email_login: "E-mail / Логин",
  },
  login_form: {
    title_wf: "Вход в личный кабинет",
    submit_button: "Войти",
    password: "Пароль",
    email: "E-mail",
    ecp_login: "Войти с ЭЦП",
    ecp_NONE: "Выберите тип",
    ecp_PKCS12: "Ваш Компьютер",
    ecp_AKKaztokenStore: "Казтокен",
    ecp_AKKZIDCardStore: "Личное Удостоверение",
    ecp_type: "Тип хранилища ключа",
    forgot_password: "Забыли пароль?",
    forgot_password_button: "Сгенерировать новый пароль",
    forgot_password_description:
      "Ссылка на генерацию нового пароля будет отправлена на почту",
    forgot_email_sent:
      "Проверьте вашу почту, письмо со ссылкой на смену пароля отправлено.",
    forgot_email_not_sent: "Такой пользователь не найден или произошла ошибка.",
    reset_password_button: "Сменить пароль",
    reset_password: "Установить новый пароль",
    reset_password_description:
      "Установите новый пароль для своего аккаунта (укажите E-mail и новый пароль)",
    reset_password_success_description: "Новый пароль успешно установлен",
    reset_password_success: "Пароль изменен",
    time_to_logout_description:
      "Время сессии завершено. Нужно повторно авторизироваться в системе",
    time_to_logout_title: "Время сессии завершено",
  },
  errors: {
    required: "Это поле обязательное",
    integer: "Допустимы только цифры",
    alpha: "Допустимы только буквы",
    min_length: "Минимальная длина 12 символов",
    max_length: "Максимальная длина 12 символов",
    email: "Введите корректный E-mail",
    url: "Введите корректный URL",
    password: "Пароль должен содержать как минимум 1 цифру и один символ",
  },
  contracts: {
    search_by_number: "Поиск по номеру",
    search_by_number_button: "Искать",
    ktzh_log_type_request: "Запрос",
    ktzh_log_type_response: "Ответ",
    ktzh_movement_1: "1 - Внутриреспубликанским направления",
    ktzh_movement_2: "2 - Импортном направлении",
    ktzh_movement_3: "3 - Экспортном направлении",
    ktzh_movement_4: "4 - Транзитном направлении",
    ktzh_movement_5: "5 - По всем направлениям",
    ktzh_participant_1: "1 - Грузоотправитель",
    ktzh_participant_2: "2 - Экспедитор",
    ktzh_participant_0: "0 - Грузополучатель",

    paper_copy: "Cкачать PDF отчёт", //"Бумажные копии",
    paper_copy_no_logo: "Cкачать PDF отчёт (Без логотипа)",
    paper_copy_proxy_ktzh: "Доверенность КТЖ",
    paper_copy_proxy_ktzh_no_logo: "Доверенность КТЖ (Без логотипа)",
    paper_copy_invoice: "Инвойс",
    paper_copy_invoice_no_logo: "Инвойс (Без логотипа)",
    paper_copy_cmr: "CMR",
    paper_copy_cmr_no_logo: "CMR (Без логотипа)",
    paper_copy_contract: "Контракт",
    paper_copy_contract_no_logo: "Контракт (Без логотипа)",
    paper_copy_transport_contract: "Транспортный контракт",
    paper_copy_transport_contract_no_logo:
      "Транспортный контракт (Без логотипа)",
    upload: "Загрузить",
    customs_organs: "Таможенные органы",
    customs_xml_astana_1: "XML Астана 1",
    customs_xml_astana_1_title:
      "Выгрузка XML контракта {contract_id} для загрузки в ASTANA1",
    make_xml_file: "Сформировать XML файл",
    customs_xlsx_d_selector: "XLSX D-Sector",
    customs_xlsx_d_selector_title:
      "Выгрузка данных контракта {contract_id} для ПО D-Sector TS",
    make_xlsx_file: "Сформировать XLSX файл",
    customs_wsdl_astana: "WSDL Астана",
    customs_wsdl_astana_title: "Web сервис ASTANA1. Контракт {contract_id}",
    send_data_to_astana_1: "Передать данные в ASTANA1",
    astana_1_answer: "Ответ из ASTANA1",
    transport_organs: "Перевозчики",
    transport_ktzh: "КТЖ",
    transport_ktzh_title:
      "Информационный обмен с КТЖ по Контракту {contract_id}",
    transport_ktzh_make_title: "КТЖ Запрос данных по контракту №{contract_id}",
    transport_ktzh_view_title:
      "Просмотр КТЖ запроса по контракту №{contract_id}",
    transport_ktzh_view_resp_title:
      "Просмотр КТЖ ответа по контракту №{contract_id}",
    ktzh_log_id: "№ п/п",
    ktzh_log_type: "Запрос/ответ",
    ktzh_log_date: "Дата",
    ktzh_log_file: "Файл",
    ktzh_log_action: "Просмотр",
    make_ktzh_request: "Запрос данных у КТЖ",
    ktzh_for_date: "На дату",
    ktzh_bin: "БИН",
    ktzh_movement_type: "Вид сообщения",
    ktzh_participant_type: "Тип участника",
    ktzh_expeditor_code: "Код экспедитора",
    ktzh_send_request: "Отправить запрос на sftp",

    ktzh_invoice_un: "Уникальный идентификатор",
    ktzh_invoice_num: "Номер отправки",
    ktzh_recive_station_code: "Код станции отправления",
    ktzh_dest_station_code: "Код станции назначения",
    ktzh_sender_exp_no:
      "12-ный   код   отправителя,   вприоритете,   при   наличии, экспортный код отправителя",
    ktzh_etsng_code: "Код груза по ЕТСНГ",
    ktzh_fact_mass: "Грузоподъемность вагона",
    ktzh_payer_code: "Код плательщикав SAP",
    ktzh_vag_no: "Номер вагона",
    ktzh_vag_count: "Количество     вагонов     вотправке",
    ktzh_gruz: "Масса груза фактическая",
    ktzh_invc_dt: "Дата приема к перевозке",
    ktzh_container_no: "Номер контейнера",
    ktzh_smgs_type: "Тип     межгосударственногосообщения",

    transport_auto: "Авто",
    transport_avia: "Авиа",
    transport_water: "Водная",
    governmental_organs: "Госорганы",
    governmental_organs_tax: "Налоговые органы РК",
    governmental_organs_certification: "Органы сертификации",
    governmental_organs_fin_monitoring: "Фин. мониторинг",
    governmental_organs_customs: "Пограничная служба",
    governmental_organs_make_choise: "Выберите",

    exim: "ЭксИм",
    brokers_tab: "Брокеры",
    broker: "Брокер",
    choose_broker: "Выбор брокера",
    epi_price: "Цена ЭПИ",
    td_price: "Цена ТД",
    broker_request_modal_title: "Заявка на услуги брокера по контракту №",
    broker_request: "Запрос на услуги брокера",
    select_broker: "Выбрать брокера",
    epi_price_currency: "Валюта",
    td_price_currency: "Валюта",
    delivery_term: "Условия поставки",
    brokers: "Брокеры",
    couriers_tab: "Перевозка",
    view: "Просмотр",
    delivery_price: "Стоимость доставки",
    delivery_date: "Срок доставки",
    offer_date: "Дата предложения",
    choose_courier: "Выбор перевозчика",
    delivery_request: "Запрос на перевозку",
    select_courier: "Выбрать перевозчика",
    delivery_request_modal_title: "Предложения на перевозку по контракту №",
    delivery_request_from: "От",
    delivery_type: "Тип перевозки",
    delivery_type_auto: "Автомобильная",
    delivery_type_railway: "Железнодорожная",
    delivery_type_avia: "Авиа",
    delivery_type_sea: "Морская",
    delivery_type_post: "Почтовая",
    from_address: "Откуда",
    to_address: "Куда",
    weight: "Вес, брутто",
    volume: "Объем",
    delivery_price_currency: "Валюта",
    date_of_load: "Дата загрузки",
    date_of_delivery: "Дата поставки",
    packaging: "Упаковка",
    hazard_class: "Класс опасности",
    hazard_class0: "Не опасный груз",
    hazard_class1: "Класс 1: Взрывчатые вещества и изделия",
    hazard_class2: "Класс 2: Газы",
    hazard_class3: "Класс 3: Легковоспламеняющиеся жидкости",
    hazard_class4:
      "Класс 4: Легковоспламеняющиеся твердые вещества, самореактивные вещества и твердые десенсибилизированные взрывчатые вещества",
    hazard_class5: "Класс 5: Окисляющие вещества",
    hazard_class6: "Класс 6: Ядовитые и инфекционные вещества",
    hazard_class7: "Класс 7: Радиоактивные материалы",
    hazard_class8: "Класс 8: Коррозионные вещества",
    hazard_class9: "Класс 9: Прочие опасные вещества и изделия",
    comments: "Примечания",
    couriers: "Перевозчики",
    couriers_attahments_info:
      "Новые вложения будут сохранены при сохранении предложения",
    courier_name: "Наименование",
    courier_code: "Код",
    invite: "Пригласить",

    offer_from: "Предложение от",
    offers_show_declined: "Показать отвергнутые предложения",
    offer_no_changes: "Предложение на подписание контракта, без правок",
    offer_no_changes_message:
      "Отправляя это предложение, вы автоматически подписываете контракт ЭЦП со своей стороны. Если автор контракта примет ваше предложение, будет сформирована сделка.",
    submit_ktg: "КТЖ",
    attachements: "Вложения",
    add_attachement: "Добавить вложение",
    add_attachement_info:
      "Новые вложения будут сохранены при сохранении контракта",
    "close-contract": "Изменения будут утеряны. Точно закрыть контракт?",
    filter_contracts: "Фильтровать контракты",
    number: "Номер",
    title: "Тема",
    amount: "Сумма",
    date: "Дата",
    owner: "Владелец",
    contragent: "Контрагент",
    currency: "Валюта",
    new: "Сформировать",
    add_form: "Сформировать контракт",
    contract_tab: "Контракт",
    contragents_tab: "Контрагенты",
    offers_tab: "Предложения",
    contract_status: "Статус контракта",
    status_1: "Заявка",
    status_2: "Заключение сделки",
    status_3: "Сделка",
    status_4: "Не актуален",
    type: "Тип контракта",
    case: "Вид контракта",
    type_buy: "Покупка",
    type_sell: "Продажа",
    case_product: "Товары",
    case_service: "Услуги",
    subject: "Тема",
    description: "Описание",
    currency: "Валюта",
    contract_date: "Дата поставки",
    contract_amount: "Стоимость контракта",
    buyer: "Покупатель",
    seller: "Продавец",
    product: "Товар",
    payment: "Оплата",
    courier: "Перевозчик",
    actions: "",
    product_number: "Номер",
    product_title: "Наименование",
    product_sku: "Код ТН ВЭД",
    ai_search: "AI поиск",
    run: "Начать",
    product_qty: "Количество",
    product_units: "Единицы измерения",
    product_unit_price: "Цена единицы товара",
    conditions: "Условия поставки",
    conditions_code: "Код условий поставки",
    payment_conditions: "Условия оплаты",
    payment_conditions_code: "Код условий оплаты",
    place: "Место",
    term: "Сроки поставки",
    is_public: "Публичный контракт",
    send_to_adb: "Отправить в ADB",
    submit_button: "Сохранить контракт",
    submit_and_sign_button: "Сохранить и подписать",
    add_form: "Сформировать новый контракт",
    edit_form: "Редактировать контракт",
    current_contracts: "Контракты",
    products: "Товары",
    add_product: "Добавить товар",
    add_place: "Добавить место",
    number_of_items: "Кол-во позиций",
    find_partner: "Искать партнера",
    find_param_1: "Параметр 1",
    find_param_2: "Параметр 2",
    find_param_3: "Параметр 3",
    find_param_4: "Параметр 4",
    find_param_5: "Параметр 5",
    find_param_6: "Параметр 6",
    search_other: "Искать вне ATTIS",
    shipping_cost: "Стоимость доставки",
    search: "Искать",
    search_china: "Поиск китайской компании",
    save_search: "Сохранить поиск",
    send_notifications: "Отправить уведомления",
    saved_searches: "Сохраненные поиски",
    search_results: "Результаты поиска",
    contragents_search_id: "№ Канд",
    contragents_search_country: "Страна",
    contragents_search_name: "Наименование",
    contragents_search_contact: "Контакт",
    contragents_search_sphere: "Вид деятельности",
    contragents_search_checked: "Выбран",
    contragents_search_email: "E-mail",
    attis_contract_deadline: "Срок действия предложения",
    saved_searches_date: "Дата поиска",
    saved_searches_number_of_results: "Количество результатов",
    documents_tab: "Документы",
    docs_cat_all: "Все",
    docs_cat_commerce: "Коммерческие",
    docs_cat_finance: "Финансовые",
    docs_cat_transport: "Транспортные",
    docs_cat_customs: "Таможенные",
    double_click_to_open: "Двойной щелчок, чтобы открыть",
    add_file: "Добавить документ",
    browse: "Перетащите файлы сюда или кликните для выбора в диалоге...",
    file_too_big: "Ваш файл больше 10Mb. Пожалуйста попробуйте другой.",
    file_too_big20: "Ваш файл больше 20Mb. Пожалуйста попробуйте другой.",
    file_wrong_type:
      "Мы принимаем только файлы в форматах JPG, PNG, PDF, DOC, XLS, DOCX и XLSX. Пожалуйста выберите подходящий файл и повторите.",
    offer: "Предложение",
    products_description: "Описание товара",
    offer_status: "Статус",
    update_fields_you_need: "Обновите нужные поля",
    offer_file: "Файл",
    offer_valid_date: "Срок действия предложения",
    offer_changes: "Изменения",
    single_offer: "Просмотр предложения",
    offer_answer: "Ответ",
    offer_accept: "Принять",
    contract_sign: "Подписать контракт",
    offer_decline: "Отказать",
    offer_answer_title: "Ответ на предложение",
    offer_chain_title: "Цепочка ответов",
    offer_show_chain_answer: "Показать цепочку",
    offer_hide_chain_answer: "Скрыть цепочку",
    offer_answer_text: "Текст ответа",
    offer_answer_send: "Отправить",
    single_document: "Просмотр документа",
    new_document: "Создание документа",
    document_number: "Номер документа",
    document_date: "Дата документа",
    document_types: "Типы документа",
    document_invoice: "Инвойс",
    document_cmr: "CMR",
    document_awb: "AWB",
    document_sad: "САД",
    document_ktg_attorney: "Доверенность КТЖ",
    document_ktg_attorney_no_logo: "Доверенность КТЖ (Без логотипа)",
    document_payment: "Платежка",
    document_save: "Сохранить",
    document_save_validate: "Сохранить и проверить",
    document_create: "Создать",
    document_create_validate: "Создать и проверить",
    document_file: "Файл документа (до 20Мб)",
    invoice_document_number: "Номер инвойса",
    invoice_document_date: "Дата инвойса",
    invoice_document_currency: "Валюта инвойса",
    invoice_document_places_quantity: "Кол-во грузовых мест",
    invoice_document_places_description: "Вид грузовых мест",
    invoice_document_gross_weight: "Вес брутто (кг)",
    invoice_document_net_weight: "Вес нетто (кг)",
    invoice_document_gcost: "Общая стоимость",
    invoice_document_discount: "Cумма скидки",
    invoice_document_transport_charges: "Cумма транспортных расходов",
    invoice_document_insurance_charges: "Cумма расходов по страхованию",
    invoice_document_other_charges: "Сумма прочих расходов",
    invoice_document_total_cost: "Общая стоимость по инвойсу",
    invoice_document_payment_period: "Срок оплаты",
    invoice_document_buyer: "Покупатель",
    invoice_document_seller: "Продавец",
    invoice_products: "Сведения о товарах инвойса",
    cmr_products: "Сведения о товарах",
    cmr_places: "Места по CMR",
    invoice_products_GoodMarking: "Артикул",
    invoice_products_GoodsCode: "ТН ВЭД",
    invoice_products_GoodsDescription: "Описание товара",
    invoice_products_GoodsQuantity: "Количество товара",
    invoice_products_SupplementaryQualifierName: "Доп. ед. измерения",
    invoice_products_GrossWeightQuantity: "Вес товара, брутто (кг)",
    invoice_products_NetWeightQuantity: "Вес товара, нетто (кг)",
    invoice_products_Price: "Цена товара/услуги",
    invoice_products_Discount: "Cумма скидки",
    invoice_products_DiscountPercentage: "Cумма скидки %",
    invoice_products_OriginCountryCode: "Код страны происхождения",
    invoice_products_ServiceCharges: "Сервисные расходы",
    invoice_products_TransportCharges: "Транспортные расходы",
    invoice_products_OtherCharges: "Прочие расходы",
    document_cancel_message: "Вы уверены, что хотите отменить изменения?",
    company_number: "Идентификатор",
    company_name: "Наименование",
    company_address: "Адрес",
    company_bank: "Банк",
    company_account: "Счет",
    company_phone: "Номер телефона",
    company_email: "Электронная почта",
    company_fax: "факс",
    add_seller: "Добавить продавца",
    add_buyer: "Добавить покупателя",
    offer_new: "Добавить предложение",
    document_cmr: "CMR",
    cmr_products_GoodsMarking: "Знаки и номера",
    cmr_products_GoodsQuantity: "Количество мест",
    cmr_products_GoodsDescription: "Наименование груза",
    cmr_products_GoodsNomenclatureCode: "Код ТН ВЭД",
    cmr_products_GrossWeightQuantity: "Вес товара, брутто (кг)",
    cmr_products_VolumeQuantity: "Объем товара (груза) в кубометрах",
    cmr_places_typecode: "Вид грузового места",
    cmr_places_count: "Кол-во грузовых мест",
    cmr_placesform_type_code: "Код вида упаковки/грузового места",
    cmr_placesform_places_count: "Кол-во грузовых мест/упаковок",
    cmr_placesform_places_description: "Описание грузовых мест/упаковки",
    cmr_placesform_part_count:
      "Количество упаковки/грузовых мест, частично занятых товаром",
    cmr_track_reg_country_name: "Страна регистрации транспортного средства",
    cmr_number: "Номер CMR",
    cmr_date: "Дата CMR",
    cmr_sender: "Отправитель",
    cmr_recipient: "Получатель",
    cmr_courier: "Перевозчик",
    cmr_courier_next: "Последующий перевозчик",
    cmr_track: "Марка и номер тягача",
    cmr_trailer: "Номер прицепа",
    DeliveryPlace: "Наименование пункта поставки",
    DeliveryTermsStringCode: "Условия поставки",
    DeliveryTermsStringCode_code: "Код условий поставки",
    TermsDescription: "Коментарии",
    cmr_g_3: "Место разгрузки",
    cmr_g_4: "Дата и место погрузки",
    cmr_CountryCode: "Страна",
    cmr_City: "Город",
    cmr_GoodsCost: "Объявленная стоимость груза",
    cmr_StreetHouse: "Адрес",
    cmr_PostalCode: "Индекс",
    cmr_TakingCargoDate: "Дата погрузки",
    cmr_WarehouseName: "Название СВХ или ТС",
    add_courier: "Добавить перевозчика",
    add_courier_next: "Добавить последующего перевозчика",
    add_sender: "Добавить отправителя",
    add_recipient: "Добавить получателя",
    document_fm1: "ФМ1",

    fm1_tab1: "Сведения о форме ФМ-1",
    fm1_tab1_short: "Сведения",
    fm1_main_date: "1.2 Дата формы ФМ-1",
    fm1_main_doc_kind: "1.3 Вид документа",
    fm1_main_form_state: "1.4 Состояние операции",
    fm1_main_reason: "1.5 Основание для подачи сообщения",
    fm1_main_doc_kind_1: "Новое сообщение",
    fm1_main_doc_kind_2: "Корректировка непринятого сообщения",
    fm1_main_doc_kind_3: "Запрос замены сообщения",
    fm1_main_doc_kind_2_number: "Укажите номер корректируемого сообщения",
    fm1_main_doc_kind_3_number: "Укажите номер сообщения",
    fm1_main_form_state_1: "Совершено",
    fm1_main_form_state_2: "Продолжается",
    fm1_main_form_state_3: "Приостановлено",
    fm1_main_form_state_4: "Не совершено",
    fm1_main_form_state_1_date: "Время завершения операции",
    fm1_main_form_state_2_date: "Время начала операции",
    fm1_main_form_state_3_date:
      "Время приостановки операции субъектом финансового мониторинга",
    fm1_main_subreason: "Выберите подпункт",
    fm1_main_reason_1: "Равна или превышает пороговую сумму",
    fm1_main_reason_2: "Подозрительная операция",
    fm1_main_reason_sub_1:
      "совершение сделки, не имеющей очевидного экономического смысла»",
    fm1_main_reason_sub_2:
      "совершение действий, направленных на уклонение от процедур финансового мониторинга».",
    fm1_main_reason_sub_3: "финансирование терроризма и (или) экстремизма",
    fm1_main_related_date: "Дата связанной формы ФМ-1",
    fm1_tab2:
      "Сведения о субъекте финансового мониторинга,направившем форму ФМ-1",
    fm1_tab2_short: "Субъект",
    fm1_subj_code: "2.1 Код субъекта финансового мониторинга*",
    fm1_subj_group: "2.2 Субъект финансового мониторинга*",
    fm1_subj_org_form: "1.1. Организационная форма: ",
    fm1_subj_name: "1.2. Наименование: ",
    fm1_subj_pers_second_name: "1.2.1. Фамилия:",
    fm1_subj_pers_name: "1.2.2. Имя:",
    fm1_subj_pers_patronymic: "1.2.3. Отчество (при наличии):",
    fm1_subj_rnn: "2.3 РНН*",
    fm1_subj_iin_bin: "2.4 ИИН/БИН*",
    fm1_address_group: "2.5 Адрес местонахождения",
    state_kaz: "1. Область (в том числе гг. Алматы и Астана):",
    region_kaz: "2. Район: ",
    sity_kaz:
      "3. Населенный пункт (город/поселок/село), за исключением гг. Алматы и Астаны: ",
    street: "4. Наименование улицы/проспекта/микрорайона: ",
    house_num: "5. Номер дома: ",
    flat_num: "6. Номер квартиры/офиса (при наличии):",
    post_index: "7. Почтовый индекс:",
    fm1_document_id_group:
      "2.6 Документ, удостоверяющий личность (для физических лиц)*",
    fm_1_passport_group:
      "2.6.1 Номер и серия документа, удостоверяющего личность (для физических лиц)*",
    doc_num: "1. Номер:",
    doc_series: "2. Серия (при наличии):",
    goverm_office:
      "2.6.2 Кем выдан документ, удостоверяющий личность (для физических лиц)*",
    doc_date:
      "2.6.3 Когда выдан документ, удостоверяющий личность (для физических лиц)*",
    fm1_responsive_person_group: "2.7 Ответственное должностное лицо",
    fm1_subj_manager_second_name: "1. Фамилия:",
    fm1_subj_manager_name: "2. Имя:",
    fm1_subj_manager_patronymic: "3. Отчество (при наличии):",
    fm1_subj_position: "2.7.1 Должность ответственного должностного лица",
    fm1_subj_phone: "2.8 Контактные телефоны*",
    fm1_subj_email: "2.9 Электронная почта",
    is_fiz_lico: "Субъект мониторинга:",
    fiz_lico: "Физическое лицо",
    yur_lico: "Юридическое лицо",
    fm1_tab3: "Информация об операции, подлежащей финансовому мониторингу",
    fm1_tab3_short: "Операция",
    fm1_oper_number: "3.1 Номер операции*",
    fm1_oper_code_type: "3.2 Код вида операции*",
    fm1_oper_eknp: "3.3 Код назначения платежа *",
    fm1_oper_members_quant: "3.4 Количество участников операции*",
    fm1_oper_currency: "3.5 Код валюты операции*",
    fm1_oper_curr_code: "3.6 Сумма операции в валюте ее проведения*",
    fm1_oper_tenge_sum: "3.7 Сумма операции в тенге*",
    fm1_oper_basis: "3.8 Основание совершения операции*",
    fm1_oper_group:
      "3.9 Дата и номер документа, на основании которого осуществляется операция",
    fm1_oper_basis_doc_date: "1. Дата:",
    fm1_oper_basis_doc_num: "2. Номер документа:",
    fm1_oper_1code: "3.10 Код признака подозрительности операции",
    fm1_oper_2code:
      "3.11 1-й дополнительный код признака подозрительности операции (при наличии)",
    fm1_oper_3code:
      "3.12 2-й дополнительный код признака подозрительности операции (при наличии)",
    fm1_oper_trouble_desc:
      "3.13 Описание возникших затруднений квалификации операции как подозрительной",
    fm1_oper_add_info: "3.14 Дополнительная информация по операции",

    fm1_tab4:
      "4. Сведения об участниках операции, подлежащей финансовому мониторингу",
    fm1_tab4_short: "Участники",
    fm1_members_fm1_member: "4.1 Участник (нужное подчеркнуть)*",
    fm1_members_fm1_memb_is_subj:
      "4.2 Клиент субъекта финансового мониторинга (нужное подчеркнуть)*",
    fm1_members_fm1_memb_subj_kind: "4.3 Вид участника*",
    fm1_members_fm1_memb_country: "4.4 Резидентство",
    fm1_members_fm1_memb_type:
      "4.5 Тип участника операции (нужное подчеркнуть)*",
    fm1_members_fm1_memb_foreign:
      "4.6 Иностранное публичное должностное лицо (нужное подчеркнуть)",

    fm1_member_bank: "4.7 Банк участника операции*",

    fm1_members_fm1_memb_bank_branch_place: "1.1. Местонахождение филиала:",
    fm1_members_fm1_memb_bank_branch: "1.2. Наименование банка:",
    fm1_members_fm1_memb_sdp: "1.2.1. Наименование СДП:",
    fm1_members_fm1_memb_branch_code: "1.3. Код банка/филиала:",
    fm1_members_fm1_memb_acc: "1.4. Номер счета участника:",
    fm1_correspondent_account:
      "1.5. Сведения о корреспондентских счетах, участвующих в операции:",

    fm1_members_fm1_memb_bank_place: "1.5.1. Местонахождение банка:",
    fm1_members_fm1_memb_bank_name: "1.5.2. Наименование банка:",
    fm1_name_of_participant:
      "4.8 Наименование участника операции (для юридических лиц)*",
    fm1_member_participant: "1. Участник:",

    fm1_members_fm1_memb_org_form: "1.1. Организационная форма:",
    fm1_members_fm1_memb_company_name: "1.2. Наименование:",
    fm1_members_fm1_memb_noname: "2. Невозможно установить",
    fm1_founders_of_member: "4.9 Учредители участника (для юридических лиц)",

    fm1_members_fm1_memb_founder_org_form: "1.1. Организационная форма:",
    fm1_members_fm1_memb_founder_: "2.1. Наименование:",
    fm1_members_fm1_memb_founder_secondname: "1.2.1. Фамилия:",
    fm1_members_fm1_memb_founder_name: "1.2.2. Имя:",
    fm1_members_fm1_memb_founder_patronymic: "1.2.3. Отчество (при наличии):",
    fm1_members_fm1_memb_country: "2. Резидентство:",
    fm1_first_head: "4.10 Первый руководитель (для юридических лиц)",

    fm1_persons_fm1_person_secondname: "1. Фамилия:",
    fm1_persons_fm1_person_name: "2. Имя:",
    fm1_persons_fm1_person_midle_name: "3. Отчество (при наличии):",
    fm1_members_oked: "4.12 ОКЭД",
    fm1_members_iin_bin: "4.13 ИИН/БИН",
    fm1_memebers_fio:
      "4.14 Ф.И.О. (для физических лиц и индивидуальных предпринимателей)",

    fm1_persons_fm1_person_secondname: "1.1. Фамилия:",
    fm1_persons_fm1_person_name: "1.2. Имя:",
    fm1_persons_fm1_person_middle_name: "1.3. Отчество (при наличии):",
    fm1_members_: "2.1. Невозможно установить",
    fm1_docs_doc_type: "4.15 Документ, удостоверяющий личность",
    fm1_docs_doc_type_first_head:
      "4.16 Номер и серия документа, удостоверяющего личность",

    fm1_docs_doc_num: "1. Номер:",
    fm1_docs_doc_series: "2. Серия (при наличии):",
    fm1_docs_goverm_office: "4.17 Кем выдан документ, удостоверяющий личность",
    fm1_docs_doc_date: "4.18 Когда выдан документ, удостоверяющий личность",
    fm1_persons_fm1_person_birth_date:
      "4.19 Дата рождения (для физических лиц и индивидуальных предпринимателей)",
    fm1_persons_fm1_person_birth_place:
      "4.20 Место рождения (для физических лиц и индивидуальных предпринимателей)",
    fm1_persons_yur_address:
      "4.21 Юридический адрес (для юридических лиц - юридический адрес, для физических лиц - адрес места регистрации)",

    fm1_addrr_state_kaz: "1. Область (в том числе гг. Алматы и Астаны):",
    fm1_addrr_region_kaz: "2. Район:",
    fm1_addrr_sity_kaz:
      "3. Населенный пункт (город/поселок/село, за исключением гг. Алматы и Астаны):",
    fm1_addrr_street: "4.Наименование улицы/проспекта/микрорайона:",
    fm1_addrr_house_num: "5. Номер дома:",
    fm1_addrr_flat_num: "6. Номер квартиры/офиса (при наличии):",
    fm1_addrr_post_index: "7. Почтовый индекс:",
    fm1_members_fm1_memb_contact_phone: "4.22 Номер контактного телефона",
    fm1_members_fm1_memb_email: "4.23 Электронная почта",
    fm1_members_fm1_memb_fact_address:
      "4.24 Фактический адрес (для юридических лиц - адрес местонахождения, для физических лиц - адрес места проживания)",

    fm1_addrr_state_kaz: "1. Область (в том числе гг. Алматы и Астаны):",
    fm1_addrr_region_kaz: "2. Район",
    fm1_addrr_sity_kaz:
      "3. Населенный пункт (город/поселок/село, за исключением гг. Алматы и Астаны):",
    fm1_addrr_street: "4. Наименование улицы/проспекта/ микрорайона:",
    fm1_addrr_house_num: "5. Номер дома:",
    fm1_addrr_flat_num: "6. Номер квартиры/офиса (при наличии):",
    fm1_addrr_post_index: "7. Почтовый индекс:",
    fm1_members_fm1_memb_memb_add_info:
      "4.25 Дополнительная информация об участнике операции",

    fm1_fm1_member_payer: "1. Плательщик по операции ",
    fm1_fm1_member_recipient: "2. Получатель по операции ",
    fm1_fm1_member_payer_representative: "3. Представитель плательщика ",
    fm1_fm1_member_recipient_representative: "4. Представитель получателя ",
    fm1_fm1_member_face_in_name_of: "5. Лицо от имени и по поручению ",
    fm1_fm1_member_beneficiary: "6. Выгодоприобретатель",
    fm1_memebers_memb_subj_is_not: "Не является",
    fm1_memebers_memb_subj_is: "Является",
    fm1_memb_type1: "1. Юридическое лицо ",
    fm1_memb_type2: "2. Физическое лицо ",
    fm1_memb_type3: "3. Индивидуальный предприниматель",
    fm1_memb_foreign1: "Не является ",
    fm1_memb_foreign2: "Является ",
    fm1_memb_foreign3:
      "Лицо аффилированное с иностранным публичным должностным лицом",
    fm1_memb_org_form_1: "1 - АО",
    fm1_memb_org_form_2: "2 - ООО",
    fm1_memb_org_form_3: "3 - ОАО",
    fm1_memb_org_form_4: "4 - ЗАО",
    fm1_memb_org_form_5: "5 - не установлено",
    fm1_validate: "Валидация",
    fm1_kfm_xml: "Отправить в КФМ",

    //form api
    document_epi: "ЭПИ",

    document_epi_tab_1: "Общие сведения",
    document_epi_tab_1_short: "Общие",
    document_epi_tab_2: "Сведения о товарной партии",
    document_epi_tab_2_short: "Товарная партия",
    document_epi_tab_3: "Отправитель-получатель",
    document_epi_tab_3_short: "Отправитель-получатель",
    document_epi_tab_4: "Сведения о перевозке товаров",
    document_epi_tab_4_short: "Перевозка",
    document_epi_tab_5: "Товарная часть Гр. 31-47",
    document_epi_tab_5_short: "Товарная часть",
    document_epi_tab_6: "Предшествующие документы. Гр. 40.",
    document_epi_tab_6_short: "Документы",

    ap_main_reg_num: "Гр.А Регистрационный номер предварительной информации",
    ap_main_country_code: "Кодовое обозначение страны",
    ap_main_reg_date: "Дата регистрации",
    ap_main_trans_kind_code: "Код цели",
    ap_main_transit_direction_code: "Тип перевозки",
    ap_main_electronic_document_sign: "Гр.1 Признак ЭД",
    ap_main_declaration_kind: "Код особенности декларирования товаров",
    ap_main_subsoil_sign: "Признак недропользователя. для РК",
    ap_main_seal_number: "Номер пломбиратора в ТД",
    ap_main_seal_quantity: "Количество наложенных пломб в ТД",
    ap_main_language_cuesad: "Код языка заполнения документа",
    ap_main_recipient_country_code:
      "Код страны таможенного органа, которому представляется документ",
    ap_main_movement_code: "Цель перемещения в ТД",
    ap_main_movement_code_code: "Код цели перемещения в ТД",
    ap_main_transit_direction_code_1: "ИМ",
    ap_main_transit_direction_code_2: "ЭК",
    ap_main_transit_direction_code_3: "ТР",
    ap_main_transit_direction_code_4: "ВТ",
    ap_main_transit_direction_code_5: "ТС",

    ap_goods_group: "Сведения о товарной партии",
    ap_good_origin_country_name: "Страна происхождения товара",
    ap_good_specification_number: "Общее количество спецификаций",
    ap_good_specification_list_number: "Общее количество листов спецификаций",
    ap_good_total_goods_number: "Гр.5 Всего наименований товаров",
    ap_good_total_package_number: "Гр.6 Общее количество грузовых мест",
    ap_good_total_sheet_number: "Количество листов ДТ/ТД",
    ap_good_total_cust_cost: "Гр.22 Общая стоимость товаров",
    ap_good_cust_cost_currency_code: "Гр.22 Буквенный код валюты",

    ap_sender_group: "Гр.2 Сведения об отправителе товаров",
    ap_memb_organization_name: "Наименование",
    ap_memb_short_name: "Краткое наименование",
    ap_memb_bin: "БИН",
    ap_memb_itn: "ИТН",
    ap_sender_org_address: "Адрес организации",
    ap_member_postal_code: "Почтовый индекс",
    ap_member_country_name: "Код страны",
    ap_member_region: "Область (регион, штат, провинция и т.п.)",
    ap_member_city: "Населенный пункт",
    ap_member_street_house: "Улица, номер дома, номер офиса",
    ap_recipient_group: "Гр.8 Сведения о получателе товаров",

    ap_recipient_address: "Адрес организации",

    ap_lico_fin_ureg_group: "Лицо ответственное за финансовое урегулирование",

    ap_lico_fin_ureg_address: "Адрес организации",

    ap_declarant_group: "Сведения о декларанте товаров",

    ap_declarant_address: "Адрес организации",

    ap_person_declaraed_group:
      "Сведения о лице, заполнившем декларацию. Гр. 54/ гр 50 ТД",
    ap_person_person_surname: "Фамилия",
    ap_person_person_name: "Имя",
    ap_person_person_middle_name: "Отчество",
    ap_person_person_post: "Должность",
    ap_person_contact_phone: "Номер телефона",
    ap_courier_group: "Сведения о перевозчике гр. 50 ТД",

    ap_courier_address: "Адрес организации",

    ap_drivers_group: "Информация о водителях транспортных средств",

    ap_person_reg_country_code:
      "Код страны регистрации водителя транспортного средства",
    ap_document_id: "Документ, удостоверяющий личность",
    ap_send_rec_identity_card_code: "Код вида документа",
    ap_send_rec_identity_card_series: "Серия документа",
    ap_send_rec_identity_card_number: "Номер документа",
    ap_send_rec_identity_card_date: "Дата выдачи документа",
    ap_send_rec_organization_name:
      "Наименование организации, выдавшей документ",

    ap_send_rec_identitry_card_code_1: "паспорт",
    ap_send_rec_identitry_card_code_2: "водительское удостоверение",

    ap_transportations_place_group: "Местонахождение товаров. Гр. 30 ДТ",
    ap_transp_information_type_code: "Тип информации",
    ap_transp_customs_office: "Таможенный орган",
    ap_transp_customs_office_code: "Код таможенного органа",
    ap_transp_customs_country_code: "Код страны таможенного органа",
    ap_transportations_transport_group:
      "Сведения о перевозке товаров. Гр. 15, 15а, 17, 17а, 18, 19, 21, 25, 26, 29 - ДТ/ Гр. 15, 17, 18, 19, 21, 25, 26, 29, 53, 55 - ТД",
    ap_transp_container_indicator: "Гр.19 Признак контейнерных перевозок",
    ap_transp_dispatch_country_code: "Гр.15 Страна отправления",
    ap_transp_destination_country_code: "Гр.17 Страна назначения",
    ap_transportations_customs_group: "Гр.29 Таможенный орган въезда/выезда",
    ap_transp_customs_office_inout: "Код таможенного органа",
    ap_transp_customs_country_code_io:
      "Код государства члена Таможенного союза",
    ap_transp_date_expected_arrival: "Дата ожидаемого  прибытия",
    ap_transportations_transport_facilities_group:
      "Гр.18,26 Транспортные средства при прибытии/убытии",
    ap_transp_transport_mode_code: "Гр.25 Код вида ТС",
    ap_transp_transport_nationality_code:
      "Буквенный код страны принадлежности транспортных средств",
    ap_transportations_transport_description_group:
      "Описание транспортного средства",
    ap_transp_vin: "Номер шасси (VIN)",
    ap_transp_transport_identifier: "Номер транспортного средства",
    ap_transp_active_transport_identifier:
      "Идентификатор активного транспортного средства",
    ap_transp_information_type_code_11: "11 - СВХ",
    ap_transp_information_type_code_21: "21 - ТС",
    ap_transp_information_type_code_25: "25 - Свободный склад",
    ap_transp_information_type_code_31: "31 - Склад получателя",
    ap_transp_information_type_code_41:
      "41 - Склад хранения собственных товаров (для РК)",
    ap_transp_information_type_code_52: "52 - Транспортное средство",
    ap_transp_information_type_code_60: "60 - Помещение (площадки) УЭО",
    ap_transp_information_type_code_72: "72 - ЗТК (для РБ)",
    ap_transp_information_type_code_91: "91 - Адрес места хранения (для РБ)",
    ap_transp_information_type_code_99: "99 - Иное место ВХ",
    ap_transp_information_type_code_80: "80 - ОЭЗ.",
    ap_good_data_group: "Товарная часть Гр. 31-47",
    ap_good_data_goods_numeric:
      "Порядковый номер декларируемого товара / номер товара по списку/",
    ap_good_data_list_numeric: "Номер товара в списке",
    ap_good_data_goods_description: "Наименование",
    ap_good_data_gross_weight_quantity: "Вес товара, брутто (кг)",
    ap_good_data_net_weight_quantity: "Вес товара, нетто (кг)",
    ap_good_data_invoiced_cost: "Цена/ стоимость товара",
    ap_good_data_customs_cost: "Таможенная стоимость товара",
    ap_good_data_statistical_cost: "Статистическая стоимость товара",
    ap_good_data_goods_tnved_code: "Гр.33 Код товара по ТН ВЭД ТС",
    ap_good_data_origin_country_code: "Код страны происхождения",
    ap_good_data_delivery_terms_string_code: "Код условий поставки",

    save_product: "Сохранить",
    add_doc: "Добавить документ",
    save_doc: "Сохранить документ",
    epi_to_xml: "Отправить в ТО",

    ap_prev_doc_group: "Гр.40 Предшествующие документы",
    ap_prev_doc_preceding_document_date: "Предшествующий документ - дата",
    ap_prev_doc_preceding_document_number: "Регистрационный номер документа",
    ap_prev_doc_preceding_document_name: "Наименование предшествующего документа",

    document_delete_message: "Вы уверены, что хотите удалить документ?",

    country: "Страна",
    city: "Город",
    sphere: "Род деятельности",
    contr_search_name: "Наименование",

    contract_check_contragent: "Проверить покупателя/продавца?",

    good_selector: "Товар или услуга",
    good_selector_c1: "Раздел",
    good_selector_c2: "Отдел",
    good_selector_c3: "Группа",
    good_selector_c4: "Класс",
    good_selector_c5: "Наименование",

    ap_main_decl_num: "Гр.А Номер ТД внутренний",
    ap_main_decl_date: "Гр.50 Дата оформления ТД",
    ap_main_carnet: "Гр.1 Признак осуществления перевозки по книжке МДП",
    ap_transp_date_expected_arrival_time: "Время ожидаемого прибытия",
    ap_good_data_quant: "Количество товара",
    ap_good_data_ext_measure: "Доп. ед. измерения",
    ap_good_data_container_num: "Номера контейнеров",
    ap_prev_doc_kind: "Код документа",

    ap_good_data_places_group:
      "Сведения о грузе, грузовых местах, поддонах и упаковке товаров",
    ap_good_data_places: "Общее количество грузовых мест, занятых товаром",
    ap_good_data_packet: "Код наличия упаковки товара",
    ap_good_data_places_name: "Наименование вида грузовых мест",

    ap_good_data_packet_0: "0 - Без упаковки",
    ap_good_data_packet_1: "1 - С упаковкой",
    ap_good_data_packet_2:
      "2 - Без упаковки в оборудованных емкостях транспортного средства",

    awb_1_airport_code: "1) Код аэропорта отправления",
    awb_1a_acompany_code: "1А) Кодовый номер авиакомпании",
    awb_1b_serial_num: "1B) Серийный номер авианакладной",
    awb_1c_acomp_name_addr: "1С) Название и адрес авиакомпании",
    awb_2_sender_name_addr:
      "2) Имя (название/наименование) и адрес отправителя",
    awb_4_recipient_name_addr:
      "4) Имя (название/наименование) и адрес грузополучателя",
    awb_6_agent_name_addr:
      "6 Имя (название/наименование) агента выдающего перевозчика и город",
    awb_7_agent_iata_code: "7 Код ИАТА агента",
    awb_8_agent_acc: "8 Расчетный счет агента",
    awb_9_dest_airport: "9 Аэропорт отправления",
    awb_10_payment_data: "10 Информация по оплате",
    awb_11a_first_carrier_dest_point:
      "11А Пункт назначения первого перевозчика",
    awb_11b_fist_carrier_name:
      "11В Название первого перевозчика (маршрут и пункт назначения)",
    awb_11c_second_carrier_dest_point:
      "11С Пункт назначения второго перевозчика",
    awb_11d_second_carrier_name: "11D Название второго перевозчика",
    awb_11e_third_carrier_dest_point:
      "11Е Пункт назначения третьего перевозчика",
    awb_11f_third_carrier_name: "11F Название третьего перевозчика",
    awb_12_curr_code: "12 Код валюты для всех сумм",
    awb_14a_pr_o: "14А Способ оплаты сборов - за вес",
    awb_14b_col_l: "14В Способ оплаты сборов - за объявленную ценность",
    awb_15a_pr_d: "15А Способ оплаты других сборов - за вес",
    awb_15b_col_l: "15В Способ оплаты других сборов - за объявленную ценность",
    awb_16_decl_value_carr: "16 Заявленная ценность для перевозки",
    awb_17_decl_value_cust: "17 Заявленная ценность для таможни",
    awb_18_dest_airport: "18 Аэропорт конечного пункта назначения",
    awb_19ab_flight_date: "19A или 19B Бронирование на рейс/дату",
    awb_20_insuranse_amount: "20 Сумма страхования",
    awb_21_handling_info: "21 Информация по обработке груза",
    awb_21a_custom_status: "21А Таможенный статус груза",
    awb_22a_pieses_no:
      "22А Количество мест или пункт, в котором произошло изменение тарифа",
    awb_22b_brutto: "22В Вес брутто",
    awb_22c_measure: "22С Единица измерения веса груза",
    awb_22d_rate_class: "22D Код класса тарифа",
    awb_22e_commodity_item:
      "22Е Товарный номер или процент скидки/надбавки или тип класса тарифа для пакетированного груза",
    awb_22f_chargeable_weight: "22F Оплачиваемый вес",
    awb_22g_rate_charge:
      "22G Тариф или сбор или скидка для пакетированных грузов",
    awb_22h_total: "22Н Итого по тарифам и сборам",
    awb_22i_nature_quant: "22I Характер и количество груза",
    awb_22j_total_pieses: "22J Общее число мест",
    awb_22l_total_sum_rev: "22К Общий вес брутто",
    awb_22k_total_brutto: "22L Общая сумма сборов",
    awb_23_other_charges: "23 Характер других сборов",
    awb_24_weight_charge_sum: "24А или 24В Сумма сбора за вес",
    awb_25_valuation_sum: "25А или 25В Сумма сбора за объявленную ценность",
    awb_26_tax_sum: "26А или 26В Сумма налога",
    awb_27_total_other_charges:
      "27А или 27В Общая сумма других сборов в пользу агента",
    awb_28_carrier_total_other_charges:
      "28А или 28В Общая сумма других сборов в пользу перевозчика",
    awb_30_total_prepaid_collect:
      "30А или 30В Общая сумма сборов по авиагрузовой накладной",
    awb_32a_awb_create_date: "31 Подпись отправителя",
    awb_32b_awb_place: "32В Место выписки авиагрузовой накладной",
    awb_32c_signature: "32С Подпись представителя выдающей авиакомпании",

    document_awb: "AWB",
    document_packaging: "Упаковочные листы",

    documents_packaging_number: "Номер п/п",
    documents_packaging_invoice: "Инвойс",
    documents_packaging_products_count: "Кол-во товаров",
    documents_packging_list_for_invoice: "Упаковочный лист по инвойсу",
    documents_packaging_list_invoce_by_contract: "Инвойс по контракту №",
    packaging_brutto_total: "Вес брутто, всего",
    packaging_netto_total: "Вес нетто, всего",

    packaging_consignor: "Получатель",
    packaging_consignee: "Отправитель",

    packaging_number_pp: "№ п/п",
    packaging_goodsdescription: "Описание",
    packaging_goodsquantity: "Количество",
    packaging_placegoodsquantity: "Кол-во мест",
    packaging_places_tab: "Общее кол-во мест",
    packaging_transport_tab: "Транспорт",
    packaging_product_tab: "Товары",
    packaging_products_modal: "Товары по упаковочному листу",

    packaging_list_places_modal: "Общее кол-во мест по видам",

    packaging_measureunitqualifiername: "Ед. изм.",
    packaging_brutto: "Вес товара брутто",
    packaging_netto: "Вес товара нетто",
    packaging_dimensions: "Размеры товара",
    packaging_goodsvolume: "Объем товара",
    packaging_volumeunitqualifiername: "Ед. изм. объема",
    packaging_goodmarking: "Артикул",

    packging_placescount: "Кол-во мест",
    packaging_placesdescription: "Описание мест",
    packaging_packagingtypecode: "Код вида упаковки",
    packaging_partialplacescount: "Кол-во мест, занятых частично",

    packaging_list_transport_tab: "Транспорт",
    packaging_transport_number: "Номер ТС",
    packaging_transporttypecode: "Код вида ТС",
    packaging_transportcountrycode: "Код страны рег. ТС",
    packaging_transportleading: "Ведущее ТС",

    packaging_prouct_packaging_modal_title: "Места товаров",

    awb_31: "31 Подпись отправителя",
    awb_22a_group: "22А до 22L Подробности применения тарифа",

    confirm_removal: "Вы уверены, что хотите удалить этот контракт?",
    close_document: "Закрыть документ",
    contract_group_new: "Новые",
    contract_group_mine: "Мои",
    contract_group_participate: "Участвую",
    conditions_tab: "Условия по контракту",
    attis_contract_conditions_overdue: "Процент пени при просрочке платежа",
    attis_contract_conditions_packaging_transport_fees_included:
      "Стоимость упаковки и др. расходов включена",
    attis_contract_conditions_goods_origin_country:
      "Страна происхождения товаров",
    attis_contract_conditions_point_of_departure: "Пункт отправления",
    attis_contract_conditions_destination_point: "Пункт назначения",
    attis_contract_conditions_days_to_change_price: "Изменение цены, дней",
    attis_contract_conditions_days_to_change_price_description:
      "Продавец [Поставщик] имеет право изменять цены на Товары при условии оповещения Покупателя о предстоящем изменении не менее чем за __ дней до такого изменения",
    attis_contract_conditions_prepayment_percent: "% предоплаты",
    attis_contract_conditions_number_of_days_for_prepayment:
      "Срок предоплаты, дней",
    attis_contract_conditions_number_of_days_for_fullpayment:
      "Срок полной оплаты, дней",
    attis_contract_conditions_overdue_term: "Срок просрочки",
    attis_contract_conditions_shipping_term: "Срок отгрузки, дней",
    attis_contract_conditions_total_delivery_time: "Общий срок поставки",
    attis_contract_conditions_days_to_receive_goods: "Срок приемки, дней",
    attis_contract_conditions_days_to_quality_receive_goods:
      "Приемка по качеству, дней",
    attis_contract_conditions_transfer_of_ownership:
      "Переход права собственности ",
    attis_contract_conditions_guarantee_term: "Гарантийный срок",
    attis_contract_conditions_exceeding_guaranty_term:
      "Превышение гарантийного срока",
    attis_contract_conditions_payment_overdue: "Просрочка платежа, пеня %",
    attis_contract_conditions_shipping_overdue:
      "Штраф за просрочку поставки, % в день",
    attis_contract_conditions_payment_overdue_description:
      "_% от просроченной суммы за каждый день просрочки платежа",
    attis_contract_conditions_shipping_overdue_description:
      "% от стоимости неотгруженной партии Товаров за каждый день задержки",
    attis_contract_conditions_decline_due_to_overdue:
      "Отказ из-за просрочки поставки, дней",
    attis_contract_conditions_legal_country: "Страна законодательства",
    attis_contract_conditions_arbitrage_country: "Страна арбитража",
    attis_contract_conditions_contract_language: "Языки контракта",
    attis_contract_conditions_contract_term: "Срок действия контракта, дата",
    attis_contract_conditions_notification_term: "Срок уведомления",
    attis_contract_conditions_product_and_delivery: "Товар и поставка",
    attis_contract_conditions_quality_doc:
      "Документ, подтверждающий качество товарa",
    attis_contract_conditions_not_accept_fine:
      "Штраф за необоснованный отказ принять товар, % от общей стоимости",
    attis_contract_conditions_opening_letter_deadline:
      "Срок открытия аккредитива",
    attis_contract_conditions_opening_letter_deadline_description:
      ", не позднее, дней (аккредитив)",
    attis_contract_conditions_letter_payment_documents:
      "Платеж по аккредитиву против следующих документов",
    attis_contract_conditions_letter_payment_documents_description:
      "аккредитив, здесь указывается перечень документов, представляемых в банк для оплаты",
    attis_contract_conditions_docs_deadline_after_letter:
      "Срок предоставления документов",
    attis_contract_conditions_docs_deadline_after_letter_description:
      "в банк при оплате аккредитивом с момента его открытия",
    attis_contract_conditions_default_lang:
      "Превалирующий язык контракта при разночтениях",
    attis_contract_conditions_payment: "Оплата",
    attis_contract_conditions_contract_details: "Детали контракта",
    attis_contract_conditions_place_of_detention: "Место заключения",
    attis_contract_conditions_buyer_basis: "Покупатель действует на основании",
    attis_contract_conditions_seller_basis: "Продавец действует на основании",
    attis_contract_conditions_buyer_full_name: "Покупатель в лице",
    attis_contract_conditions_seller_full_name: "Продавец в лице",
    russian: "Русский",
    english: "Английский",
    chinese: "Китайский",
    russian_english: "Русский - Английский",
    russian_chinese: "Русский - Китайский",
    english_chinese: "Английский - Китайский",
    select_ecp_type: "Выберите способ подписи",
    only_for_kz: "Для резидентов Республики Казахстан. Требуется NCALayer",
    sign_with_ecp: "Подписать ЭЦП",
    sign_with_code: "Подписать кодом",
    input_signature_code: "Введите код, отправленный на ваш E-mail",
    signed_message_signature: "Подписан ЭЦП",
    signed_message_code: "Подписан Кодом",
    check_seller: "Проверить продавца",
    check_buyer: "Проверить покупателя",
    contract_check_contragent_alert:
      "Внимание! Проверка покупателя / продавца - платная услуга.",
    view_form: "Просмотр сделки",
    "no-signature-message":
      "Документ не имеет подписи, PDF сгенерирован без подписи",
    "yes-signature-message":
      "Документ имеет подпись, PDF сгенерирован с подписью",
    history_action_type: "Операция",
    history_action_created_by: "ID",
    history_action_username: "ФИО",
    history_action_date: "Дата действия",
    history_tab: "История договора",
    history_new_contract: "Новый контракт",
    history_contract_update: "Обновление контракта",
    history_contract_delete: "Удаление контракта",
    history_accept_contract: "Принять договор",
    history_new_ktg: "Новый КТЖ",
    history_new_broker_contract: "Новый брокерский договор",
    history_update_broker_contract: "Обновление брокерского договора",
    history_delete_broker_contract: "Удаление брокерского договора",
    history_contract_owner_sign: "Контракт подписан владельцем",
    history_contract_contragent_sign: "Контракт подписан контрагентом",

    history_new_RWB: "Новая ж / д накладная",
    history_update_RWB: "Обновить ж / д накладную",
    history_delete_RWB: "Удалить ж / д накладную",
    history_new_insurance: "Новая страховка",
    history_update_insurance: "Обновленные страховки",
    history_delete_insurance: "Удаление страховки",
    history_new_liability_insurance: "Новое страхование ответственности",
    history_update_liability_insurance: "Обновленное страховки ответственности",
    history_delete_liability_insurance: "Удаление страховки ответственности",

    history_sftp_download: "Загрузка файла SFTP",
    history_delete_document: "Удалить документ",
    history_new_invoice: "Новый счет",
    history_new_invoice_goods: "Новые товары по счету",
    history_invoice_update: "Обновление счета",
    history_new_cmr: "Новый CMR",
    history_new_cmr_cargo: "Новый CMR груз",
    history_new_cmr_goods: "Новые товары CMR",
    history_cmr_update: "Обновление CMR",
    history_new_fm1: "Новый ФМ-1",
    history_fm1_update: "Обновление ФМ-1",
    history_new_epi: "Новый ЭПИ",
    history_epi_update: "Обновление ЭПИ",
    history_new_awb: "New awb",
    history_awb_update: "Обновление AWB",
    history_new_packing_list: "Новый упаковочный лист",
    history_packing_list_update: "Обновление списка упаковки",
    history_delete_packing_list: "Удаление cписок упаковки",
    history_new_places: "Новые грузовые места",
    history_places_update: "Обновление грузовых мест",
    history_delete_places: "Удаление грузовых мест",
    select_radio_button: "Выбрать",

    history_new_broker_offer: "Новое брокерское предложение ",
    history_select_broker_offer: "Выбор предложения брокера",
    history_decline_broker_offer: "Отклонение предложения брокера",
    history_accept_broker_offer: "Принятие предложения брокера",
    history_broker_offer: "Брокерское предложение",
    history_select_courier_offer: "Выбор предложения курьера",
    history_decline_courier_offer: "Отклонение предложение курьера",
    history_courier_offer: "Курьерское предложение",
    history_new_courier_offer: "Новое курьерское предложение",
    history_delete_offer: "Удаление предложения",
    history_sign_offer: "Подпись предложения",
    history_new_offer: "Новое предложение",
    history_decline_offer: "Отклонение предложения",
    history_accept_offer: "Принятие предложения",
    history_answer_offer: "Ответить на предложения",
    custom_code: "Полные реквизиты ТП",
    courier_notes: "Оговорки и примечания перевозчика",
    cmr_docs: "Список прилагаемых документов",
    cmr_doc_type: "Тип документа",
    cmr_doc_number: "Номер документа",
    cmr_doc_date: "Дата",

    transport_contract: "Договор перевозки",
    cancel_term: "Отмена Заявки (часов)",
    consent_term: "Согласие перевозчика (часов)",
    inform_term: "Информирование клиента (часов)",
    location_term: "Местонахождение (часов)",
    fuel_percent: "Увеличение стоимости ДТ (%)",
    currency_percent: "Поднятие курса валюти (%)",
    application_term: "Подать заявку (часов)",
    customs_term: "Таможенное оформление (часов)",
    payment_term: "Произвести оплату (дней)",
    delay_abroad_term: "Простой при международной перевозке (дней)",
    delay_home_term: "Простой при внутренней перевозке (дней)",
    courier_cis_delay_amount: "Несвоевременной подачи автомашины в СНГ (тенге)",
    customer_cis_delay_amount: "Простой в СНГ (тенге)",
    courier_eu_delay_amount: "Несвоевременной подачи автомашины в ЕС (тенге)",
    customer_eu_delay_amount: "Простой в ЕС (тенге)",
    courier_declination_percent: "Неустойка при отказе Исполнителя (%)",
    penalty_percent: "Пеня за просрочку оплаты (%)",
    penalty_never_more: "Пеня не более чем (%)",
    customer_declination_percent: "Неустойка при отказе Клиента (%)",
    act_term: "Акт считается подписанным через (дней)",
    repeats_term: "Длительность форс-мажора (дней)",
    force_major_term: "Срок уведомления о форм-мажоре (дней)",
    claim_term: "Срок рассмотрения претензии (дней)",
    resolve_term: "Институт разрешения споров",
    contract_term: "Срок действия договора",
    contract_cancel_term: "Срок уведомления о расторжении (дней)",

    cancel_term_long:
      "Заявка может быть отменена Клиентом либо Перевозчиком в одностороннем порядке без оплаты штрафов, но не менее чем за _____ часов (исключая выходные и праздничные дни) до согласо-ванного времени прибытия транспортного средства Перевозчика под загрузку.",
    consent_term_long:
      "2.3. Перевозчик обязан в течение _________ часов с момента получения заявки сообщить о своем согласии или несогласии выполнить перевозку на предложенных условиях.",
    inform_term_long:
      "Проинформировать Клиента в течение _________ часов обо всех случаях вынужденной за-держки автомашины в пути, их причинах и других непредвиденных обстоятельствах, препятствующих своевременной погрузке.",
    location_term_long:
      "3.1.4. Предоставлять информацию Клиенту о местонахождении автомашины с грузом по всему пути следования каждые _________ часа с момента загрузки, информация может быть предоставлена как телефонограммой, так и в письменном виде",
    fuel_percent_long:
      "в случае, если стоимость ДТ увеличится более чем на ___%;",
    currency_percent_long:
      "- в случае, если произойдет поднятие курса валюты более чем на ___%;",
    application_term_long:
      "Подать Исполнителю письменную заявку на подачу автомашины под погрузку не позднее, чем за ___ часов до ее начала",
    customs_term_long:
      "Произвести таможенное оформление и разгрузочные работы в течение ____ часов с момента прибытия транспорта к указанному в заявке месту разгрузки.",
    payment_term_long:
      "Клиент обязан произвести оплату в течение ___ (___________) рабочих дней",
    delay_abroad_term_long:
      "Клиент несет материальную ответственность за простой автомашины, произошедшей по вине Клиента, Исполнителю под погрузкой или разгрузкой свыше ___ () рабочих дней при международной перевозке и ___ () рабочих дней при внутриреспубликанской перевоз-ке, за каждые последующие полные и неполные сутки в размере:",
    delay_home_term_long:
      "Клиент несет материальную ответственность за простой автомашины, произошедшей по вине Клиента, Исполнителю под погрузкой или разгрузкой свыше ___ () рабочих дней при международной перевозке и ___ () рабочих дней при внутриреспубликанской перевоз-ке, за каждые последующие полные и неполные сутки в размере:",
    courier_cis_delay_amount_long:
      "5.2. Исполнитель в случае несвоевременной подачи автомашины под погрузку в определенный сто-ронами срок, несет перед Клиентом материальную ответственность в размере: - ____ () тенге на территории стран ближнего зарубежья (СНГ);",
    customer_cis_delay_amount_long:
      "-  _____ () тенге на территории стран дальнего зарубежья (Евросоюз).",
    courier_eu_delay_amount_long:
      "5.2. Исполнитель в случае несвоевременной подачи автомашины под погрузку в определенный сто-ронами срок, несет перед Клиентом материальную ответственность в размере: - _____ (_______) тенге на территории стран дальнего зарубежья (Евросоюз).",
    customer_eu_delay_amount_long:
      "-  _____ () тенге на территории стран ближнего зарубежья (СНГ);",
    courier_declination_percent_long:
      "5.3. В случае отказа Исполнителя от согласованной Заявки, Исполнитель выплачивает Клиенту штрафную неустойку в размер ___ () % от общей стоимости фрахта.",
    penalty_percent_long:
      "5.4. За просрочку в оплате счетов Клиент уплачивает Исполнителю пеню в размере ____ % от общей суммы платежа за каждый просроченный день, но не более ____ % от суммы задолженности.",
    penalty_never_more_long:
      "5.4. За просрочку в оплате счетов Клиент уплачивает Исполнителю пеню в размере ____ % от общей суммы платежа за каждый просроченный день, но не более ____ % от суммы задолженности.",
    customer_declination_percent_long:
      "В случае отказа Клиента от согласованной перевозки на основании Заявки, Клиент выплачивает Исполнителю неустойку в размере ____ (_____) % от общей стоимости фрахта.",
    act_term_long:
      "5.14. Акт считается принятым и подписанным, если в течение ___ () рабочих дней не по-ступило письменной претензии о ненадлежащем исполнении услуг от Получателя груза",
    repeats_term_long:
      "6.2. Если такие обстоятельства будут продолжаться свыше ____ () календарных дней, то каждая из Сторон имеет право отказаться от дальнейшего исполнения обязательств по настоящему Договору, и в этом случае ни одна из Сторон не будет иметь право на возмещение другой Стороной возможных убытков.",
    force_major_term_long:
      "6.3. Сторона, для которой создалась невозможность исполнения обязательств по настоящему Дого-вору, обязана незамедлительно, но не позднее __ () календарных дней со дня наступле-ния форс-мажорных обстоятельств, известить другую Сторону.",
    claim_term_long:
      "7.2.	Все споры и разногласия, которые могут возникнуть из настоящего договора или в связи с ним, стороны будут стремиться урегулировать путем переговоров или в претензионном порядке. Срок рассмотрения претензий – _______ (_____) рабочий день от даты получения претензии.",
    resolve_term_long:
      "7.3.	В случае возникновения разногласий по настоящему Договору или по Дополнительным согла-шениям к нему Стороны предпримут все меры для урегулирования спорных вопросов путем проведения переговоров. В случае если путем переговоров и взаимных уступок единство мне-ний достигнуто не будет, спор подлежит разрешению в ______.",
    contract_term_long:
      "9.1. Настоящий договор вступает в силу с момента подписания и действует до _____________ года",
    contract_cancel_term_long:
      "9.4. Настоящий договор может быть расторгнут по письменному соглашению Сторон либо по ини-циативе любой из сторон без объяснения причин при условии письменного уведомления о сво-ем намерении не менее, чем за ____ () рабочих дней до планируемой даты рас-торжения договора.",
    paper_copy_packing: "Упаковочные листы",
    paper_copy_packing_no_logo: "Упаковочные листы (Без логотипа)",

    document_rwb: "ЖД накладная",
    rwb_doc_id: "ID документа",
    rwb_refdocid: "Номер документа",
    rwb_consignor_notice: "Уведомление грузоотправителя",
    rwb_places_quantity: "Количество мест",
    rwb_gross_weight_quantity: "Вес брутто",
    rwb_departure_mode_description: "Описание типа отправки",
    rwb_loader_mode_description: "Описание типа погрузки",
    rwb_additional_sheet_quantity: "Количество дополнительных листов",
    rwb_cargo_value: "Стоимость карго",
    rwb_customs_notice: "Уведомление таможни",
    rwb_weight_definition_mode_description: "Описание вида определения веса",
    rwb_carrier_notice: "Уведомление перевозчика",
    rwb_commerce_akt: "Коммерческий акт",
    rwb_prolongation: "Пролонгация",
    rwb_issue_marks: "Пометки о проблемах",
    rwb_amount60: "Сумма 60",
    rwb_amount61: "Сумма 61",
    rwb_amount62: "Сумма 62",
    rwb_amount63: "Сумма 63",
    rwb_calculation_notice: "Уведомление о расчетах",
    rwb_addition_payment: "Дополнительный платеж",

    rwb_consignor_option_notice: "Заметка грузоотправителя",
    rwb_consignor: "Грузоотправитель",
    rwb_consignee: "Грузополучатель",
    rwb_departure_station_code: "Код станции отправления",
    rwb_departure_station_name: "Название станции отправления",
    rwb_departure_rwcode: "ЖД-код пункта отправления",
    rwb_departure_rwname: "Название ЖД пункта отправления",
    rwb_departure_country: "Страна отправления",
    rwb_destination_rwcode: "ЖД-код пункта назначения",
    rwb_destination_station_code: "Код станции назначения",
    rwb_destination_rwand_station_name: "Название станции назначения",
    rwb_border_station_code: "Код пограничной станции",
    rwb_border_station_name: "Название пограничной станции",
    rwb_border_rwcode: "ЖД-код пограничной станции",
    rwb_border_rwname: "Названи ЖД пограничной станции",
    rwb_border_country: "Пограничная страна",
    rwb_contract_name: "Название контракта",
    rwb_contract_number: "Номер контракта",
    rwb_contract_date: "Дата контракта",
    rwb_flat_pallet_quantity: "Количество плоских паллет",
    rwb_box_pallet_quantity: "Количество коробочных паллет",
    rwb_pallet_exchange_mode: "Способ обмена паллет",
    rwb_work_tool_id: "ID рабочего инструмента",
    rwb_work_tool_container_description:
      "Описание контейнера рабочего инструмента",
    rwb_work_tool_railway_code: "Код рабочего инструмента",
    rwb_mark_sing: "Знак отметки",
    rwb_mark_kind: "Тип отметки",
    rwb_mark_result_control: "Контроль результата отметки",
    rwb_contract_carrier_name: "Название перевозчика по контракту",
    rwb_contract_carrier_time: "Время у перевозчика по контракту",
    rwb_contract_carrier_date: "Дата у перевозчика по контракту",
    rwb_contract_carrier_date_time_moscow:
      "Дата и время у перевозчика по контракту (МСК)",
    rwb_contract_carrier_date_time_moscow_date:
      "Дата у перевозчика по контракту (МСК)",
    rwb_contract_carrier_date_time_moscow_time:
      "Время у перевозчика по контракту (МСК)",
    rwb_contract_carrier_station_code: "Код станции перевозчика по контракту",
    rwb_contract_carrier_station_name:
      "Название станции перевозчика по контракту",
    rwb_contract_carrier_rw_name: "Название ЖД перевозчика по контракту",
    rwb_contract_carrier_country: "Страна перевозчика по контракту",
    rwb_arrival_carrier_name: "Название перевозчика прибытия",
    rwb_arrival_date: "Дата прибытия",
    rwb_arrival_time: "Время прибытия",
    rwb_arrival_date_time_moscow: "Дата и время прибытия (МСК)",
    rwb_arrival_date_time_moscow_date: "Дата прибытия (МСК)",
    rwb_arrival_date_time_moscow_time: "Время прибытия (МСК)",
    rwb_arrival_station_code: "Код станции прибытия",
    rwb_arrival_station_name: "Название станции прибытия",
    rwb_arrival_rw_name: "Название ЖД прибытия",
    rwb_arrival_rw_code: "ЖД-код прибытия",
    rwb_arrival_country: "Страна прибытия",
    rwb_good_container_indicator: "Контейнер",
    rwb_good_work_tool_description: "Рабочий инструмент",
    rwb_good_conductor_description: "Описание кондуктора",
    rwb_good_place_goods_quantity: "Количество",
    rwb_good_places_quantity: "Количество мест",
    rwb_good_gross_weight_quantity: "Вес брутто",
    rwb_good_places_description: "Описание мест",
    rwb_good_harmonized_range_goods: "Гармонизированный диапазон товаров",
    rwb_good_packing: "Упаковка",
    rwb_good_marking: "ТНВЭД",
    rwb_good_carriage_number: "Номер вагона",
    rwb_good_container_number: "Номер контейнера",
    rwb_good_goods_numeric: "Товары численные",
    rwb_good_customs_code: "Таможенный код",
    rwb_good_gtd_number: "Номер ГТД",
    rwb_good_gcost: "Стоимость",
    rwb_good_currency: "Валюта",
    rwb_good_mrn: "МРН",

    rwb_carrier_id: "ID",
    rwb_carrier_carrier_name: "Название перевозчика",
    rwb_carrier_carrier_code: "Код перевозчика",
    rwb_carrier_from_station_code: "Код пункта отправление",
    rwb_carrier_from_station_name: "Название пункта отправления",
    rwb_carrier_from_rw_name: "Название ЖД пункта отправления",
    rwb_carrier_from_country: "Страна отправления",
    rwb_carrier_to_station_code: "Код пункта назначения",
    rwb_carrier_to_station_name: "Название пункта назначения",
    rwb_carrier_to_rw_name: "Название ЖД пункт назначения",
    rwb_carrier_to_country: "Страна назначения",
    rwb_carrier_tech_station: "Техническая станция",

    rwb_carrier_tech_station_order_number: "Номер заказа",
    rwb_carrier_tech_station_tech_signs: "Тех. знаки",
    rwb_carrier_tech_station_station_code: "Код станции",
    rwb_carrier_tech_station_station_name: "Название станции",
    rwb_carrier_tech_station_rw_name: "Название ЖД",
    rwb_carrier_tech_station_country: "Страна",

    rwb_container_container_id: "ID контейнера",
    rwb_container_rw_code: "ЖД код",
    rwb_container_container_kind: "Тип контейнера",
    rwb_container_container_mode_desc: "Описание режима",
    rwb_container_container_capacity: "Ёмкость",
    rwb_container_container_capacity_unit_code: "Единица измерения",
    rwb_container_tare: "Тара",
    rwb_container_goods_weight: "Вес товаров",
    rwb_container_places_quentity: "Количество товаров",
    rwb_container_pocket_quentity: "Количество карманов",
    rwb_container_container_length: "Длина контейнера",

    rwb_auto_vin: "VIN",
    rwb_auto_transport_kind: "Тип ТС",
    rwb_auto_transport_mark: "Марка ТС",
    rwb_auto_transport_identifier: "ID ТС",
    rwb_auto_transport_nationality: "Страна ТС",
    rwb_auto_active_transport_identifier: "Идентификатор активного ТС",
    rwb_auto_transport_regnumber: "Регистрационный номер",
    rwb_auto_wagon_number: "Номер вагона",
    rwb_auto_tare: "Тара",
    rwb_auto_goods_weight: "Вес товаров",
    rwb_auto_places_quentity: "Количество товаров",
    rwb_auto_pocket_quentity: "Количество карманов",
    rwb_auto_container_length: "Длина контейнера",

    rwb_carriage_carriage_id: "ID вагона",
    rwb_carriage_rw_name: "Название ЖД",
    rwb_carriage_owner_name: "Владелец вагона",
    rwb_carriage_owner_type: "Тип владельца",
    rwb_carriage_rw_power: "Мощность ЖД",
    rwb_carriage_axis_quentity: "Количество осей",
    rwb_carriage_tare: "Тара",
    rwb_carriage_goods_weight: "Вес товаров",
    rwb_carriage_caliber: "Калибр",

    rwb_seal_seal_id: "ID",
    rwb_seal_seal_quentity: "Количество",
    rwb_seal_ident_kind: "Вид",
    rwb_seal_ident_desc: "Описание",

    rwb_stamp_carrier_name: "Название перевозчика",
    rwb_stamp_date: "Дата",
    rwb_stamp_time: "Время",
    rwb_stamp_date_time_moscow: "Дата и время (МСК)",
    rwb_stamp_date_time_moscow_date: "Дата (МСК)",
    rwb_stamp_date_time_moscow_time: "Время (МСК)",
    rwb_stamp_station_code: "Код станции",
    rwb_stamp_station_name: "Название станции",
    rwb_stamp_rw_name: "Название ЖД",
    rwb_stamp_rw_code: "ЖД код",
    rwb_stamp_country: "Страна",

    rwb_carrier_charge_order_no: "№ заказа",
    rwb_carrier_charge_carrier_code: "Код перевозчика",
    rwb_carrier_charge_from_station_code: "Код станции отправления",
    rwb_carrier_charge_from_station_name: "Название станции отправления",
    rwb_carrier_charge_from_rw_name: "Название ЖД отправления",
    rwb_carrier_charge_from_country: "Страна отправления",
    rwb_carrier_charge_to_station_code: "Код станции назначения",
    rwb_carrier_charge_to_station_name: "Название станции назначения",
    rwb_carrier_charge_to_rw_name: "Название ЖД назначения",
    rwb_carrier_charge_to_country: "Страна назначения",
    rwb_carrier_charge_distance: "Расстояние",
    rwb_carrier_charge_calc_weight: "Рассчетный вес",
    rwb_carrier_charge_extra_charge_code: "Код дополнительной платы",
    rwb_carrier_charge_extra_charge_name: "Название дополнительной платы",
    rwb_carrier_charge_extra_charge_amount: "Сумма дополнительной платы",
    rwb_carrier_charge_tarif_code: "Код тарифа",
    rwb_carrier_charge_calc_cargo_code: "Код рассчета карго",
    rwb_carrier_charge_currency_rate: "Курс валюты",
    rwb_carrier_charge_snd_tarif_currency_code: "Валюта тарифа СНД",
    rwb_carrier_charge_snd_payment_currency: "Валюта оплаты СНД",
    rwb_carrier_charge_rcv_tarif_currency_code: "Валюта тарифа РЦВ",
    rwb_carrier_charge_rcv_payment_currency: "Валюта оплаты РЦВ",
    rwb_carrier_charge_amount48: "Сумма 48",
    rwb_carrier_charge_amount49: "Сумма 49",
    rwb_carrier_charge_amount50: "Сумма 50",
    rwb_carrier_charge_amount51: "Сумма 51",
    rwb_carrier_charge_amount52: "Сумма 52",
    rwb_carrier_charge_amount53: "Сумма 53",
    rwb_carrier_charge_amount54: "Сумма 54",
    rwb_carrier_charge_amount55: "Сумма 55",
    rwb_carrier_charge_amount56: "Сумма 56",
    rwb_carrier_charge_amount57: "Сумма 57",
    rwb_carrier_charge_amount58: "Сумма 58",
    rwb_carrier_charge_amount59: "Сумма 59",

    rwb_paid_rw_code_paid_rw_name: "Название ЖД",
    rwb_paid_rw_code_paid_rw_code: "Код ЖД",
    rwb_paid_rw_code_paid_rw_short: "Короткое название ЖД",
    rwb_paid_rw_code_payer_code: "Код плательщика",
    rwb_paid_rw_code_payer_name: "Имя плательщика",
    rwb_paid_rw_code_from_rw_name: "ЖД отправления",
    rwb_paid_rw_code_from_country: "Стана отправления",

    rwb_consignor_doc_doc_name: "Название документа",
    rwb_consignor_doc_doc_number: "Номер документа",
    rwb_consignor_doc_doc_date: "Дата документа",
    rwb_consignor_doc_mode_code: "Код вида",
    rwb_consignor_doc_expiration_date: "Дата завершения действия",
    rwb_consignor_doc_release_customs: "Освобождение таможни",

    rwb_tab_data: "Данные",
    rwb_tab_goods: "Товары",
    rwb_tab_carrier: "Перевозчики",
    rwb_tab_carrier_charge: "Плата перевозчикам",
    rwb_tab_transport: "Транспорт",
    rwb_tab_container: "Контейнеры",
    rwb_tab_auto: "Авто",
    rwb_tab_carriage: "Вагоны",
    rwb_tab_seal_stamp: "Пломбы / Печати",
    rwb_tab_seal: "Пломбы",
    rwb_tab_stamps: "Печати",
    rwb_tab_paid_rw_code: "Оплаты ЖД",
    rwb_tab_consignor_doc: "Документы",

    save_place: "Обновить место",

    broker_contract: "Брокерский договор",
    broker_contract: "Брокерский договор (Без логотипа)",
    bc_number: "Номер",
    bc_city: "Город",
    bc_date: "Дата",
    bc_agreement: "Соглашение",
    bc_penalty_amount: "Сумма штрафа",
    bc_currency: "Валюта",
    bc_trial_city: "",
    bc_trial_language: "",

    insurance_policy_holder_name: `Наименование Страхователя: `,
    insurance_represented_by: `в лице (ФИО, должность):`,
    insurance_legal_address: `Юридический адрес:`,
    insurance_actual_address: `Фактический адрес:`,
    insurance_is_public_person: `Являетесь ли Вы иностранным публичным лицом (заполняется, физ. лицом или ИП)?`,
    insurance_insured_details: `Реквизиты Страхователя:`,
    insurance_insured_activity: `Вид деятельности Страхователя:`,
    insurance_beneficiary: `Выгодоприобретатель:`,
    insurance_beneficiary_details: `Реквизиты Выгодоприобретателя:`,
    insurance_shipping_name: `Наименование груза:`,
    insurance_package_info: `Сведения о виде упаковки и специальных защитных покрытий:`,
    insurance_cargo_cost: `Стоимость груза в одной упаковке и (или) в одном специальном покрытии:`,
    insurance_package_count: `Количество упаковок и (или) объектов в специальных защитных покрытиях:`,
    insurance_total_cost: `Общая стоимость партии груза:`,
    insurance_release_date: `Дата выпуска (производства) груза:`,
    insurance_containerization: `Контейнеризация: Полная?`,
    insurance_cargo_placing: `Опишите способ (метод) размещения груза и количество контейнеров:`,
    insurance_route: `Маршрут:`,
    insurance_security_measures: `Предпринятые меры безопасности:`,
    insurance_transport_means: `Перевозка грузов осуществляется посредством:`,
    insurance_transfer_points: `Пункты перегрузки, где планируется изменения типа транспортного средства:`,
    insurance_shipping_details: `Реквизиты перевозочных документов:`,
    insurance_risk: `Страхуемые риски:`,
    insurance_risk_a: `Условие А «С ответственностью за все риски»`,
    insurance_risk_b1: `Условие Б «С ответственностью за частную аварию»`,
    insurance_risk_b2: `Условие В «Без ответственности за повреждения»`,
    insurance_additional_conditions: `Дополнительные условия:`,
    insurance_max_value: `Максимальная страховая стоимость груза: `,
    insurance_max_value_a: `А) в одном контейнере`,
    insurance_max_value_b: `Б) на одном автотранспортном средстве`,
    insurance_max_value_c: `В) на одном морском судне`,
    insurance_max_value_d: `Г) на одном воздушном судне`,
    insurance_max_value_e: `Д) на одном железнодорожном вагоне`,
    insurance_max_value_f: `Е) в одном месте хранения`,
    insurance_insured_transport: `В страховую сумму включены транспортные и страховые расходы`,
    insurance_insured_transport_amount: `Страховая сумма (для партии груза):`,
    insurance_franchise: `Франшиза:`,
    insurance_shipment_date: `Дата отправки груза:`,
    insurance_shipment_duration: `Срок нахождения груза в пути`,
    insurance_insurance_stats: `Статистические данные:`,
    insurance_insurance_stats_desc: `Приведите статистические данные о каких-либо страховых случаях, происшедших с Вашими грузами за последние три года (стоимость груза, понесенные потери и др.)`,
    insurance_relevant_info: `Приведите любые сведения, имеющие на ваш взгляд, отношение к данному риску:`,
    insurance_other: `Прочее:`,
    document_insurance: "Страховка грузов",

    document_liability_insurance:
      "Cтрахование гражданско-правовой ответственности",
    document_sad: "ГТД",

    sad_line_1_title: "1. «Декларация»",
    sad_lina_a: "А",
    sad_line_3: "3. Формы",
    sad_line_3_value: "Номер листа",
    sad_line_4: "4. Отгрузочные спецификации",
    sad_line_5: "5. Всего товаров",
    sad_line_6: "6. Всего мест",
    sad_line_7: "7. Справочный номер",
    sad_line_2: "2. Отправитель",
    sad_line_8: "8. Получатель",
    sad_line_14: "14. Декларант",
    sad_line_20: "20. Условия поставки",
    sad_line_21: "21. ",
    sad_line_22: "22. Валюта и общая сумма по счету",
    sad_line_23: "23. Курс валют<br>&nbsp;",
    sad_line_24: "24. Характер сделки",
    sad_line_30: "30. Местонахождение товаров",
    sad_line_31: "31. Грузовые места и описание товаров",
    sad_line_32: "32. Товар",
    sad_line_33: "33. Код товара ",
    sad_line_36: "36. Преференции",
    sad_line_37: "37. Процедура",
    sad_line_39: "39. Квота",
    sad_line_40: "40. Общая декларация/Предшествующий документ",
    sad_line_44: "44. Дополнительная информация / Предоставленные документы",
    sad_line_45: "45. Таможенная стоимость",
    sad_line_46: "46. Статистическая стоимость",
    sad_line_47: "47. Исчисление платежей",
    sad_line_48: "48. Отсрочка платежей",
    sad_line_54: "54. Место и дата",
    sad_line_b: "B. Подробности подсчета",

    sad_g44_modal: "Заполнить строку",

    sad_show_more_products_button: "Показать все товары",
    sad_hide_more_products_button: "Скрыть товары",
    sad_product_line: "Данные о товаре",

    sad_line_adress: "Адрес отправителя",
    gtd_g011: "Краткое наим. заявляемой таможенной процедуры",
    gtd_g012: "Код заявляемой таможенной процедуры",
    gtd_g012_1: "Признак электронного документа",
    gtd_ga: "Внутренний номер<br>ДТ",
    gtd_g542: "Дата оформления<br>ГТД",
    gtd_gk_7: "Код особенности декларирования товаров",
    gtd_g022i: "Наименование отправителя",
    gtd_g023i: "Адрес отправителя",
    gtd_g0141: "БИН декларанта",
    gtd_g0142: "Наименование декларанта",
    gtd_g0143: "Адрес декларанта",
    gtd_g11: "11. Торгующая страна",
    gtd_g12: "12. Общая таможенная  стоимость",
    gtd_g15a: "Страна<br>отправления",
    gtd_g16a: "Страна происхождения",
    gtd_g17a: "Страна<br>назначения",
    gtd_g19: "Контейнер",
    gtd_g081: "БИН получателя",
    gtd_g082: "Наименование получателя",
    gtd_g083: "Адрес получателя",
    gtd_g20: "Количество",
    gtd_g20_incoterms: "Условия<br>поставки",
    gtd_g20_place: "Место",
    gtd_g22_curr: "Валюта",
    gtd_gtd_total_price: "Общая фактурная стоимость",
    gtd_g23: "Курс валюты",
    gtd_g241: "Код характера<br>сделки",
    gtd_g242: "Код вида расчета<br>по сделке",
    gtd_g30_place: "Код местонахождения товаров",
    gtd_g30_twh_code: "Классификатор таможенных органов ",

    gtd_g31_good_name: "Наименование товара",
    gtd_g31_good_rec: "Сведения о товаре (кол-во записей)",
    gtd_g31_good_data: "Сведения о товаре (см. на обороте)",
    gtd_g31_cti: "кол-во товара<br>по ТТН",
    gtd_gr31_measure: "Ед. изм.",
    gtd_gr31_place_quant: "Количество мест",
    gtd_g31_place_type: "Вид грузовых мест",
    gtd_g31_container_quant: "Кол-во<br>контейнеров",
    gtd_g31_container_num: "Номер<br>контейнера",
    gtd_g31_proc_conditions: "Условия переработки",
    gtd_g31_mark: "Признак ПВ",
    gtd_g31_mark_pv: "ПВ",
    gtd_g31_check_mark: "Номер контрольных знаков",

    gtd_g32_good_num: "Номер товара",
    gtd_g33_tnved: "Код ТН ВЭД",

    gtd_g36_1: "Таможенные сборы",
    gtd_g36_2: "Таможенные платежи",
    gtd_g36_3: "Акцизы",
    gtd_g36_4: "НДС",
    gtd_g37_cust_rej_code: "Таможенный режим",
    gtd_g37_good_movement_features_code: "Особенности перемещения товаров",

    gtd_g39_quota: "Квота",
    gtd_g39_quota_measure: "Ед. изм.<br>квоты",
    gtd_g39_quota_rest: "Остаток квоты",
    gtd_g39_quota_rest_measure: "Ед.изм.<br>остатка квоты",

    gtd_g40_doc_code: "Код документа",
    gtd_g40_doc_num: "Номер<br>документа",
    gtd_g40_doc_date: "Дата<br>документа",
    gtd_g40_weight_netto: "Вес нетто",
    gtd_g40_quantity: "Количество",
    gtd_g40_measure: "Единица<br>измерения",
    gtd_g40_hs_code: "ТН ВЭД",
    gtd_g40_cost: "Стоимость",
    gtd_g40_rate_a: "Ставка",
    gtd_g40_vat: "НДС",

    gtd_g41: "41. Дополнит. единицы",
    gtd_g42: "42. Цена товара",
    gtd_g43: "43. Код МОС",

    gtd_g44_g32_good_num: "Номер товара",
    gtd_g44_g44_doc_type_code: "Код документа",
    gtd_g44_serial_doc_num: "Порядковый номер документа",
    gtd_g44_doc_num: "Номер документа",
    gtd_g44_doc_date: "Дата документа",
    gtd_g44_doc_reg_nun: "Регистрационная дата документа",
    gtd_g44_doc_begin_date: "Дата начала документа",
    gtd_g44_doc_end_date: "Дата окончания документа",
    gtd_g44_doc_sign: "Признак предоставления документа",
    gtd_g44_doc_sign_0: "документ не предоставлен при подаче ДТ",
    gtd_g44_doc_sign_1: "документ  предоставлен при подаче ДТ",
    gtd_g44_doc_sign_2:
      "документ не предоставлен (документ предоставлялся ранее)",
    gtd_g44_doc_sign_3:
      "документ предоставлен (будет предоставлен) после выпуска товаров",

    gtd_g45_customs_value: "Таможенная стоимость",
    gtd_g46_stat_value: "Статистическая стоимость",

    gtd_g47_cust_pay_code: "Код вида платежа",
    gtd_g47_accrual_basis: "Основа начисления",
    gtd_g47_bet_size: "Размер ставки",
    gtd_g47_bet_measure: "Ед. изм. ставки",
    gtd_g47_bet_measure_currency: "Валюта",
    gtd_g47_payment_sum: "Сумма платежа",
    gtd_g47_pcf_cofe: "Валюта платежа",

    gtd_g48_cust_pay_code: "Код вида платежа",
    gtd_g48_doc_number: "Номер документа",
    gtd_g48_doc_date: "Дата документа",
    gtd_g48_payment_date: "Дата оплаты",

    gtd_g541_doc_num: "Номер документа",
    gtd_g541_doc_num_desc:
      "номер документа, свидетельствующего о включении лица в Реестр таможенных представителей, если декларирование товаров производится таможенным представителем",
    gtd_g541_doc_date: "Дата документа",
    gtd_g541_doc_date_desc:
      "дата документа, свидетельствующего о включении лица в Реестр таможенных представителей, если декларирование товаров производится таможенным представителем",
    gtd_g541_contract_num: "Номер договора",
    gtd_g541_contract_num_desc:
      "номер договора таможенного представителя с декларантом",
    gtd_g541_contract_date: "Дата договора",
    gtd_g541_contract_date_desc:
      "дата договора таможенного представителя с декларантом",
    gtd_g542_surname: "Фамилия",
    gtd_g542_name: "Имя",
    gtd_g542_midlname: "Отчество",
    gtd_g542_position: "Должность",
    gtd_g542_phone: "Телефон",
    gtd_g542_cert: "НКА",
    gtd_g542_cert_desc: "Номер классификационного аттестата",
    gtd_g542_doctype: "Вид документа",
    gtd_g542_pass_num: "Номер паспорта",
    gtd_g542_pass_date: "Дата выдачи паспорта",
    gtd_g543_powers_doc_num: "Номер документа",
    gtd_g543_powers_doc_num_desc: "Номер документа удостоверяющего полномочия",
    gtd_g543_powers_doc_date: "Дата документа",
    gtd_g543_powers_doc_date_desc: "Дата документа удостоверяющего полномочия",
    gtd_g543_powers_doc_date_end: "Дата окончания полномочий",

    gtd_gb_g47_cust_payment: "Вид платежа",
    gtd_gb_payment_sum: "Сумма платежа",
    gtd_gb_curr_code: "Код валюты",
    gtd_gb_payment_order_num: "Номер платежного поручения",
    gtd_gb_payment_order_date: "Дата платежного поручения",
    gtd_gb_payment_methods: "Способ платежа",
    gtd_gb_company_id: "БИН",

    gtd_g041: "Общее кол-во спецификаций",
    gtd_g042: "Общее кол-во листов спецификаций",
    gtd_g05: "Всего товаров",
    gtd_g06: "Всего мест",

    add_address: "Задать адрес",

    address_postcode: "Индекс",
    address_region: "Область",
    address_country: "Страна",
    address_city: "Город",
    address_town: "Населенный пункт",
    address_street: "Улица",
    address_number: "Номер дома",
    address_office: "Номер помещения",
    address_type_none: "Выберите код вида связи",
    address_type_em: "e-mail",
    address_type_fx: "телефакс",
    address_type_te: "телефон",
    address_type_tg: "телеграф",
    address_type_tl: "телекс",
    address_code_of_type: "Код вида связи",
    address_typed_field_em: "E-mail",
    address_typed_field_fx: "Телефакс",
    address_typed_field_te: "Телефон",
    address_typed_field_tg: "Телеграф",
    address_typed_field_tl: "Телекс",

    liability_insurance_policy_holder: "Страхователь",

    liability_insurance_policy_holder_name: "Наименование",
    liability_insurance_policy_holder_address: "Местонахождения",
    liability_insurance_policy_holder_phone: "Номер телефона",
    liability_insurance_policy_holder_email: "E-mail",
    liability_insurance_policy_holder_bank: "Банковские реквизиты",
    liability_insurance_policy_holder_bin: " БИН",
    liability_insurance_policy_holder_bik: "БИК",
    liability_insurance_is_resident: "Признак резидентства",
    liability_insurance_license_no: "№ лицензии",
    liability_insurance_economy_sector: "Сектор экономики",
    liability_insurance_activity_type: "Вид экономической деятельности",
    liability_insurance_object_teritory: "Территориальный признак объекта",
    liability_insurance_insured_details: "Застрахованный",

    liability_insurance_insured_sum:
      "Страховая сумма по рискам причинение вреда",

    liability_insurance_life_insured_sum: "Жизни и здоровью третьих лиц",
    liability_insurance_property_insured_sum: "Имуществу третьих лиц",
    liability_insurance_cargo_insured_sum: "Собственнику груза",

    liability_insurance_insured_limit: "Лимит ответственности",

    liability_insurance_total_insured_sum:
      "Совокупный лимит ответственности по всем рискам",
    liability_insurance_insurance_term: "Срок страхования",
    liability_insurance_insurance_teritory: "Территория страхования",
    liability_insurance_transport_type: "Вид транспорта",

    liability_insurance_transport_h:
      "Экспедирование грузов производится с использованием всех видов транспорта",

    liability_insurance_transport_model: "модель",
    liability_insurance_transport_name: "название",
    liability_insurance_transport_reg_number: "регистрационный номер",
    liability_insurance_transport_body_number: "номер кузова",
    liability_insurance_transport_release_date: "год выпуска",
    liability_insurance_vehicles_number: "Количество транспортных средств",
    liability_insurance_previous_insurance_info:
      "Информация о предыдущем договоре страхования ответственности",
    liability_insurance_valid_contracts_info:
      "Информация о действующих договорах добровольного страхования гражданско-правовой ответственности",

    liability_insurance_insurer: "СВЕДЕНИЯ О ПРЕДСТАВИТЕЛЕ СТРАХОВЩИКА",

    liability_insurance_insurer_name:
      "Ф.И.О., должность, наименование юридического лица (агента)",
    liability_insurance_insurer_address: "Адрес, местонахождение",
    liability_insurance_insurer_phone: "Телефон (рабочий и сотовый)",
    liability_insurance_insurer_commission:
      "Комиссионное вознаграждение страхового агента (наличие либо отсутствие)",
    liability_insurance_insurer_contact_name:
      "ФИО, должность, ФИО контактного лица страховщика",
    liability_insurance_insurer_contact_address:
      "Адрес контактного лица страховщика, местонахождение",
    liability_insurance_insurer_contact_phone:
      "Телефон контактного лица страховщика (рабочий и сотовый)",
    liability_insurance_insurance_date: "Дата принятия заявления-анкеты",
    liability_insurance_franchise: "Франшиза",
    liability_insurance_payout_term: "Порядок и сроки уплаты страховой премии",
    broker_select_radio_btn: "Выбрать",

    upload_ktzh_answer: "Загрузить ответ КТЖ",
    show_ktzh_request: "Просмотреть запрос",
    show_ktzh_answer: "Просмотреть ответ",

    send_insurance_request: "Отправить заявку страховщику",
    download_insurance_certificate: "Скачать страховой сертификат",
    contract_history_data: "Исторические данные",
    pdf_aml: "Проверка компании",

    pdf_aml_no_logo: "Проверка компании (Без логотипа)",

    offer_target_name: "Предложение кому",
    pdf_liability_insurance: "Страховка ответственности",
    pdf_liability_insurance_no_logo: "Страховка ответственности (Без логотипа)",
    check_contragent_price_alert: "Данная услуга платная. Стоимость  ",
    kyc_service_message:
      "Сервис Проверки Контрагента предоставляет информацию, полученную из официальных ресурсов и средств массовой информации. Система дает возможность Пользователю получать изменения информации о нужном объекте в режиме мониторинга его статуса. Информация носит справочный характер. Платформа АТТИС не несет ответственность за последствия при использовании полученных сведений. Решение по дальнейшим действиям, связанным с результатами поиска, берет на себя Пользователь.",
    excel_import_gooods_label: "импорт товаров из Excel",

    ktg_attorney_principal: "Доверитель",
    ktg_attorney_principal_name: "Название компании",
    ktg_attorney_principal_reg_number: "Регистрационный номер",
    ktg_attorney_principal_code: "БИН",
    ktg_attorney_principal_address: "Адрес",

    ktg_attorney_representative: "Представитель",
    ktg_representative_full_name: "ФИО",
    ktg_representative_job_title: "Должность",
    ktg_acting_basis: "Действующая основа",
    ktg_place: "Место документа",
    ktg_attorney_issued_before: "Доверенность выдана до",

    ktg_attorney_wagon_id: "No",
    ktg_attorney_wagon_number: "No вагона",
    ktg_attorney_wagons_list: "Список вагонов-самосвалов",

    ktg_attorney_add_wagon: "Добавить вагон",
    ktg_wagon_number: "Номер вагона",
    ktg_act_basis_placeholder: "Устава",

    pdf_insurance: "Страховка груза",
    pdf_insurance_no_logo: "Страховка груза (Без логотипа)",
    insurance_pdf_title: "ЗАЯВЛЕНИЕ – АНКЕТА",
    insurance_pdf_subtitle: "на заключение договора страхования грузов",
    insurance_pdf_subsubtitle:
      "Пожалуйста, визируйте любые исправления и дополнения. Заполняйте заглавными печатными буквами.",
    insurance_pdf_footer_title: "Декларация Страхователя:",
    insurance_pdf_p_1:
      "Подписанием настоящего заявления-анкеты, а также договора страхования Страхователь дает Страховщику (в том числе родительской организации Страховщика и дочерним компаниям родительской организации Страховщика) свое согласие на сбор и обработку персональных данных, согласно Закону РК «О персональных данных и их защите», включая накопление, использование, изменение (дополнение, обновление), хранение, распространение, обезличивание, блокирование, уничтожение персональных данных, а также свое согласие на осуществление коммуникаций со Страхователем, включая получение информационной рассылки. Согласие считается действительным, если не будет отозвано по письменному требованию Страхователя.",
    insurance_pdf_p_2:
      "Страховщик вправе проверить достоверность предоставленных персональных данных, в том числе с использованием других доступных источников. ",
    insurance_pdf_p_3:
      "Настоящим заявляю, что сведения, указанные в Заявлении-анкете верны, и не содержат ложной информации или каких-либо неточностей и вся существенная информация в соответствии с требованием Страховщика мною предоставлена. Мне также известно о последствиях за сообщение ложных сведений об объекте страхования, страховом риске, страховом случае и его последствиях. ",
    insurance_pdf_p_4:
      "Также подтверждаю, что данное Заявление-анкета будет служить основанием для заключения Договора страхования. ",
    insurance_pdf_p_5:
      "С Правилами добровольного страхования грузов АО «Страховая компания «{{company}}» ознакомлен/копию получил.",
    insurance_pdf_p_6_b: "Уведомление.",
    insurance_pdf_p_6:
      "Страховщик оставляет за собой право расторгнуть Договор страхования и/или отказать в осуществлении страховой выплаты в случае, если Страхователь настоящим привел ложные сведения либо утаил какую бы то ни было существенную информацию в целях заключения Договора страхования, а также по основаниям, предусмотренным Законом РК «О противодействии легализации (отмыванию) доходов, полученных преступным путем, и финансированию терроризма».",
    insurance_pdf_insurer: "Страхователь",
    insurance_pdf_signature: "Подпись",
    insurance_pdf_date: "Дата",
    insurance_pdf_footer1: "Ставка страхового платежа процентов",
    insurance_pdf_footer2: "Страховой платеж исчислен в размере",
    insurance_pdf_footer3: "Представитель АО «Страховая компания",
    insurance_pdf_0: "Наименование Страхователя:",
    insurance_pdf_0_1: "в лице (ФИО, должность):",
    insurance_pdf_0_2: "Юридический адрес:",
    insurance_pdf_0_3: "Фактический адрес:",
    insurance_pdf_0_4:
      "Являетесь ли Вы иностранным публичным лицом (заполняется, физ. лицом или ИП)?",
    insurance_pdf_1: "Реквизиты Страхователя:",
    insurance_pdf_2: "Вид деятельности Страхователя:",
    insurance_pdf_3: "Выгодоприобретатель:",
    insurance_pdf_4: "Реквизиты Выгодоприобретателя:",
    insurance_pdf_5: "Наименование груза:",
    insurance_pdf_6:
      "Сведения о виде упаковки и специальных защитных покрытий:",
    insurance_pdf_7:
      "Стоимость груза в одной упаковке и (или) в одном специальном покрытии:",
    insurance_pdf_8:
      "Количество упаковок и (или) объектов в специальных защитных покрытиях:",
    insurance_pdf_9: "Общая стоимость партии груза:",
    insurance_pdf_10: "Дата выпуска (производства) груза:",
    insurance_pdf_11: "Контейнеризация: Полная?",
    insurance_pdf_12:
      "Опишите способ (метод) размещения груза и количество контейнеров (вагонов, прицепов, навалом, насыпью и т.д.):",
    insurance_pdf_13:
      "Маршрут: (укажите сведения о точном маршруте перевозки, а также пункты перегрузки и перевалки, включая склад отправления и склад назначения):",
    insurance_pdf_14: "Предпринятые меры безопасности:",
    insurance_pdf_15:
      "Перевозка грузов осуществляется посредством (вид транспорта):",
    insurance_pdf_16:
      "Пункты перегрузки, где планируется изменения типа транспортного средства (также укажите все склады временного хранения):",
    insurance_pdf_17: "Реквизиты перевозочных документов:",
    insurance_pdf_18: "Страхуемые риски:",
    insurance_pdf_19: "Условие А «С ответственностью за все риски»",
    insurance_pdf_20: "Условие Б «С ответственностью за частную аварию»",
    insurance_pdf_21: "Условие В «Без ответственности за повреждения»",
    insurance_pdf_22: "Дополнительные условия:",
    insurance_pdf_23: "Максимальная страховая стоимость груза:",
    insurance_pdf_24: "А) в одном контейнере",
    insurance_pdf_25: "Б) на одном автотранспортном средстве",
    insurance_pdf_26: "В) на одном морском судне",
    insurance_pdf_27: "Г) на одном воздушном судне",
    insurance_pdf_28: "Д) на одном железнодорожном вагоне",
    insurance_pdf_29: "Е) в одном месте хранения",
    insurance_pdf_30:
      "В страховую сумму включены транспортные и страховые расходы",
    insurance_pdf_31: "Если ДА, укажите сумму:",
    insurance_pdf_32: "Страховая сумма (для партии груза):",
    insurance_pdf_33: "Франшиза:",
    insurance_pdf_34: "Дата отправки груза:",
    insurance_pdf_35: "Срок нахождения груза в пути",
    insurance_pdf_36:
      "Приведите статистические данные о каких-либо страховых случаях, происшедших с Вашими грузами за последние три года (стоимость груза, понесенные потери и др.):",
    insurance_pdf_37:
      "Приведите любые сведения, имеющие на ваш взгляд, отношение к данному риску:",
    insurance_pdf_38: "Прочее:",

    document_specification: "Спецификация",
    document_specification_no_logo: "Спецификация (Без логотипа)",
    specifications_spec_number: "Номер спецификации",
    specifications_spec_place: "Место заключения",
    specifications_spec_date: "Дата подписания",
    spec_good_name: "Коммерческое наименование товара",
    spec_good_orign: "Страна происхождения товара",
    spec_good_manufacturer: "Наименование производителя товара",
    spec_good_model: "Модель товара",
    spec_good_mark: "Марка товара",
    spec_good_serialnum: "Серийный номер товара",
    spec_good_man_year: "Год производства",
    spec_good_curr: "Валюта",

    form_m: "Форма M",
    invoice: "Инвойс",
    cmr: "CMR",
    specification: "Спецификация",
    fm1: "ФМ-1",
    epi: "ЭПИ",
    awb: "АВБ",
    rwb: "ЖД",
    insurance: "Страховка груза",
    "liability-insurance": "Страховка ответсвенности",
    packaging: "Упаковка",
    sad: "ГТД",
    ktg_attorney: "КТЖ",
    download_pdf: "Скачать PDF отчет",
    download_pdf_no_logo: "Скачать PDF отчет (Без логотипа)",
  },
  admin: {
    serviceprices: "Прейскурант на услуги",
    service_code: "Код",
    service_name: "Название сервиса",
    service_price: "Цена",
    actions: "Действия",
    add_service: "Добавить сервис",
    edit_service: "Редактировать сервис",
    service_price_privileged: "Цена с привилегией",

    active: "Регистрация",
    registrations: "Регистрации",
    users: "Пользователи",
    logs: "Логи",
    operations: "Операции",
    index: "Панель администратора",
    lock_user: "Отключить",
    unlock_user: "Включить",
    oper_code: "Операция",
    log_source_user_id: "Пользователь инициатор события",
    log_target_user_id: "Пользователь цель события",
    doc_id: "Документ",
    stop: "Останов",
    start: "Запуск",
    request_date: "Дата заявки",
    attis_status: "ATTIS в режиме",
    stop_confirmation: "Внимание ! Система ATTIS будет остановлена",
    start_confirmation:
      "Внимание ! Система ATTIS будет переведена в рабочее состояние",
    registration_approved: "Заявка одобрена",
    registration_declined: "Заявка отклонена",
    registration_declination_placeholder: "Введите причину отклонения заявки",
    log_date: "Дата операции",
    is_error: "Ошибка",
    data: "Данные",

    "toc-offers": "Оферты",
    "toc-offer-active": "Активна",
    "toc-offer-inactive": "Неавктивна",
    download: "Скачать",
    offer_file: "Файл оферты",
    offer_diff: "Изменения в оферте",
    offer_start_date: "Дата начала действия",
    offer_end_date: "Дата окончания действия",
    offer_status: "Статус",

    sad_builder_type: "Тип документа",
    "ca-history": "История Comply Advantage",

    ca_history_date_from: "Дата с",
    ca_history_date_to: "Дата до",
    ca_history_organisation: "Организация",
    search_query: "Запрос",
    search_date: "Дата",
    ca_search_id: "Id",
    history_pdf: "Ответ CA",

    news: "Новости",
    news_title: "Заголовок",
    news_date: "Дата",
    news_actions: "",

    requests_log_company_name: "Организация",
    requests_log_search_keyword: "Поиск по ключевому слову",
    requests_log_has_results: "есть результаты",
    requests_log_search_type: "Запрос",
    requests_log_date: "Дата запроса",
    requests_log_time: "Время запроса",

    request_log_api: {
      row_no: "№ п/п",
      company_name: "Наименование Предприятия",
      company_code: "Регистрационный номер или USCC",
      request_start_time: "Дата заявки",
      request_end_time: "Дата выполнения заявки",
      request_price: "Стоимость, тенге"
    },
    translations: {
      translations: "Переводы",
      service_code: "Код услуги",
      category: "Категория",
      field_name_cn: "Имя поля (CN)",
      field_data_cn: "Данные поля (CN)",
      field_name_ru: "Имя поля (RU)",
      field_data_ru: "Данные поля (RU)",
      field_name_en: "Имя поля (EN)",
      field_data_en: "Данные поля (EN)",
      error_json:
        "Ошибка: ответ серверной части не подлежит сериализации в формате JSON.",
      add: "Добавить",
      edit: "Редактировать",
      delete: "Удалить",
      add_translation: "Добавить перевод",
      edit_translation: "Редактировать перевод",
    },
  },
  help: {
    registration: "Регистрация пользователя",
    document: "Документы",
    transport_offer: "Заявка на перевозку",
    contract_offer: "Контракт Предложения",
    contract_signature: "Контракт подписание",
    new_contract: "Контракт заявка",
    contract_add_contragent: "Контракт добавление контрагента",
    pa_personal: "Личный кабинет",
    pa_legal: "Личный кабинет ЮЛ",
    contragent_check: "Поиск и проверка контрагента",
    export_import: "Экспорт импорт",
    epi: "ЭПИ",
    ca: "Проверить партнера",
    "contract-new": "Создать контракт",
    "china-search": "Поиск партнёра",
  },
  navigation: {
    never_show_again: "Больше не показывать",
    registration: "Сначала нужно пройти регистрацию",
    register: "Зарегистрироваться",
    auth: "Теперь нужно пройти авторизацию",
    login: "Войти",
    search_partner: "Поиск партнера",
    find_a_partner: "Нужно найти партнера по выбранным параметрам",
    check_partner: "Проверить партнера",
    find_a_partner_message:
      'Для поиска партнера, выберите необходимые параметры и нажмите "Искать"',
    find_a_partner_message_result:
      'Нужно отметить галочкой того партнера, которого вы хотите проверить и нажать "проверить"',
    next_create_contract:
      'После проверки партнера нужно создать контракт. Для этого перейдите в раздел "Контракты"',
    create_contract: "Создать контракт",
    to_create_contract_message:
      'Для создания контракта нажмите кнопку "Создать контракт"',
    save_contract_message:
      'После заполнения контракта - сохраните его нажав на "Сохранить контракт"',
    save_contract: "Сохранить контракт",
    open_contract_message: "Контракт создан, откройте его",
    open_contract: "Открыть контракт",
    sign_contract_message: "Теперь контракт нужно подписать",
    sign_contract: "Подписать контракт",
    contract_offers_message:
      "Создайте или просмотрите предложения по контракту",
    create_offer: "Открыть",
    contract_couriers_message:
      "Создайте или просмотрите предложения по перевозке",
    contract_brokers_message: "Создайте или просмотрите предложения брокеров",
    contract_docs_message:
      "Создайте Инвойс, Упаковочный лист, Транспортные накладные, Страховку, затем перейдите на вкладку ЭКСИМ",
    create_documents: "Создать документы",
    contract_docs_invoice_message: "Начните создавать документы с инвойса",
    create_invoice: "Создать Инвойс",
    contract_docs_packing_list_message: "Теперь нужно создать упаковочный лист",
    create_packing_list: "Создать Упаковочный лист",
    contract_docs_cmr_message: "Теперь создайте CMR",
    create_cmr: "Создать CMR",
    contract_docs_insurance_message: "Теперь нужно создать страховку груза",
    create_insurance: "Создать страховку",
    contract_docs_liability_insurance_message:
      "Теперь создайте страховку гражданско-правовой ответственности",
    create_liability_insurance: "Создать страховку",
    contract_docs_exim_message: "Теперь перейдите к ЭксИм",
    create_exim_insurance: "Перейти",
  },
  twh: {
    new: "Добавить уведомление",
    edit: "Изменить уведомление",
    docid: "Номер документа",
    transportnum: "Номер ТС",
    carriername: "Перевозчик",
    trailernum: "Номер прицепа",
    placedate: "Дата размещения",
    noticedate: "Дата уведомления",
    specialist: "Специалист",
    dateout: "Дата выбытия",
    notifcuststatus: "Статус таможни",
    pr_vygr: "Признак выгрузки",
    notifnum: "Идентификатор",
    custmark: "Примечания",

    notifnumint: "Номер уведомления",
    blankinnum: "Номер бланка",
    cbxnum: "Номер СВХ",
    transport: "Транспортное средство",
    transtype: "Тип ТС",
    regcountry: "Страна регистрации",
    transportmark: "Марка ТС",
    carrierrnn: "Перевозчик РНН (УНП?)",

    cbxnum2: "Номер приказа?",
    driver: "Водитель (Заинтересованное лицо?)",
    drivername: "ФИО",
    driverpasspnum: "Номер документа",
    driverpasspdate: "Дата выдачи документа",
    driverpasspplace: "Место выдачи документа",
    goodsforbidden: "Запрещенный груз",
    regnum: "Регистрационный номер",
    custofficerstampnum: "ЛНП",
    custofficername: "Имя таможенника",
    shassi: "Шасси",
    driverdocname: "Тип документа",
    dcodepto: "Код ПТО",
    namepto: "Наименование ПТО",
    carrier: "Грузоперевозчик",
    carriername2: "Наименование",
    carrieraddress: "Адрес",
    regcountrycode: "Код страны регистрации",
    purpose: "Цель размещения",
    createyear: "Год",
    trisleave: "Автомобиль выбыл",
    carrierstamp1: "Примечание 1",
    carrierstamp2: "Примечание 2",
    placename: "Место размещения",
    registration_twh: "Регистрация на СВХ",
    registration_pto: "Регистрация на ПТО",
    check_results: "Результаты осмотра",
    damage: "Наличие повреждений гр. отд. ТС",
    breachiden: "Нарушены средства идентификации",
    removeiden: "Сняты средства идентификации",
    imposiden: "Наложены средства идентификации",
    bi_amount: "Сумма",
    bi_num: "Кол-во",
    ri_amount: "Сумма",
    ri_num: "Кол-во",
    ii_amount: "Сумма",
    ii_num: "Кол-во",
    driveroffice: "Офис водителя",
    damcomment: "Комментарий по повреждениям",
    newdoc: "Новый документ",
    isnew: "Новый документ",
    drivertype: "Тип",
    docscurrencycode: "Валюта",
    transcategorycode: "Вид",
    twhplace: "Место размещения",
    notifcuststatusdate: "Дата комментария",

    custdocs: "Таможенные документы",
    docs: "Документы",
    permdocs: "Разрешительные документы",
    recipients: "Получатели",
    recordid: "ID",
    custofficername: "Инспектор",
    ny: "Год",
    nj: "Журнал",
    nn: "Документ",
    docdkd: "ДКД",
    doccomment: "Комментарий",
    docfirm: "Организация",
    // indv: '',
    sendername: "Отправителя",
    docdatecreate: "Создан",
    doctype: "Тип",
    docnum: "Номер",
    docdate: "Дата",
    addpermfirm: "Компания",
    docnetto: "Нетто",
    docbrutto: "Брутто",
    doccurrencycode: "Валюта",
    docprice: "Стоимость",
    linenum: "Запись",
    recipientrnn: "БИН",
    recipientname: "ФИО",
    recipientaddress: "Адрес",
    // indf: '',

    confirm_removal: "Вы уверены, что хотите удалить это уведомление?",
  },
  validation: {
    PA1_Addr_W_001_name: "Наличие юридического адреса",
    PA1_Addr_W_001_message: "Почтовый индекс не указан",

    PA1_Addr_W_002_name: "Наличие юридического адреса",
    PA1_Addr_W_002_message: "Страна резидентства не указана",

    PA1_Addr_W_003_name: "Наличие юридического адреса",
    PA1_Addr_W_003_message:
      "Регион (Наименование единицы административно-территориального деления первого уровня) не указан",

    PA1_Addr_W_004_name: "Наличие юридического адреса",
    PA1_Addr_W_004_message: "Район не указан",

    PA1_Addr_W_005_name: "Наличие юридического адреса",
    PA1_Addr_W_005_message: "Город не указан",

    PA1_Addr_W_006_name: "Наличие юридического адреса",
    PA1_Addr_W_006_message: "Населенный пункт не указан",

    PA1_Addr_W_007_name: "Наличие юридического адреса",
    PA1_Addr_W_007_message: "Улица не указана",

    PA1_Addr_W_008_name: "Наличие юридического адреса",
    PA1_Addr_W_008_message: "Обозначение дома, корпуса, строения не указано",

    PA1_Addr_W_009_name: "Наличие юридического адреса",
    PA1_Addr_W_009_message: "Обозначение офиса или квартиры не указано",

    PA1_Fndr_W_001_name: "Учредители",
    PA1_Fndr_W_001_message: "Нет данных об учредителях",

    PA1_Acc_W_002_name: "Счета",
    PA1_Acc_W_002_message: "Нет данных о банковских счетах",

    PA1_Main_E_001_name: "Наименование",
    PA1_Main_E_001_message: "Нет наименования компании",

    PA1_Main_W_002_name: "ОКЭД",
    PA1_Main_W_002_message: "Не указан ОКЭД",

    PA1_Main_W_003_name: "Тип организации",
    PA1_Main_W_003_message: "Не указан тип организации",

    PA1_Main_W_004_name: "Контакты",
    PA1_Main_W_004_message: "Не указаны контакты компании",

    PA1_Main_W_005_name: "Страна регистрации",
    PA1_Main_W_005_message: "Не указана страна резидентства",

    PA2_Main_W_001_name: "Резидентство",
    PA2_Main_W_001_message: "Не указана страна резидентства",

    PA2_Main_W_002_name: "ЭЦП",
    PA2_Main_W_002_message: "ЭЦП не загружена",

    CN1_Main_W_001_name: "Тема",
    CN1_Main_W_001_message: "Не указана тема контракта",

    CN1_Main_W_002_name: "Описание",
    CN1_Main_W_002_message: "Не указано описание контракта",

    CN1_Main_W_003_name: "Товары",
    CN1_Main_W_003_message: "Не указаны товары в контракте",

    CN1_Main_W_004_name: "Покупатель",
    CN1_Main_W_004_message: "Не указан контрагент по контракту",

    Inv_Main_E001_name: "Дата инвойса",
    Inv_Main_E001_message: "Не указана дата инвойса",

    Inv_Main_E002_name: "Валюта инвойса",
    Inv_Main_E002_message: "Не указана валюта инвойса",

    Inv_Main_W003_name: "Валюта инвойса и контракта",
    Inv_Main_W003_message: "Валюта инвойса и контракта не совпадают",

    Inv_Main_W004_name: "Инвойс вес брутто",
    Inv_Main_W004_message: "Не указан вес брутто",

    Inv_Main_W005_name: "Инвойс вес нетто",
    Inv_Main_W005_message: "Не указан вес нетто",

    Inv_Main_W006_name: "Инвойс общая стоимость",
    Inv_Main_W006_message: "Не указана общая стоимость",

    Inv_Goods_E001_name:
      "Стоимость контракта и сумма общих стоимостей инвойсов",
    Inv_Goods_E001_message: "Стоимость контракта и инвойсов не совпадают",

    Inv_Goods_E002_name:
      "Коммерческое наименование товаров инвойса и контракта",
    Inv_Goods_E002_message:
      " Коммерческое наименование товаров контракта и инвойсов не совпадают",

    Inv_Goods_E003_name: "Код ТН ВЭД товаров инвойса и контракта",
    Inv_Goods_E003_message:
      "Коды ТН ВЭД товаров контракта и инвойсов не совпадают",

    Inv_Goods_E004_name: "Количество товаров инвойса и контракта",
    Inv_Goods_E004_message:
      "Количество товаров контракта и инвойсов не совпадают",

    Inv_Goods_E005_name: "Цены товаров инвойса и контракта",
    Inv_Goods_E005_message: "Цены товаров контракта и инвойсов не совпадают",

    Inv_Goods_E006_name: "Покупатель контракта и инвойса",
    Inv_Goods_E006_message: "Покупатель контракта и инвойсов не совпадают",

    Inv_Goods_E007_name: "Продавец контракта и инвойса",
    Inv_Goods_E007_message: "Продавец контракта и инвойсов не совпадают",

    PL_Pack_Main_E001_name: "Вес брутто товара",
    PL_Pack_Main_E001_message: "Вес брутто товара не соответствует инвойсу",

    PL_Pack_Main_E002_name: "Вес нетто товара",
    PL_Pack_Main_E002_message: "Вес нетто товара не соответствует инвойсу",

    PL_Pack_Main_E003_name: "Количество товара",
    PL_Pack_Main_E003_message:
      "Количество товара в упаковочном листе и контракте не совпадают",

    PL_Pack_Main_E004_name: "Количество мест",
    PL_Pack_Main_E004_message:
      "Количество мест товаров в упаковочных листах и инвойсе не совпадают",

    AP_Goods_W002_name: "Количество наименований товаров",
    AP_Goods_W002_message: "Количество товаров в инвойсе и ЭПИ не совпадают",

    AP_Goods_W003_name: "Вес товара",
    AP_Goods_W003_message: "Вес брутто товара не совпадает с инвойсом",

    AP_Goods_W004_name: "Общее количество грузовых мест",
    AP_Goods_W004_message:
      "Общее количество грузовых мест в ЭПИ не совпадает с Упаковочными листами",

    AP_Goods_W005_name: "",
    AP_Goods_W005_message: "",

    CMR_Main_W001_name: "Отправитель CMR",
    CMR_Main_W001_message: "Продавец контракта и CMR не совпадают",

    CMR_Main_W002_name: "Получатель CMR",
    CMR_Main_W002_message: "Покупатель контракта и CMR не совпадают",

    CMR_Goods_E001_name: "Вес груза CMR",
    CMR_Goods_E001_message: "Вес брутто товара не совпадает с инвойсом",

    CMR_Goods_E002_name: "Стоимость груза CMR",
    CMR_Goods_E002_message: "",

    CMR_Main_W003_name: "Количество товаров",
    CMR_Main_W003_message: "количество товаров в CMR и контракте не совпадают",

    CMR_Main_W004_name: "Количество грузовых мест",
    CMR_Main_W004_message:
      "Количество грузовых мест в упаковочных листах не совпадает с местами в CMR",

    validate_fix_button: "Исправить",

    CN1_Main_W_100_name: "Товары",
    CN1_Main_W_100_message: "Не указаны товары в форме",

    // CN1_Main_W_001_name: 'Form M GUID',
    // CN1_Main_W_001_message: 'Не задан Form M GUID',
    // CN1_Main_W_002_name: 'Form M тип',
    // CN1_Main_W_002_message: 'Не задан тип Form M',
    // CN1_Main_W_003_name: 'Valid Forex',
    // CN1_Main_W_003_message: 'Не определен Valid Forex',
    // CN1_Main_W_004_name: 'Номер Form M',
    // CN1_Main_W_004_message: 'Не задан номер Form M',
    // CN1_Main_W_005_name: 'Префикс',
    // CN1_Main_W_005_message: 'Не задан префикс',
    // CN1_Main_W_006_name: 'Год',
    // CN1_Main_W_006_message: 'Не задан год',
    // CN1_Main_W_007_name: 'Номер формы',
    // CN1_Main_W_007_message: 'Не задан номер формы',
    // CN1_Main_W_008_name: 'Пользователь',
    // CN1_Main_W_008_message: 'Не задан пользователь',

    CN1_Main_W_001_name: "TIN",
    CN1_Main_W_001_message: "Не задан tin",
    CN1_Main_W_002_name: "Страна регистрации",
    CN1_Main_W_002_message: "Не задана страна регистрации",
    CN1_Main_W_003_name: "Имя апликанта",
    CN1_Main_W_003_message: "Не задано имя апликанта",
    CN1_Main_W_004_name: "Адрес апликанта",
    CN1_Main_W_004_message: "Не задан адрес апликанта",
    CN1_Main_W_005_name: "Город апликанта",
    CN1_Main_W_005_message: "Не задан город апликанта",
    CN1_Main_W_006_name: "Телефон апиканта",
    CN1_Main_W_006_message: "Не задан телефон апликанта",
    CN1_Main_W_007_name: "Email апликанта",
    CN1_Main_W_007_message: "Не задан Email апликанта",
    CN1_Main_W_008_name: "Страна транспортировки",
    CN1_Main_W_008_message: "Не задана страна транспортировки",
    CN1_Main_W_009_name: "Порт загрузки",
    CN1_Main_W_009_message: "Не задан порт загрузки",
    CN1_Main_W_010_name: "Пункт назначения",
    CN1_Main_W_010_message: "Не задан пункт назначения",
    CN1_Main_W_011_name: "Вид транспортировки",
    CN1_Main_W_011_message: "Не задан вид транспортировки",
    CN1_Main_W_012_name: "Страна обработки",
    CN1_Main_W_012_message: "Не задана страна обработки",
    CN1_Main_W_100_name: "Товары",
    CN1_Main_W_100_message: "Не заданы товары",
    CN1_Main_W_101_name: "Вес нетто",
    CN1_Main_W_101_message: "Не задан вес нетто",
  },

  homepage: {
    eurasia: "RUSSIA",
    crossborder_link: "На портал",
    menu_main: "Главная",
    menu_about_us: "О нас",
    menu_services: "Услуги",
    menu_news: "Новости",
    menu_our_team: "Наша команда",
    menu_contacts: "Контакты",
    tarif: "Тариф",
    personal_area_btn: "Личный кабинет",
    attis_full_name:
      "Автоматизированная трансграничная торгово-расчетная интегрированная система (АТТИС)",
    attis_subline_name: "Платформа, интегрирующая Россию и Китай",
    attis_description:
      "Международная электронная платформа для предоставления полного комплекса информационных услуг по принципу «Единое окно» всем участникам внешнеэкономической деятельности",
    watch_video: "Смотреть видео",
    section_about_us: "О НАС",
    about_us_p1:
      "2020 года, когда по поручению Премьер-Министра Республики Казахстан была создана Межведомственная рабочая группа, координатором работы которой выступило Министерство торговли и интеграции Республики Казахстан. Проект АТТИС базируется на многолетнем опыте его владельцев, на передовых технологиях в сфере IT, позволяющих осуществлять эффективную адаптацию с государственными и частными информационными системами, а также оперативное внедрение проекта.",
    about_us_p2:
      "Структура проекта АТТИС состоит из региональных центров АТТИС, расположенных в Европе, КНР, в Республике Казахстан и Российской Федерации. Каждый региональный центр АТТИС имеет сертификацию стран, на территории которых они осуществляют свою деятельность. ",
    about_us_p3:
      "Владельцы проекта АТТИС обладают большим опытом в сфере финансов, логистики, таможенных процедур и бизнес-управления.",
    about_us_p4:
      "В рамках реализации проекта «Один пояс, один путь» проект АТТИС получил административную поддержку, а также первоначальное финансирование со стороны правительства КНР (Министерство коммерции КНР) для инициирования разработки и пилотного внедрения проекта АТТИС со странами-партнерами. Система АТТИС интегрирована официальными информационными ресурсами КНР,  охватывающих на сегодняшний день полную информацию о всех китайских компаних. Такая интеграция дает участникам внешнеэкономической деятельности возможность выбора подходящих по цене и качеству предложений и позволит заключать сделки прямо в системе АТТИС. ",
    about_us_p5:
      "Миссия проекта АТТИС – создание глобальной и конкурентоспособной платформы, объединяющей всех участников внешнеэкономической деятельности по обе стороны границы, в одном информационном пространстве для предоставления полного комплекса информационных и иных услуг по принципу одного окна.",
    about_us_p6:
      "Проверка информации о потенциальном контрагенте (юридическое/физическое лицо), а также о транспортном средстве, с автоматическим переводом – уникальная возможность проверки потенциальных контрагентов/партнеров на благонадежность по всему миру, а также получение информации о транспортном средстве, с использованием международной системы на основе Искусственного Интеллекта",
    about_us_list_title: "Преимущества проекта АТТИС:",
    about_us_list_i1:
      "прозрачность, оперативность и доступность информации по внешнеэкономической деятельности для всех ее участников;",
    about_us_list_i2:
      "упрощение процедур торговли и повышение международных рейтингов;",
    about_us_list_i3:
      "повышение прозрачности и надежности при проведении внешнеэкономических сделок;",
    about_us_list_i4:
      "возможность для участников внешнеэкономической деятельности по упрощению подачи сведений в государственные органы;",
    about_us_list_i5:
      "сокращение временных и финансовых затрат участников внешнеэкономической деятельности;",
    about_us_list_i6:
      "пвозможность для участников внешнеэкономической деятельности осуществлять поиск зарубежных контрагентов и партнеров в доверенных источниках информации, а также проверять их на благонадежность с использованием международной системы «ComplyAdvantage».",
    // about_us_p6: "Целевая аудитория проекта АТТИС включает экспортеров, импортеров, транспортные и логистические компании, таможенных брокеров, коммерческие банки, страховые организации, государственные органы, уполномоченные организации по сертификации происхождения, а также иных участников внешнеэкономической деятельности.",
    our_team_section: "Наша команда",
    our_team_description:
      "Лидерами международной группы АТТИС, которые стояли у истоков разработки и создания проекта АТТИС, являются:",
    leader_edward: "ЭДВАРД БОУЭН",
    leader_edward_job_title: "Генеральный Директор",
    leader_edward_description:
      "Эдвард служил офицером британской армии более 20 лет, и это позволила ему развить свои знания и опыт в области планирования и организации. После увольнения из армии в 1994 году он работал в Латвии, где основал ряд компаний, занимающиеся логистикой и поставкой свежих и замороженных продуктов из США и Эквадора в соседние страны, а также в Казахстан. Продав эти компании, он создал ряд индустриальных парков в Латвии с крупными международными партнерами. Один из таких парков расположенный недалеко от границы с Россией, в свободной экономической зоне Резекне, остается в центре внимания для дальнейшего развития наземных маршрутов по маршруту «Один пояс, Один путь». Эдвард был первым председателем Британской торговой палаты в Латвии в 1997 году и основателем Совета иностранных инвесторов в Латвии. Он работал с Сергеем более десяти лет, что привело к созданию CrossborderXP.",
    leader_michael: "МАЙКЛ БУРК",
    leader_michael_job_title: "Партнёр. Банки И Финансы",
    leader_michael_description:
      "Майкл имеет более 40 лет опыта работы в банковской сфере. В начале своей карьеры после выполнения нескольких заданий в Центральном банке Ирландии он был назначен в Международный валютный фонд, где работал в Уганде и Египте. Затем последовали 5 лет программы Phare ЕU-ЕС, 1992-1997 гг., В качестве советника Центрального банка в Латвии. Он был генеральным директором и президентом банка Rietumu (Латвии) с 1997 по 2006 год. В 2009 году правительство Латвии, совместно с ЕБРР обратилось к нему с просьбой помочь в восстановлении Parex Bank. Он занимал должность председателя банка до 2017 года, вернув государству более 70% утраченных средств. Обладая обширным международным опытом, Майкл являлся независимым директором в Bank of Nova Scotia (Ирландия) и State Street Bank Ireland. Майкл был почетным консулом Ирландии в Латвии в 1998-2006 годах. Является одним из основателей CROSSBORDERXP.",
    leader_sergey: "СЕРГЕЙ НИКОЛАЕВ",
    leader_sergey_job_title: "Системный Архитектор",
    leader_sergey_description:
      "Сергей является автором и владельцем более 7 официально зарегистрированных объектов интеллектуальной собственности в области разработки программного обеспечения и построения информационных систем. Более 25 успешно разработанных и внедренных проектов в области электронного правительства, электронного банкинга, электронной таможни. Эксперт высокого уровня с 30-ти летним стажем в качестве руководителя проектов, компаний в различных странах, где реализовывались проекты (Казахстан, Россия, Белоруссия, Украина, Китай, США)",
    leader_tikhonov: "ВЯЧЕСЛАВ ТИХОНОВ",
    leader_tikhonov_job_title: "ДИРЕКТОР АТТИС ТРЕЙД РУ",
    leader_tikhonov_description:
      "Начиная с  1988 года занимал руководящие должности в различных областях деятельности - приборостроение, комплексная автоматизация, автоматизация банковской деятельности.Самостоятельно реализовал целый ряд успешных проектов малого бизнеса – оптовая торговля, рекламная деятельность. В 2009 году в условиях кризиса успешно стартовал веб-студию www.pro2b.ru, которая работает и в настоящее время. Выполнено более 500 различных проектов для малого бизнеса – разработка сайтов, сео-продвижение, дизайн, контекстная реклама и т.д.Обладая вторым высшим образованием «Практическая психология бизнеса», ведет практику прикладного бизнес-психолога, помогая деловым людям выявлять и убирать психологические проблемы, с которыми сталкивается деловые люди.",

    leader_aben: "АБЕН БЕКТАСОВ",
    leader_aben_job_title: "Управляющий Партнёр. Центральная Азия",
    leader_aben_description:
      "Более 30 лет занимал руководящие должности в самых разных государственных структурах и организациях Казахстана (Национальный банк, Министерство финансов, Национальный комитет по ценным бумагам, Казахтелеком, Национальное агентство по информационным технологиям и телекоммуникациям). Национальная система межбанковских расчетов и пенсионная система были признаны Всемирным банком как наиболее эффективные системы на постсоветском пространстве. Господин Бектасов является одним из лидеров, внесших реальный вклад в развитие существующей цифровой экономики в Казахстане.",
    leader_erzhan: "ЕРЖАН ТОКТАБАЯНОВ",
    leader_erzhan_job_title: "Директор ТОО «ATTIS Eurasia»",
    leader_erzhan_description:
      "Ержан имеет более 17 лет опыта работы в банковской и страховой сферах, где занимал руководящие позиции в юридической службе, а также службах комплаенс-контроля и финансового мониторинга. Основные задачи на данных позициях заключались в правовом сопровождении деятельности банка, в том числе контроль за соблюдением банком законодательства о противодействии легализации (отмыванию) доходов, полученных преступным путем, и финансированию терроризма,впредставлении интересовбанкав Национальном Банке Республики Казахстан,ОЮЛ «Ассоциация финансистов Казахстана»и иных государственных органах.Ержан является консультантомIFCи Всемирного банка по вопросам корпоративного управления. В рамках этой деятельности участвовал в реализации проекта по внедрению системы корпоративного управления в ведущих финансовых организациях Республики Таджикистан.",
    section_our_partners: "Наши партнёры",
    services_and_prices: "Услуги и тарифы",
    customer_categories:
      "Категории клиентов <strong>ИС &laquo;АТТИС&raquo;</strong>",
    customer_categories_description:
      "Система объединяет всех участников внешнеэкономической деятельности, включая государственные и таможенные органы по обе стороны границы",
    read_more: "Подробнее",
    show_more: "Показать еще услуги",
    show_less: "Показать меньше услуг",
    attis_features: "Возможности <strong>ИС &laquo;АТТИС&raquo;</strong>",
    news: "Новости",
    contacts: "Контакты",
    headquarters: "Главный офис",
    address:
      "109028, Москва, Подсосенский переулок, д. 30, стр. 3.\n630005, г.Новосибирск, ул. Некрасова, д. 48, офис 502.",
    phone: "Телефон",
    name: "Ваше имя",
    email: "Ваш Email",
    subject: "Тема сообщения",
    message: "Сообщение",
    sending: "Отправка",
    thankyou:
      "Спасибо. Ваше сообщение отправлено. Мы ответим Вам в ближайщее время",
    send: "Отправить",
    gotoaccount: "Перейти в личный кабинет",
    gotoaccount_text: "Зарегистрируйтесь в системе АТТИС прямо сейчас",
    nursultan: "Г.НУР-СУЛТАН",
    yesil: 'РАЙОН "ЕСИЛЬ"',
    street: "УЛИЦА ДІНМҰХАМЕД ҚОНАЕВ",
    building: "ЗДАНИЕ 4",
    kz: "Казахстан",
  },
  comply_advantage: {
    tippy: "Для продолжения мониторинга включите переключатель",
    search_tab: "Проверка контрагента",
    case_management_tab: "История и мониторинг запросов",
    name_details: "Имя и детали",
    details_name: "Введите наименование контрагента для мониторинга",
    details_reference: "Ссылка клиента (необязательное)",
    details_reference_placeholder: "XXXX",
    details_birth_year: "Год рождения (необязательное)",
    details_birth_year_placeholder: "YYYY",
    details_country: "Страна (необязательное)",
    entity_type_title: "Тип объекта",
    entity_type_all: "Все",
    entity_type_person: "физическое лицо",
    entity_type_company: "Компания",
    entity_type_organisation: "Аббревиатура",
    entity_type_vessel: "Судно",
    entity_type_aircraft: "Самолет",
    fuzzy_exact: "Полное совпадение",
    fuzziness_title: "Нечеткость",
    fuzzy_0: "0% будет проверять только точные совпадения",
    fuzzy_10: "10%",
    fuzzy_20: "20%",
    fuzzy_30: "30%",
    fuzzy_40: "40%",
    fuzzy_50: "50%",
    fuzzy_60: "60%",
    fuzzy_70: "70%",
    fuzzy_80: "80%",
    fuzzy_90: "90%",
    fuzzy_100:
      "100% будет искать результаты даже с малейшим совпадением в орфографии и фонетике",

    filter_date_from: "Создано с",
    filter_date_to: "Создано до",
    filter_name: "Имя поиска",
    filter_reference: "Искать ссылку",
    filter_match: "Статус совпадение",
    filter_risk: "Уровень риска",
    filter_assigned_to: "Назначен",
    filter_searched_by: "Поиск по",
    filter_changed: "Измененный",
    filter_monitored: "Отслеживается",
    filter_matched: "Типы совпадение",

    filter_match_all: "Все",
    filter_match_unknown: "Неизвестный",
    filter_match_no: "Не совпадает",
    filter_match_potential: "Возможное совпадение",
    filter_match_false_positive: "Ложный положительный результат",
    filter_match_true_positive: "Истинный положительный",
    filter_match_true_positive_approve:
      "Истинный положительный результат — одобрить",
    filter_match_true_positive_reject:
      "Истинный положительный результат — отклонение",

    filter_risk_all: "Все",
    filter_risk_unknown: "Неизвестный",
    filter_risk_low: "Низкий",
    filter_risk_medium: "Средний",
    filter_risk_high: "Высокий",

    filter_changed_all: "Все",
    filter_changed_changed: "Измененный",
    filter_changed_unchanged: "Без изменений",

    filter_monitored_all: "Все",
    filter_monitored_actively: "Активно отслеживается",
    filter_monitored_suspended: "Приостановленный",
    filter_monitored_unmonitored: "Неконтролируемый",

    filter_matched_types_all: "Все",
    filter_matched_types_sanctions: "Санкции",
    filter_matched_types_warnings: "Предупреждения",
    filter_matched_types_fitness_probity: "Благонадежность",
    filter_matched_types_peps_all: "PEPs",
    filter_matched_types_pep_1: "PEP класса 1",
    filter_matched_types_pep_2: "PEP класса 2",
    filter_matched_types_pep_3: "PEP класса 3",
    filter_matched_types_pep_4: "PEP класса 4",
    filter_matched_types_adverse_media: "Неблагоприятные СМИ",
    filter_matched_types_financial_crime: "Финансовое преступление",
    filter_matched_types_violent_crime: "Жестокое преступление",
    filter_matched_types_sexual_crime: "Сексуальное преступление",
    filter_matched_types_terrorism: "Терроризм",
    filter_matched_types_fraud: "Мошенничество",
    filter_matched_types_narcotics: "Наркотики",
    filter_matched_types_other: "Другое преступление",

    table_created: "Созданный",
    table_names: "Строка поиска",
    table_ref: "Ссылка",
    table_match_status: "Статус совпадения",
    table_risk_level: "Уровень риска",
    table_assigned_to: "Назначено",
    table_searcher: "Искатель",
    table_changes: "Изменения",
    table_changed: "Изменено",
    table_monitor: "Монитор",

    apply_filters: "Применить фильтры",
    remove_filters: "Удалить фильтры",

    matched_label: "Соответствует",
    relevance_label: "Актуальность",
    countries_label: "Страны",
    dob_label: "Дата рождения",

    response_entity_type_organisation: "Аббревиатура",
    response_entity_type_person: "Физическое лицо",
    response_entity_type_company: "Компания",
    response_entity_type_vessel: "Судно",
    response_entity_type_aircraft: "Самолет",

    response_match_enrichment: "Обогащение",
    response_match_sanction: "Санкции",
    response_match_warning: "Предупреждения",
    response_match_pep: "PEP",
    "response_match_pep-class-1": "PEP класса 1",
    "response_match_pep-class-2": "PEP класса 2",
    "response_match_pep-class-3": "PEP класса 3",
    "response_match_pep-class-4": "PEP класса 4",

    "response_match_fitness-probity": "Благонадежность",
    "response_match_adverse-media": "Неблагоприятные СМИ",
    "response_match_adverse-media-financial-crime": "Финансовое преступление",
    "response_match_adverse-media-violent-crime": "Жестокое преступление",
    "response_match_adverse-media-sexual-crime": "Сексуальное преступление",
    "response_match_adverse-media-terrorism": "Терроризм",
    "response_match_adverse-media-fraud": "Мошенничество",
    "response_match_adverse-media-narcotics": "Наркотики",
    "response_match_adverse-media-general": "Другое преступление",

    response_relevance_name_exact: "Имя точно совпало",
    response_relevance_aka_exact: "так же точно совпало",
    response_relevance_name_fuzzy: "Имя точно соответствует",
    response_relevance_aka_fuzzy: "так же близко совпал",
    response_relevance_phonetic_name: "Имя соответствует фонетически",
    response_relevance_phonetic_aka: "так же соответствует фонетически",
    response_relevance_equivalent_name: "Имя соответствует синониму",
    response_relevance_equivalent_aka: "так же соответствует синониму",
    response_relevance_unknown: "Сложный матч",
    response_relevance_year_of_birth: "Год рождения совпал",
    response_relevance_removed_personal_title: "Удален личный титул",
    response_relevance_removed_personal_suffix: "Удален личный суффикс",
    response_relevance_removed_organisation_prefix:
      "Префикс организации удален",
    response_relevance_removed_organisation_suffix:
      "Удален суффикс организации",
    response_relevance_removed_clerical_mark: "Удален канцелярский знак",

    case_deleted_successfully: "Дело успешно удалено",
    case_delete_unsuccessful: "Не удалось удалить дело",

    search_no_results: "Нет совпадений",
    filter_countries_all: "Все",
    check_differences: "Посмотреть различия",

    "response_match_adverse-media-v2-property": "Property",
    "response_match_adverse-media-v2-financial-aml-cft": "Financial AML/CFT",
    "response_match_adverse-media-v2-fraud-linked": "Fraud-linked",
    "response_match_adverse-media-v2-narcotics-aml-cft": "Narcotics AML/CFT",
    "response_match_adverse-media-v2-violence-aml-cft": "Violence AML/CFT",
    "response_match_adverse-media-v2-terrorism": "Terrorism",
    "response_match_adverse-media-v2-cybercrime": "Cybercrime",
    "response_match_adverse-media-v2-general-aml-cft": "General AML/CFT",
    "response_match_adverse-media-v2-regulatory": "Regulatory",
    "response_match_adverse-media-v2-financial-difficulty":
      "Financial difficulty",
    "response_match_adverse-media-v2-violence-non-aml-cft":
      "Violence NON-AML/CFT",
    "response_match_adverse-media-v2-other-financial": "Other Financial",
    "response_match_adverse-media-v2-other-serious": "Other Serious",
    "response_match_adverse-media-v2-other-minor": "Other Minor",

    on_off_monitor: "Вкл./выкл. монитор.",
    only_monitored: "Только отслеживаемые запросы",

    show_additional_params: "Показать дополнительные параметры",
    hide_additional_params: "Скрыть дополнительные параметры",
  },
  find_partner: {
    no_results_found: "Результаты не найдены",
    history: "История",
    cn: "Китай",
    kz: "Казахстан",
    ru: "Россия",
    confirm_move_to_other_page:
      "Внимание! Данные и результаты поиска могут быть потеряны в случае перехода на другую страницу. Вы уверены?",
    search_keyword: "Единый социальный кредитный код, Регистрационный номер",
    search_button: "Поиск",
    find_all_companies: "Загрузить все компании",
    max_pages: "Страницы",
    table_field: "Поле",
    table_value: "Значение",
    table_value_cn: "Значение китай",
    all_services_cn: "Все услуги Китай",
    common_info_cn: "Информация о компании",
    common_info_cn_no_logo: "Информация о компании (Без логотипа)",
    overall_info_cn: "Групповой поиск",
    common_info_name_list: "Используемые имена",
    common_info_name_list_name: "Название",
    common_info_name_list_date: "Дата изменения",
    common_info_share_holder_list: "Акционеры",
    common_info_share_holder_KeyNo: "Ключ №",
    common_info_share_holder_StockName: "Список акций",
    common_info_employee_list: "Сотрудники",
    common_info_employee_KeyNo: "Ключ №",
    common_info_employee_Name: "Название",
    common_info_employee_Job: "Работа",
    common_info_invest_list: "Инвесторы",
    common_info_invest_list_Name: "Название",
    common_info_invest_list_KeyNo: "Ключ №",
    common_info_invest_list_RegistCapi: "Капитал",
    common_info_invest_list_StartDate: "Дата начала",
    common_info_invest_list_Status: "Статус",
    common_info_invest_list_OperName: "Представитель",
    common_info_change_list: "Информация об изменении записи",
    common_info_change_list_ProjectName: "Название проекта",
    common_info_change_list_BeforeList: "До",
    common_info_change_list_AfterList: "После",
    common_info_change_list_ChangeDate: "Дата изменения",
    common_info_branch_list: "Информация о филиале",
    common_info_branch_list_KeyNo: "Ключ №",
    common_info_branch_list_Name: "Название",
    common_info_branch_list_DirectorName: "Имя директора",
    common_info_branch_list_Status: "Статус",
    common_info_more_email_list: "Больше почтовых ящиков",
    common_info_more_email_list_Source: "Источник",
    common_info_more_email_list_Value: "Значение",
    common_info_more_tel_list: "Другие телефоны",
    common_info_more_tel_list_Source: "Источник",
    common_info_more_tel_list_Value: "Значение",
    common_info_ent_tag_list: "Фирменный знак",
    common_info_ent_tag_list_Type: "Тип",
    common_info_ent_tag_list_Name: "Имя",
    common_info_Province: "Провинция",
    common_info_Grade: "Оценка",
    common_info_GradeDescription: "Описание оценки",
    common_info_as_calculated_grade: "Как рассчитана оценка",
    cn_company_info_check_alert:
      "Внимание! Проверка информации о китайской компании является платной услугой. Цена",
    no_results:
      "Нет совпадений для запроса услуги [services] по параметрам [parameters]",
    no_results_430: "Результатов не найдено",
    court_notice_info: "Проверка судебных решений",
    court_notice_info_no_logo: "Проверка судебных решений (Без логотипа)",
    court_notice_Id: "Ид",
    court_notice_CaseNo: "Номер дела",
    court_notice_CaseReason: "Дело Причина",
    court_notice_Category: "Категория",
    court_notice_Court: "Суд",
    court_notice_PublishDate: "Дата публикации",
    court_notice_ProcecutorList: "Список прокуроров",
    court_notice_DefendantList: "Список ответчиков",

    corporate_news_search: "Поиск корпоративных новостей",
    corporate_news_search_no_logo:
      "Поиск корпоративных новостей (Без логотипа)",
    corporate_news_search_Id: "ID",
    corporate_news_search_NewsId: "ID новости",
    corporate_news_search_Source: "Источник",
    corporate_news_search_Title: "Заголовок",
    corporate_news_search_Url: "Url",
    corporate_news_search_PublishTime: "Время публикации",
    corporate_news_search_EmotionType: "Тип эмоции",
    corporate_news_search_Category: "Категория",
    corporate_news_search_NewsTags: "Новостной тег",
    corporate_news_search_Content: "Содержание",
    area_table: "Область",
    industry_table: "Промышленность",
    revoke_info_table: "Информация об отзыве",
    parent_info_table: "Информация о головном офисе",
    common_info_cn_description:
      "Описание: Запрос предоставляет полную информацию о бизнесе, такую ​​как название компании, статус регистрации, уставный капитал, единый код социального кредита, тип бизнеса, срок работы, численность персонала, юридический адрес, сферу деятельности и другую информацию. В то же время он предоставляет данные, связанные с предприятием, такие как:зарегистрированные акционеры, ключевой персонал, иностранные инвестиции компании, записи об изменениях, управляющие компании, филиалы, головные офисы, контактные телефоны, контактные адреса электронной почты и другую информацию. Позвольте вам получить всю информацию о предприятии одним запросом.",
    court_notice_info_description:
      "Описание: Получите исторические данные судебных дел запрашиваемой компании, выполнив поиск по ключевым словам, и верните исторический номер дела, тип процесса, лицо, ведшее процесс, истец, ответчик и другую информацию.",
    corporate_news_search_description:
      "Описание: Получите новости компании общественное мнение, а с помощью интеллектуального анализа данных Qichacha определите эмоциональный тип новостей и верните поля, такие как заголовок, источник и категория новостей.",
    main_service_cn: "Услуги",
    main_service_description:
      "Эта услуга содержит информацию о компании и проверку судебных уведомлений.",
    load_in_progress:
      "Пожалуйста подождите. Данные загружаются, это может занять некоторое время.",
    cn_single_service_alert: "Внимание! {} является платной услугой. Цена ",
    cn_bulk_services_alert: "Внимание! {} являются платными услугами. Цена ",

    fuzzy_search_cn: "Поиск компаний",
    group_search: "Бизнес справка",
    group_search_description:
      "Описание: Получите бизнес справку по компании. Осуществляется поиск информации о компании, проверка судебных решений, поиск корпоративных новостей, годовых отчетов, осуществляется оценка корпоративных рисков.",
    fuzzy_search_description:
      "Описание: Получите список компаний, соответствующих критериям поиска, путем поиска по ключевым словам (таким как название компании, имя человека, название продукта, адрес, номер телефона, сфера деятельности и т. д.) Дата, единый код социального кредита, регистрационный номер и другую информацию.",
    fuzzy_search_cn_KeyNo: "Ключ №",
    fuzzy_search_cn_Name: "Название",
    fuzzy_search_cn_CreditCode: "Кредитный код",
    fuzzy_search_cn_StartDate: "Дата начала",
    fuzzy_search_cn_OperName: "Представитель",
    fuzzy_search_cn_Status: "Статус",
    fuzzy_search_cn_No: "Регистрационный номер",
    fuzzy_search_cn_Address: "Зарегестрированный адрес",

    province_code_keyWord: "Код провинции",
    city_code_keyword: "Код города",
    data_is_not_found: "Данные по сервису {x} по параметру {y} не найдены",
    error_loading_service: "Ошибка при загрузке сервиса {} по параметру ",

    common_info_Name: "Название компании",
    common_info_OperName: "Представитель",
    common_info_Status: "Статус компании",
    common_info_StartDate: "Дата создания",
    common_info_RegistCapi: "Зарегистрированный капитал",
    common_info_CheckDate: "Дата внесения последнего изменения в Устав",
    common_info_OrgNo: "Код организ ации (аналог ОКПО в РФ)",
    common_info_No: "Регистрационный номер предприятия",
    common_info_CreditCode: "Кредитный код",
    common_info_EconKind: "Тип предприятия",
    common_info_TermStart: "Дата начала бизнеса",
    common_info_TermEnd: "Дата окончания бизнеса",
    common_info_TaxpayerType: "Тип налогоплательщика",
    common_info_BelongOrg: "Регистрирующий орган",
    common_info_PersonScope: "Численность персонала",
    common_info_InsuredCount: "Эарегистрировано сотрудников",
    common_info_EnglishName: "английское имя",
    common_info_IXCode: "Импортно-экспортный код предприятия",
    common_info_IXCode_description: `Используется для идентификации компании во время импортных и экспортных операций.
Это обязательное требование для любой компании, желающей участвовать в международной торговле.`,
    common_info_Address: "Адрес",
    common_info_Scope: "Сфера",
    common_info_IsOnStock: "Торгуются ли акции на бирже",
    common_info_StockNumber: "Код списка",
    common_info_StockType: "Тип листинга",
    common_info_ImageUrl: "Логотип",
    common_info_PhoneNumber: "Номер телефона",
    common_info_Email: "Эл. адрес",
    common_info_WebSiteUrl: "Ссылка на сайт",
    common_info_EntNature: "Характер деятельности предприятия",
    common_info_AreaCode: "Код города",
    common_info_RecCap: "Оплаченный капитал",
    common_info_Industry: "Промышленность",

    common_info_UpdatedDate: "Дата обновления",
    common_info_EndDate: "Дата закрытия",

    search_keyword_886:
      "Ключевые слова для поиска (такие как название компании, имя человека, название продукта, адрес, телефон, сфера деятельности и т. д.)",

    group_request: "Групповой запрос",

    service_430: "Информация о компании",
    service_930: "Проверка судебного уведомления",
    service_701: "Поиск корпоративных новостей",
    service_213: "Годовой отчет",
    service_736: "Сканирование корпоративных рисков",
    service_886: "Поиск бизнеса",
    service_410: "Поиск бизнеса",
    service_410_admin: "Поиск бизнеса",
    service_736_213: "Краткая справка",

    description_430:
      "Описание: Интерфейс предоставляет информацию о бизнесе при личном контакте, такую ​​как название компании, статус регистрации, уставный капитал, единый код социального кредита, тип бизнеса, срок работы, численность персонала, юридический адрес, сферу деятельности и другую информацию. Информация. В то же время он предоставляет размерные данные, связанные с предприятием, такие как: промышленные и коммерческие зарегистрированные акционеры, ключевой персонал в промышленной и коммерческой регистрации, иностранные инвестиции компании, записи об изменениях, управляющие компании, филиалы, головные офисы, контактные телефоны, контактные адреса электронной почты и другую информацию. Позвольте вам получить всю информацию о предприятии только с одним запросом.",
    description_930:
      "Описание: Получите исторические данные судебных объявлений запрашиваемой компании, выполнив поиск по ключевым словам, и верните исторический номер дела, тип объявления, лицо, объявляющее, истец, ответчик и другую информацию.",
    description_701:
      "Описание: Получите собственные новости компании и общественное мнение, а с помощью интеллектуального анализа данных Qichacha определите эмоциональный тип новостей и верните поля, такие как заголовок, источник и категория новостей.",
    description_213:
      "Описание: годовой отчет компании включает в себя основную информацию, заявленную самой компанией, информацию о веб-сайте или интернет-магазине, информацию о спонсорах и вкладах в капитал, информацию о состоянии корпоративных активов и изменениях в капитале и т. д.",
    description_736:
      "Описание: Текущий интерфейс включает в себя как деловую информацию (включая деловые интервью, информацию об акционерах (включая соотношение долей), ключевой персонал, филиалы, информацию об изменениях, отраслевую классификацию, корпоративные портреты и т. д.), так и информацию о корпоративных рисках, такую как как административное наказание, неправомерные хозяйственные операции, недобросовестные лица, подлежащие исполнению, лица, подлежащие исполнению, ипотека движимого имущества, ликвидация, залог акций, выборочная проверка, налоговый кредит и другая информация. Комплексный запрос измерения позволяет получить всю информацию о предприятии в одном запросе.",
    description_886:
      "Описание: Получите список компаний, соответствующих критериям поиска, путем поиска по ключевым словам (таким как название компании, имя человека, название продукта, адрес, номер телефона, сфера деятельности и т. д.) Дата, единый код социального кредита, регистрационный номер и другие Информация.",

    services_loading: "загружается",
    services_loading_data: "Загрузка данных",
    services_loading_translations:
      "Загрузка переводов. Процесс перевода может занять несколько минут, не закрывайте окно",

    services_rendering: "Отрисовка результатов",

    area_list_Province: "Провинция",
    area_list_City: "Город",
    area_list_County: "Район",

    industry_list_IndustryCode: "Код отрасли",
    industry_list_Industry: "Описание категории отрасли",
    industry_list_SubIndustryCode: "Код отрасли",
    industry_list_SubIndustry: "Описание категории отрасли",
    industry_list_MiddleCategoryCode: "Код отраслевого класса",
    industry_list_MiddleCategory: "Описание отраслевого класса",
    industry_list_SmallCategoryCode: "Код отрасли",
    industry_list_SmallCategory: "Описание подкатегории отрасли",

    revoke_info_list_CancelDate: "Дата отмены",
    revoke_info_list_CancelReason: "Причина отмены",
    revoke_info_list_RevokeDate: "Дата отзыва",
    revoke_info_list_RevokeReason: "Отзыв за отзыв",

    parent_info_list_KeyNo: "Номер предприятия",
    parent_info_list_Name: "Название компании",
    parent_info_list_OperName: "Представитель",
    parent_info_list_RegistCapi: "Зарегистрированный капитал",
    parent_info_list_StartDate: "Дата создания",
    parent_info_list_Status: "Статус",

    visit_company_website: "Посетите сайт компании",
    search_keyword_placeholder:
      "Название компании, имя человека, название продукта, адрес, сфера деятельности",
    bn_search_keyword_placeholder:
      "Единый социальный кредитный код, Регистрационный номер",
    ca_search_keyword_placeholder:
      "Введите наименование контрагента для мониторинга",
    search_parameters: "Параметры",

    history_results_not_found: "Этот запрос не имел совпадений",
    services_parameter_translation:
      "Параметры поиска переводятся на английский язык",

    fuzzy_load_more_results: "Загрузить еще {} записей",

    search_parameters_translation:
      "Согласны ли вы, что параметры вашего поиска будут переведены на английский язык? Перевод: ",

    info_1:
      "Запрос предоставляет полную информацию о бизнесе, такую ​​как название компании, статус регистрации, уставный капитал, единый код социального кредита", //'получите полезную информацию о компании – основные сведения, информацию о годовом отчёте компании, судебные уведомления, сканирование корпоративных рисков и пр.',
    info_1_more:
      ", тип бизнеса, срок работы, численность персонала, юридический адрес, сферу деятельности и другую информацию. В то же время он предоставляет данные, связанные с предприятием, такие как:зарегистрированные акционеры, ключевой персонал, иностранные инвестиции компании, записи об изменениях, управляющие компании, филиалы, головные офисы, контактные телефоны, контактные адреса электронной почты и другую информацию. Позвольте вам получить всю информацию о предприятии одним запросом.", //'получите полезную информацию о компании – основные сведения, информацию о годовом отчёте компании, судебные уведомления, сканирование корпоративных рисков и пр.',
    info_2: "Запрос можно составлять на любом языке",
    info_3:
      "стоимость одного запроса составляет 1500 рублей,           для клиентов Азиатско-Тихоокеанского Банка (АО) специальный тариф   -  1000 рублей за один запрос",
    info_4:
      "стоимость одного запроса составляет 50 рублей,           для клиентов Азиатско-Тихоокеанского Банка (АО) специальный тариф  -  25 рублей за один запрос",
    info_5:
      "Поиск контрагента/партнера – зарегистрированные пользователи платформы имеют возможность осуществлять поиск зарубежных контрагентов/партнеров в целях установления деловых отношений с ними и заключения сделок, а также рассылать им коммерческие предложения. Результаты поиска выдаются по 20 компаний. Следующая страница из 20 компаний потребует оплаты",
    info_6:
      "Этот фильтр не действует на санкционные списки и упоминания в медиа",
    info_7:
      "Уровень гибкости поиска (0% будет проверять только точные совпадения; 100% будут искать результаты даже с малейшим совпадением в орфографии и фонетике)",
    find_partner: "Поиск контрагента",
    search_certificate: "Сертификат поиска",
    search_query: "Поисковой запрос",
    request_from: "Запрос от",
    request_date: "Дата",
    no_matches_link: "Статус совпадения: нет совпадений",
    no_matches_line: "Статус совпадения: нет совпадений",
    search_results: "Результаты поиска",
    found_matches: "Найдено совпадений",
    download_pdf: "Скачать PDF отчет",
    download_pdf_no_logo: "Скачать PDF отчет (Без логотипа)",
    download_excel: "Скачать Excel",
    partner_search_excel_filename: "Контрагенты в Китае",
    pdf_file_name: "Расширенная",
    pdf_short_file_name: "Краткая",
    pdf_company_info_service_cn: "Инфо",
    fuzzyness_no_results: "Нечеткость",
    types_no_results: "Типы",
    risk_level_no_results: "Уровень риска",
    not_found_message: "компания/лицо в санкционных и иных запретительных списках не обнаружен.",

    switch_monitoring_on: "Включи мониторинг здесь",

    rating_410: "Рейтинг",
    common_help_item_title: "Пояснение",
    common_help_item_1: "Количество зарегистрированных сотрудников соответствует масштабу бизнеса",
    common_help_item_2: "Имеет значение не столько зарегистрированный, сколько оплаченный капитал",
    common_help_item_3: "Капитал компании соответствует масштабам бизнеса и сфере деятельности (требование законодательства КНР)",
    common_help_item_4: "Пустые таблицы, пункты Справки без содержания и отсутствующие пункты показывают, что деятельность рассматриваемой компании данных пунктов не касается",
    common_help_item_5: "Некоторые таблицы в силу большого количества полей переносятся на следующие строки",
    common_help_item_6: "Таблица \"Информация об изменении записи\" содержит хронологию развития компании (в Расширенном варианте Справки)",

    specific_help_items_title: "Пояснение значений некоторых пунктов справки",

    entType_explanation_title: "Характер деятельности предприятия",
    entType_explanation: "0-материковое предприятие, 1-социальная организация, 3-гонконгская компания, 4-государственное учреждение, 5-Китайская тайваньская компания, 6-Фонд, 7-Больница, 8-Зарубежная компания, 9-Юридическая фирма, 10-Школа, 11-Институциональное агентство",

    IXCode_explanation_title: "Импортно-экспортный код предприятий",
    IXCode_explanation: "Используется для идентификации компании во время импортных и экспортных операций. Это обязательное требование для любой компании, желающей участвовать в международной торговле",

    permissionInfo_explanation_title: "Административное лицензирование",
    permissionInfo_explanation: "Юридическое разрешение административного субъекта конкретному административному контрагенту заниматься определенной деятельностью или осуществлять определенное поведение путем выдачи разрешений или лицензий на основании заявления административного контрагента в обстоятельствах, обычно запрещенных по закону. Административное действие прав или квалификаций. Это понятие содержит три значения: во-первых, существует общий правовой запрет; во-вторых, административный субъект снимает общий запрет с контрагента; в-третьих, административный контрагент получает квалификацию или право заниматься определенной деятельностью или совершать определенное поведение",

    exceptions_explanation_title: "Ненормальные бизнес-операции (включение в реестр)",
    exceptions_explanation: "В соответствии с законодательством ограничивает или запрещает государственные закупки, проектные торги, передачу государственной земли, отменяет почетные звания. Механизм кредитных ограничений затронет банковский кредит, подписание контрактов, таможенное оформление, получение свидетельств о работе для иностранных корпоративных сотрудников и т.д",

    spec_info_report_explanation_title: "Особенности получения сведений из годового отчета китайских компаний",
    spec_info_report_explanation: "Все китайские предприятия обязаны предоставлять годовой отчет контролирующему органу, в противном случае компания вносится в реестр \"Ненормальные бизнес-операции\" (см. выше). При этом предприятия имеют право не раскрывать данные отчета публично, но обязаны предоставить возможность получения сведений из последнего годового отчета в индивидуальном порядке. Адрес, по которому можно получить отчет, отображается в подразделе Контактная информация для получения последнего корпоративного годового отчета."
  },
  // Исторические продажи компании (1105)
  company_history_sales: {
    company_historical_sales: "Исторические продажи компании",
    search_button: "Поиск",
    select_month: "Выберите месяц",
    search_keyword_placeholder: "Единый социальный кредитный код, Наименование предприятия",
    searching: "Идет поиск",
    no_results_found: "Результаты не найдены",
    month: "Месяц",
    company_name: "Наименование компании",
    sales_amount: "Ежемесячные продажи (сумма)",
    yoy_percent: "Год к году (%)",
    year_total: "Накопительный итог продаж за год",
    history: "История",
    fill_all_fields: "Заполните все поля",
    cn_single_service_alert: "Внимание! {} является платной услугой. Цена ",
    services_loading_data: "Загрузка данных",
    services_loading_translations: "Загрузка переводов. Процесс перевода может занять несколько минут, не закрывайте окно",
    error_loading_service: "Ошибка при загрузке сервиса {} по параметру ",
    no_data_to_export: "Нет данных для экспорта",
    credit_code: "Единый код социального кредита",
    sales_volume: "Ежемесячный объём продаж (10 тыс. шт.)",
    sales_volume_yoy: "Объём продаж за месяц год к году (%)",
    sales_amount_yoy: "Сумма продаж за месяц год к году (%)",
    sales_volume_sum: "Накопительный объём продаж за год (10 тыс. шт.)",
    sales_amount_sum: "Накопительная сумма продаж за год (10 тыс. юаней)",
    sales_volume_sum_yoy: "Накопительный объём продаж год к году (%)",
    sales_amount_sum_yoy: "Накопительная сумма продаж год к году (%)",
    chart_title: "Накопительная сумма продаж по месяцам"
  },
  find_person: {
    title: "Найти человека",
    search: "Поиск",
    search_name_placeholder: "Полное имя",
    search_id_placeholder: "Идентификатор человека",
    search_type_placeholder: "Тип",
    searching: "Идет поиск",
    no_results: "Результатов не найдено",
    results_exists_by_response_code: "является гражданином КНР. Негативных сведений не обнаружено.",
    history: "История",
    order_detail: "Деталь",
    results: "Результаты",
    view: "Просмотр",
    search_name: "Поиск по имени",
    search_id_number: "Поиск по идентификатору",
    search_type: "Поиск по типу",
    results_count: "Количество результатов",
    results_score: "Оценка",
    results_type: {
      "0-20": "",
      "20-30": "В розыске",
      "30-40": "Наркотики",
      "40-50": "Причастность к наркотикам",
      "50-60": "Уголовное прошлое",
      "60": "Люди с психическими заболеваниями, протестующие, террористы и другие",
      "60-100": "Нет попадания в категорию",
    },
    billing: {
      price: "Цена",
      your_balance: "Ваш баланс",
      not_enough_funds: "Недостаточно средств",
      not_enough_funds_history:
        "Детальная информация по этой истории не была куплена. И у вас недостаточно средств для покупки.",
      not_enough_funds_search:
        "У вас недостаточно средств для поиска/покупки этой информации.",
      buy_search: "Купить и искать?",
      buy_search_history:
        "Детальная информация по этой истории не была куплена. Хотите купить?",
      search_buy: "Хотите искать/купить эту информацию?",
    },
    types: {
      listOf: "Список",
      all: "Все типы",
      cpws: "Судебный документ",
      ktgg: "Анонсы судебных заседаний",
      zxgg: "Объявления об исполнении",
      shixin: "Объявления о недоверии",
      fygg: "Объявление суда",
      ajlc: "Судебный процесс",
      bgt: "Реклама",
      sifacdk: "Обнаружение, замораживание и арест",
      pmgg: "Извещение о продаже на аукционе",
    },
    vocabulary: {
      cpwsId: "ID Судебного документа",
      body: "Содержание",
      caseNo: "Номер дела",
      court: "Суд",
      judge: "Судья",
      judgeResult: "Результат судебного решения",
      sortTime: "Дата завершения дела",
      title: "Заголовок",
      yiju: "Основание",
      partys: "Стороны ",
      datatype: "Тип данных",
      birthday: "Дата рождения стороны",
      caf: "Плата за рассмотрение дела",
      caseCauseT: "Основное содержание дела",
      caseNoKwordT: "Кодовое значение",
      caseTypeT: "Тип документа",
      courtRankT: "Уровень суда",
      courtTypeT: "Тип суда",
      lawOffice: "Адвокатская контора",
      lawyer: "Адвокат (защитник)",
      partyFeeT: "Сумма решения",
      partyPositionT: "Позиция стороны в суде (первая инстанция)",
      partyResultT: "Результат стороны",
      partyTitleT: "Текущий статус",
      partyType: "Тип стороны",
      pname: "Название стороны",
      boHui: "Метка отказа",
      cdk: "Метка проверки, заморозки, изъятия",
      chaiChu: "Метка обезвреживания ",
      cheSu: "Метка прекращения дела",
      diaoXiao: "Метка аннулирования",
      faKuan: "Метка штрафа",
      guoHu: "Метка переоформления ",
      jieChuCDK: "Метка отмены проверки, заморозки, изъятия",
      jingGao: "Метка предупреждения",
      juLiu: "Метка задержания",
      moShou: "Метка конфискации",
      piaoJuWX: "Метка недействительности ценных бумаг",
      poChanCZ: "Метка реорганизации банкротства",
      pochanHJ: "Метка мирового соглашения по банкротству",
      poChanQS: "Метка ликвидации банкротства",
      qangZhi: "Метка принудительного исполнения",
      qangZhiZX: "Метка принудительного аннулирования",
      qianChu: "Метка переселения",
      queRenWF: "Метка признания незаконности",
      queRenWX: "Метка признания недействительности",
      shiXin: "Метка потери доверия",
      tingChanTY: "Метка приостановки производства",
      zhongBen: "Метка завершения текущей исполнительной процедуры",
      zhongZhi: "Метка приостановления исполнения",
      zjzx: "Метка завершения исполнения",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основная категория",
      ruleSubType: "Подкатегория",
      shixinId: "ID Уведомления о недоверии",
      body: "Содержимое ",
      caseNo: "Номер дела",
      court: "Название суда ",
      postTime: "Дата публикации",
      sortTime: "Дата регистрации дела",
      yiwu: "Обязанности",
      yjCode: "Номер документа основания",
      yjdw: "Организация, предоставившая основание",
      partys: "Стороны",
      datatype: "Тип данных",
      age: "Возраст",
      caseNoKwordT: "Ключевое слово номера дела",
      idcardNo: "Номер удостоверения личности",
      jtqx: "Конкретная ситуация",
      lxqkT: "Статус выполнения",
      money: "Сумма, связанная с делом",
      partyType: "Тип стороны",
      pname: "Название стороны",
      province: "Провинция",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основная категория",
      ruleSubType: "Подкатегория ",
      zxggId: "ID Уведомления об исполнении",
      address: "Адрес",
      body: "Содержимое ",
      caseNo: "Номер дела ",
      closeDate: "Дата завершения дела",
      court: "Название суда",
      proposer: "Заявитель",
      sortTime: "Дата регистрации дела",
      title: "Заголовок",
      yjCode: "Номер документа основания",
      yjdw: "Организация, предоставившая основание",
      partys: "Стороны",
      datatype: "Тип данных",
      caseStateT: "Статус дела",
      caseNoKwordT: "Ключевое слово номера дела",
      execMoney: "Сумма исполнения",
      idcardNo: "Номер удостоверения личности",
      partyType: "Тип стороны",
      pname: "Название стороны",
      signalDesc: "Описание сигнала ",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основная категория",
      ruleSubType: "Подкатегория",
      ktggId: "ID уведомления о судебном заседании",
      body: "Содержимое",
      caseNo: "Номер дела",
      court: "Суд",
      courtroom: "Зал суда",
      judge: "Судья",
      organizer: "Организатор",
      sortTime: "Время заседания",
      title: "Заголовок ",
      partys: "Стороны ",
      datatype: "Тип данных",
      caseCauseT: "Основное содержание дела",
      caseNoKwordT: "Номер дела",
      courtRankT: "Уровень суда ",
      courtTypeT: "Тип суда",
      partyPositionT: "Позиция в судебном процессе (первая инстанция)",
      partyTitleT: "Текущий статус",
      partyType: "Тип субъекта",
      pname: "Имя участника",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основная категория",
      ruleSubType: "Подкатегория",
      ajlcId: "ID процесса дела",
      actionObject: "Предмет иска",
      body: "Содержание",
      caseNo: "Номер дела ",
      courtS: "Суд",
      organizer: "Организатор",
      sortTime: "Время дела ",
      title: "Заголовок ",
      partys: "Участники",
      datatype: "Тип данных",
      ajlcStatusT: "Статус дела",
      caseCauseT: "Основное содержание дела",
      caseNoKwordT: "Код дела",
      courtRankT: "Уровень суда",
      courtTypeT: "Тип суда",
      partyPositionT: "Позиция участника (первая инстанция)",
      partyTitleT: "Текущий статус",
      partyType: "Тип субъекта",
      pname: "Имя участника",
      trialProcedureS: "Статус рассмотрения ",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основная категория",
      ruleSubType: "Подкатегория",
      body: "Содержание",
      caseNo: "Номер дела",
      court: "Название суда",
      dataType: "Тип данных",
      fyggId: "ID судебного объявления",
      layout: "Макет",
      partys: "Участники",
      sortTime: "Время подачи дела",
      title: "Заголовок",
      caseCauseT: "Основное содержание дела",
      caseNoKwordT: "Код дела",
      courtRankT: "Уровень суда",
      courtTypeT: "Тип суда",
      ggTypeT: "Тип объявления",
      partyPositionT: "Позиция участника (первая инстанция)",
      partyTitleT: "Текущий статус",
      partyType: "Тип субъекта",
      pname: "Имя участника",
      ruleMainType: "Основной тип",
      ruleSubType: "Подтип",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      bgtId: "ID платформы обнародования",
      body: "Содержание",
      caseNo: "Номер дела",
      court: "Название суда",
      proposer: "Заявитель",
      sortTime: "Время подачи дела",
      title: "Заголовок",
      yiju: "Основание",
      yjCode: "Код основания",
      partys: "Участники",
      address: "Адрес",
      caseCauseT: "Основное содержание дела",
      caseNoKwordT: "Код дела",
      execMoney: "Сумма иска",
      idcardNo: "Номер удостоверения личности",
      partyType: "Тип субъекта",
      pname: "Имя участника",
      signalDesc: "Описание сигнала",
      signalRating: "Уровень сигнала",
      signalRuleNo: "Код правила",
      signalRuleVersion: "Версия правила",
      ruleMainType: "Основной тип",
      ruleSubType: "Подтип",
      sifacdkId: "ID судебного обнаружения, замораживания и ареста",
      body: "Содержание",
      sortTime: "Время рассмотрения",
      eventDate: "Дата события",
      objectName: "Наименование объекта",
      court: "Суд",
      pname: "Участник",
      title: "Заголовок",
      action: "Категория актива",
      caseNo: "Номер дела",
      objectType: "Тип объекта",
      postTime: "Время публикации",
      money: "Сумма (в юанях)",
      dataType: "Тип данных",
      pmggId: "ID объявления о продаже с аукциона",
      title: "Заголовок объявления о продаже",
      pname: "Владелец объекта аукциона",
      idCardNo: "Номер удостоверения личности владельца",
      address: "Подробный адрес объекта",
      auctionAmount: "Начальная цена объекта",
      auctionType: "Тип объекта",
      lot: "Название объекта",
      lotInfo: "Подробное описание объекта",
      powerNo: "Номер правового документа на объект",
      measure: "Площадь объекта",
      postTime: "Дата публикации",
      sortTime: "Дата аукциона",
      court: "Суд, выполняющий продажу",
      body: "Исходный код | Содержание",
      dataType: "Тип данных",
    },
  },
  risk_control: {
    title: "Контроль над рисками",
    search: "Поиск",
    search_keyword_placeholder: "Единый социальный кредитный код, Регистрационный номер",
    searching: "Идет поиск",
    no_results: "Результатов не найдено",
    history: "История",
    search_input: "Поиск",
    view: "Просмотр",
    billing: {
      price: "Цена",
      your_balance: "Ваш баланс",
      not_enough_funds: "Недостаточно средств",
      not_enough_funds_search:
        "У вас недостаточно средств для поиска/покупки этой информации.",
      buy_search: "Купить и искать?",
      search_buy: "Хотите искать/купить эту информацию?",
    },
    vocabulary: {
      KeyNo: "Номер ключа",
      Name: "Имя",
      CreditCode: "Кредитный код",
      OperName: "Название операции",
      Status: "Статус",
      StartDate: "Дата начала",
      RegistCapi: "Регистрационный капитал",
      RealCapi: "Реальный капитал",
      OrgNo: "Номер организации",
      No: "Нет",
      TaxNo: "Налоговый номер",
      EconKind: "Вид экономики",
      TermStart: "Начало срока",
      TermEnd: "Конец срока",
      TaxpayerType: "Тип налогоплательщика",
      PersonScope: "Область действия лица",
      InsuredCount: "Количество застрахованных",
      CheckDate: "Дата проверки",
      AreaCode: "Код города",
      Area: "Область",
      Province: "Провинция",
      City: "Город",
      County: "Округ",
      BelongOrg: "Принадлежность к организации",
      ImExCode: "Код им. экс.",
      Industry: "Отрасль",
      IndustryCode: "Код отрасли",
      SubIndustryCode: "Код подотрасли",
      SubIndustry: "Код подотрасли",
      MiddleCategoryCode: "Код средней категории",
      MiddleCategory: "Средняя категория",
      SmallCategoryCode: "Код малой категории",
      SmallCategory: "Малая категория",
      EnglishName: "Английское имя",
      Address: "Адрес",
      AnnualAddress: "Годовой адрес",
      Scope: "Область",
      EntType: "Тип предприятия",
      ImageUrl: "URL изображения",
      RevokeInfo: "Информация об отзыве",
      OriginalName: "Исходное имя",
      ChangeDate: "Дата изменения",
      StockInfo: "Информация о запасах",
      ContactInfo: "Контактная информация",
      WebSiteList: "Список веб-сайтов",
      Email: "Электронная почта",
      MoreEmailList: "Дополнительный список адресов электронной почты",
      Source: "Источник",
      Tel: "Тел.",
      MoreTelList: "Дополнительный список телефонов",
      LongLat: "Долгота Широта",
      Longitude: "Долгота",
      Latitude: "Широта",
      BankInfo: "Банковская информация",
      Bank: "Банк",
      BankAccount: "Банковский счет",
      IsSmall: "Небольшой",
      Scale: "Масштаб",
      QccIndustry: "Qcc Отрасль",
      AName: "Имя A",
      BName: "Имя B",
      CName: "Имя C",
      DName: "Имя D",
      IsOfficialEnglish: "Официальный английский",
      PartnerList: "Список партнеров",
      StockName: "Имя акций",
      StockType: "Тип акций",
      StockPercent: "Процент акций",
      ShouldCapi: "Должен ли Capi",
      ShoudDate: "Дата Shoud",
      StakeDate: "Дата ставки",
      PubPartnerList: "Список партнеров Pub",
      EmployeeList: "Список сотрудников",
      Job: "Работа",
      PubEmployeeList: "Список сотрудников Pub",
      BranchList: "Список филиалов",
      ChangeList: "Список изменений",
      ProjectName: "Название проекта",
      BeforeList: "Список до",
      AfterList: "Список после",
      TagList: "Список тегов",
      Type: "Тип",
      Parent: "Родитель",
      Beneficiary: "Бенефициар",
      ActualControllerList: "Фактический список контролеров",
      FinalBenefitPercent: "Финальный процент выгоды",
      ControlPercent: "Процент контроля",
      IsActual: "Фактический",
      EmergingIndustyList: "Список развивающихся отраслей",
      PrimaryCode: "Первичный код",
      PrimaryDes: "Первичный дез",
      SecondaryList: "Вторичный список",
      SecondaryCode: "Вторичный код",
      SecondaryDes: "Вторичный дез",
      TertiaryList: "Третичный список",
      TertiaryCode: "Третичный код",
      TertiaryDes: "Третичный дез",
      GroupInfo: "Информация о группе",
      GroupId: "Идентификатор группы",
      Logo: "Логотип",
      InvestmentList: "Список инвестиций",
      FundedRatio: "Коэффициент финансирования",
      ProductList: "Список продуктов",
      RoundDesc: "Описание раунда",
      Location: "Местоположение",
      Description: "Описание",
      AdminLicenseList: "Список лицензий администратора",
      LicensDocNo: "Номер документа лицензий",
      LicensDocName: "Название документа лицензий",
      ValidityFrom: "Действительность От",
      ValidityTo: "Действительность до",
      LicensOffice: "Лицензионный офис",
      LicensContent: "Содержимое лицензий",
      ApproveSiteList: "Утверждение списка сайтов",
      WebAddress: "Веб-адрес",
      DomainName: "Доменное имя",
      LesenceNo: "Номер лицензии",
      AuditDate: "Дата аудита",
      SpotCheckList: "Выборочный контрольный список",
      ExecutiveOrg: "Исполнительная организация",
      Date: "Дата",
      Consequence: "Последствие",
      TaxCreditList: "Список налоговых льгот",
      Year: "Год",
      Level: "Уровень",
      Org: "Организация",
      ShiXin: "Ши Синь",
      ZhiXing: "Чжи Син",
      AdminPenalty: "Административный штраф",
      Exception: "Исключение",
      ChattelMortgage: "Ипотека на движимое имущество",
      Liquidation: "Ликвидация",
      EquityPledge: "Залог капитала",
      SeriousIllegal: "Серьезное противоправное",
      EquityFreeze: "Замораживание капитала",
      JudicialSale: "Судебная продажа",
      Bankruptcy: "Банкротство",
      Sumptuary: "Расходы на имущество",
      EnvPunishment: "Наказание за нарушение экологического законодательства",
      TaxOweNotice: "Уведомление о налоговой задолженности",
      TaxIllegal: "Налоговый незаконный",
      TaxAbnormal: "Налоговый аномальный",
    },
  },
  business_score: {
    title: "Бизнес Оценка",
    search: "Поиск",
    search_keyword_placeholder: "Код социального кредита, регистрационный код",
    searching: "Поиск...",
    no_results: "Результаты не найдены",
    history: "История",
    search_input: "Поисковый запрос",
    view: "Просмотр",
    language: "язык",
    year: "Год",
    vocabulary: {
      year: "Год",
      totalAsset: "Общие активы",
      totalEquity: "Собственный капитал",
      totalSale: "Общий объем продаж",
      primarySale: "Основные продажи",
      netProfits: "Чистая прибыль",
      totalProfits: "Общая прибыль",
      totalTax: "Общий налог",
      totalLiability: "Обязательства",
      tel: "Телефон",
      postalcode: "Почтовый индекс",
      dom: "Адрес",
      email: "Электронная почта",
    }
  },
  case_filling_info: {
    title: "Информация о подаче дела",
    search: "Поиск",
    search_keyword_placeholder: "Код социального кредита, регистрационный код",
    searching: "Поиск...",
    no_results: "Результаты не найдены",
    history: "История",
    search_input: "Поисковый запрос",
    view: "Просмотр",
    page: "Страница",
    date: "Дата",
    next: "Следующий",
    back: "Назад",
    vocabulary: {
      court: "Суд",
      punish_date: "Дата наказания",
      case_reason: "Причина дела",
      prosecutors: "Истцы",
      defendants: "Ответчики",
      search_type: "Поиск по",
      defendant: "Ответчику",
      prosecutor: "Истцу"
    }
  },
  contragent_search: {
    date: "Дата",
    search_text: "Поисковой запрос",
    service_code: "Название сервиса",
    do_bulk: "Групповой запрос",
    annual_report_description:
      "Описание: годовой отчет компании включает в себя основную информацию, заявленную самой компанией, информацию о веб-сайте или интернет-магазине, информацию о спонсорах и вкладах в капитал, информацию о состоянии корпоративных активов и изменениях в капитале и т. д.",
    enterprise_risk_scan_description:
      "Описание: Текущий интерфейс включает в себя как деловую информацию (включая деловые интервью, информацию об акционерах (включая соотношение долей), ключевой персонал, филиалы, информацию об изменениях, отраслевую классификацию, корпоративные портреты и т. д.), так и информацию о корпоративных рисках, такую как как административное дела, неправомерные хозяйственные операции, недобросовестные лица, подлежащие ответственности, лица, подлежащие наказанию, ипотека движимого имущества, ликвидация, залог акций, выборочная проверка, налоговый кредит и другая информация. Комплексный запрос измерения позволяет получить всю информацию о предприятии в одном запросе.",
    annual_report: "Годовой отчет",
    annual_report_no_logo: "Годовой отчет (Без логотипа)",
    enterprise_risk_scan: "Корпоративные риски",
    enterprise_risk_scan_no_logo: "Корпоративные риски (Без логотипа)",
    enterprise_basic_information: "Основная информация о предприятии",
    AssetsData: "Данные активов",
    SocialInsurance: "Социальное страхование",
    BasicInfo: "Базовая информация",
    ChangeList: "Список изменений",
    InvestInfoList: "Список информации об инвестициях",
    PartnerList: "Список партнеров",
    ProvideAssuranceList: "Предоставить список гарантий",
    StockChangeList: "Список изменений запасов",
    WebSiteList: "Список веб-сайтов",
    AdministrationLicenseList: "Информация об административном лицензировании",
    BranchList: "Список филиалов",
    EmployeeList: "Список сотрудников",
    No: "Номер",
    Year: "Год",
    PublishDate: "Дата публикации",
    TotalAssets: "Итого активы",
    TotalOwnersEquity: "Общий собственный капитал владельцев",
    GrossTradingIncome: "Валовой торговый доход",
    MainBusinessIncome: "Основной доход от бизнеса",
    NetProfit: "Чистая прибыль",
    TotalTaxAmount: "Общая сумма налога",
    TotalLiabilities: "Итого обязательства",
    BankingCredit: "Банковский кредит",
    GovernmentSubsidy: "Государственная субсидия",
    UrbanBasicIns: "Городские базовые ины",
    EmployeeBasicIns: "Основные входы для сотрудников",
    MaternityIns: "Материнство",
    UnemploymentIns: "Безработица Инс",
    IndustrialInjuryIns: "Производственные травмы",
    EntUrbanBasicInsNum: "Ent Urban Basic Ins Num",
    EntUnemploymentInsNum: "Энт Безработица Ins Num",
    EntEmployeeBasicInsNum: "Ent Сотрудник Базовый Ins Num",
    EntIndustrialInjuryInsNum: "Ent Производственная травма Ins Num",
    EntMaternityInsNum: "Энт Материнство Ins Num",
    ActUrbanBasicInsAmount: "Акт Городские Базовые Ins Сумма",
    ActUnemploymentInsAmount: "Закон о безработице Ins Сумма",
    ActEmployeeBasicInsAmount: "Сумма основных взносов действующего сотрудника",
    ActIndustrialInjuryInsAmount: "Закон о сумме производственного травматизма",
    ActMaternityInsAmount: "Сумма акта по беременности и родам",
    OweUrbanBasicInsAmount:
      "Сумма задолженностей по городским базовым платежам",
    OweUnemploymentInsAmount: "Долг по безработице",
    OweIndustrialInjuryInsAmount:
      "Сумма задолженностей по производственным травмам",
    OweMaternityInsAmount: "Долг по материнской плате",
    RegNo: "Регистрационный номер",
    CompanyName: "Название компании",
    CreditCode: "Кредитный код",
    OperatorName: "Имя оператора",
    ContactNo: "Контактный номер",
    PostCode: "Почтовый индекс",
    Address: "Адрес",
    EmailAddress: "Адрес электронной почты",
    IsStockRightTransfer: "Передача прав на акции",
    Status: "Статус",
    HasWebSite: "Имеет веб-сайт",
    HasNewStockOrByStock: "Есть новые акции или по акциям",
    EmployeeCount: "Количество сотрудников",
    BelongTo: "Принадлежит",
    CapitalAmount: "Сумма капитала",
    HasProvideAssurance: "Имеет гарантию",
    OperationPlaces: "Места операций",
    MainType: "Основной тип",
    OperationDuration: "Продолжительность операции",
    IfContentSame: "Если содержимое такое же",
    DifferentContent: "Другой контент",
    GeneralOperationItem: "Элемент общей операции",
    ApprovedOperationItem: "Утвержденный элемент операции",
    No: "Номер",
    ChangeName: "Изменить имя",
    Before: "До",
    After: "После",
    ChangeDate: "Дата изменения",
    Name: "Имя",
    ShouldCapi: "Capi",
    ShouldDate: "Дата",
    ShouldType: "Тип",
    RealCapi: "Настоящий Capi",
    RealDate: "Реальная дата",
    RealType: "Настоящий тип",
    Form: "Форма",
    InvestmentRatio: "Коэффициент инвестиций",
    KeyNo: "Ключ №",
    ShareholdingRatio: "Коэффициент владения",
    Creditor: "Кредитор",
    Debtor: "Должник",
    CreditorCategory: "Категория кредитора",
    CreditorAmount: "Сумма кредитора",
    FulfillObligation: "Выполнить Обязательство",
    AssuranceDurn: "Гарантия",
    AssuranceType: "Тип гарантии",
    AssuranceScope: "Объем гарантии",
    Type: "Тип",
    WebSite: "Веб-сайт",
    EndDate: "Дата окончания",
    principal: "основной",
    Job: "Работа",
    CerNo: "Cer No",
    ScertName: "Имя сертификата",
    ers_AreaCode: "Код города",
    ers_RecCap: "Заголовок записи",
    ers_EntType: "Характер деятельности предприятия",
    ers_ImageUrl: "URL изображения",
    ers_StockType: "Тип акции",
    ers_StockNumber: "Биржевой код",
    ers_IsOnStock: "Торгуются ли акции на бирже",
    ers_OrgNo: "Номер организации",
    ers_CheckDate: "Дата проверки",
    ers_TeamEnd: "Окончание регистрации",
    ers_TermStart: "Дата регистрации компании",
    ers_Scope: "Область",
    ers_Address: "Адрес",
    ers_EconKind: "Экономичный вид",
    ers_RegistCapi: "Зарегистрировать Capi",
    ers_CreditCode: "Кредитный код",
    ers_UpdatedDate: "Дата обновления",
    ers_Province: "Провинция",
    ers_Status: "Cтатус компании",
    ers_EndDate: "Дата окончания",
    ers_StartDate: "Дата начала",
    ers_OperName: "Имя оператора",
    ers_OperId: "Идентификатор оператора",
    ers_BelongOrg: "Принадлежит организации",
    ers_No: "Характер деятельности предприятия",
    ers_Name: "Имя",
    ers_KeyNo: "Ключ №",
    ers_IXCode: "Импортно-экспортный код компании",
    ers_PersonScope: "Область пользователя",
    ers_EnglishName: "Английское имя",
    ers_InsuredCount: "Счетчик застрахованных",
    ers_pi_Name: "Имя",
    ers_pi_Province: "Провинция",
    ers_pi_Liandate: "Лиандат",
    ers_pi_CaseNo: "Дело №",
    ers_pi_DocNo: "Номер документа",
    ers_pi_PenaltyType: "Тип штрафа",
    ers_pi_OfficeName: "Название офиса",
    ers_pi_Content: "Содержимое",
    ers_pi_PenaltyDate: "Дата штрафа",
    ers_pi_PublicDate: "Дата публикации",
    ers_pi_Remark: "Отметка",
    ers_pi_AddReason: "Причина добавления",
    ers_pi_AddDate: "Дата добавления",
    ers_pi_RomoveReason: "Причина удаления",
    ers_pi_RemoveDate: "Дата удаления",
    ers_pi_DecisionOffice: "Офис решения",
    ers_pi_RemoveDecisionOffice: "Офис решения удаления",
    ers_pi_Anno: "Анно",
    ers_pi_Orgno: "Оргно",
    ers_pi_Execute: "Выполнить",
    ers_pi_Publicdate: "Дата публикации",
    ers_pi_Executestatus: "Executeststatus",
    ers_pi_Actionremark: "Actionremark",
    ers_pi_Executegov: "Исполнитель",
    ers_pi_Id: "Идентификатор",
    ers_pi_Sourceid: "Источник",
    ers_pi_ExecuteGov: "Виполнено правительство",
    ers_pi_Biaodi: "Biaodi",
    ers_pi_Status: "Статус",
    ers_pi_PartyCardNum: "Номер партийной карты",
    ers_pi_Updatedate: "Дата обновления",
    ers_pi_RegisterNo: "Номер регистрации",
    ers_pi_RegisterDate: "Дата регистрации",
    ers_pi_RegisterOffice: "Регистрационный офис",
    ers_pi_DebtSecuredAmount: "Сумма обеспечения долга",
    ers_pi_Leader: "Лидер",
    ers_pi_Member: "Член",
    ers_pi_CompanyId: "Идентификатор компании",
    ers_pi_RegistNo: "Регистрационный номер",
    ers_pi_Pledgor: "Залогодатель",
    ers_pi_PledgorNo: "Номер залогодателя",
    ers_pi_Pledge: "Залог",
    ers_pi_PledgeNo: "Залог №",
    ers_pi_PledgedAmount: "Сумма залога",
    ers_pi_RegDate: "Дата регистрации",
    ers_pi_No: "№",
    ers_pi_ExecutiveOrg: "Исполнительная организация",
    ers_pi_Type: "Тип",
    ers_pi_Date: "Дата",
    ers_pi_Consequence: "Последствие",
    ers_pi_Year: "Год",
    ers_pi_Level: "кредитный класс",
    ers_pi_CompanyName: "Название компании",
    ers_pi_Link: "Ссылка",
    ers_pi_ImageUrl: "URL-адрес изображения",
    ers_pi_Domain: "Домен",
    ers_pi_Tags: "Теги",
    ers_pi_Description: "Описание",
    ers_pi_Category: "Категория",
    ers_pi_LicensesDocNo: "Лицензии № документа",
    ers_pi_LicensesDocName: "Имя документа лицензий",
    ers_pi_ValidityFrom: "Дата выдачи",
    ers_pi_ValidityTo: "Действителен до",
    ers_pi_LicensOffice: "Офис лицензий",
    ers_pi_LicensesContent: "Содержимое лицензий",
    ers_pi_OwnerName: "Имя владельца",
    ers_pi_CaseReason: "Причина обращения",
    ers_pi_KeyNo: "Номер ключа",
    ers_pi_StockName: "Название акции",
    ers_pi_StockType: "Тип акции",
    ers_pi_StockPercent: "Акции в процентах",
    ers_pi_ShouldCapi: "Обязательства Капи",
    ers_pi_ShouldDate: "Дата обязательств",
    ers_pi_InvestType: "Тип инвестиции",
    ers_pi_InvestName: "Название инвестиции",
    ers_pi_RealCapi: "Реальный Capi",
    ers_pi_CapiDate: "Capi Дата",
    ers_pi_TagsList: "Список тегов",
    ers_pi_FinalBenefitPercent: "Конечный процент выгоды",
    ers_pi_RelatedProduct: "Сопутствующий товар",
    ers_pi_RelatedOrg: "Связанная организация",
    ers_pi_Job: "Работа",
    ers_pi_RegNo: "Номер регистрации",
    ers_pi_BelongOrg: "Принадлежит организации",
    ers_pi_CreditCode: "Кредитный код",
    ers_pi_OperName: "Имя оператора",
    ers_pi_ProjectName: "Название проекта",
    ers_pi_BeforeContent: "Перед содержимым",
    ers_pi_AfterContent: "После содержимого",
    ers_pi_ChangeDate: "Дата изменения",
    ers_pi_name: "имя",
    ers_pi_WebSite: "Веб-сайт",
    ers_pi_PhoneNumber: "Номер телефона",
    ers_pi_Email: "Электронная почта",
    ers_pi_IndustryCode: "Код отрасли",
    ers_pi_Industry: "Промышленность",
    ers_pi_SubIndustryCode: "Код подотрасли",
    ers_pi_SubIndustry: "Подотрасль",
    ers_pi_MiddleCategoryCode: "Код средней категории",
    ers_pi_MiddleCategory: "Средняя категория",
    ers_pi_SmallCategoryCode: "Код малой категории",
    ers_pi_SmallCategory: "Малая категория",
    ers_pi_ContactNo: "Контактный номер",
    ers_pi_EmailAddress: "Адрес электронной почты",
    ers_pi_Address: "Адрес",
    ers_Liquidation: "Ликвидация",
    ers_ContactInfo: "Контактная информация",
    ers_Industry: "Промышленность",
    ers_Area: "Площадь",
    ers_area_Province: "Провинция",
    ers_area_City: "Город",
    ers_area_County: "округ",
    ers_rev_CancelDate: "Дата отмены",
    ers_rev_CancelReason: "Причина отмены",
    ers_rev_RevokeDate: "Дата отзыва",
    ers_rev_RevokeReason: "Причина отзыва",
    ers_RevokeInfo: "Отозвать информацию",
    ers_ind_IndustryCode: "Код отрасли",
    ers_ind_Industry: "Промышленность",
    ers_ind_SubIndustryCode: "Код подотрасли",
    ers_ind_SubIndustry: "Подотрасль",
    ers_ind_MiddleCategoryCode: "Код средней категории",
    ers_ind_MiddleCategory: "Средняя категория",
    ers_ind_SmallCategoryCode: "Код малой категории",
    ers_ind_SmallCategory: "Малая категория",
    ers_PermissionInfo: "Административное лицензирование",
    ers_Penalty: "Штраф",
    ers_Exceptions: "Ненормальные бизнес-операции (включение в реестр)",
    ers_ShiXinItems: "Нарушения договорных обязательств",
    ers_ZhiXingItems: "Предметы Чжи Син",
    ers_MPledge: "Закладная на недвижимость",
    ers_Pledge: "Залог",
    ers_SpotCheck: "Выборочная проверка",
    ers_CompanyTaxCreditItems: "Налоговый кредитный рейтинг",
    ers_CompanyProducts: "Продукты компании",
    ers_PermissionEciInfo: "Административное лицензирование",
    ers_PenaltyCreditChina:
      "Административное наказание (Промышленно-торговое бюро)",
    ers_Partners: "Партнеры",
    ers_Employees: "Сотрудники",
    ers_Branches: "Дочерняя компания",
    ers_ChangeRecords: "Изменить записи",
    ers_EmergingIndustyList: "Отраслевая классификация",
    ers_TagList: "Логотипы",
    ers_ARContactList:
      "Контактная информация для получения последнего корпоративного годового отчета",
    ers_OriginalName: "Исходное имя",

    company_info_status_1: "действующая компания",
    company_info_status_2: "не осуществляет деятельность по адресу регистрации",
    company_info_status_3: "аннулирование бизнес-статуса",
    company_info_status_4: "предприятие больше не существует",
    company_info_status_5: "приостановлена",
    company_info_status_6: "ликвидирована",
    TotalProfit: "Общая прибыль",

    // ActEmployeeBasicInsAmount: 'Act Employee Basic Ins Amount',
    // ActIndustrialInjuryInsAmount: 'Act Industrial Injury Ins Amount',
    // ActMaternityInsAmount: 'Act Maternity Ins Amount',
    // OweUrbanBasicInsAmount: 'Owe Urban Basic Ins Amount',
    // OweUnemploymentInsAmount: 'Owe Unemployment Ins Amount',
    // OweIndustrialInjuryInsAmount: 'Owe Industrial Injury Ins Amount',
    // OweMaternityInsAmount: 'Owe Maternity Ins Amount',
    // RegNo: 'Reg No',
    // CompanyName: 'Company  Name',
    // CreditCode: 'Credit Code',
    // OperatorName: 'Operator Name',
    // ContactNo: 'Contact No',
    // PostCode: 'Post Code',
    // Address: 'Address',
    // EmailAddress: 'Email Address',
    // IsStockRightTransfer: 'Is Stock Right Transfer',
    // Status: 'Status',
    // HasWebSite: 'Has Web Site',
    // HasNewStockOrByStock: 'Has New Stock Or By Stock',
    // EmployeeCount: 'Employee Count',
    // BelongTo: 'Belong To',
    // CapitalAmount: 'Capital Amount',
    // HasProvideAssurance: 'Has Provide Assurance',
    // OperationPlaces: 'Operation Places',
    // MainType: 'Main Type',
    // OperationDuration: 'Operation Duration',
    // IfContentSame: 'If Content Same',
    // DifferentContent: 'Different Content',
    // GeneralOperationItem: 'General Operation Item',
    // ApprovedOperationItem: 'Approved Operation Item',
    // No: 'No',
    // ChangeName: 'Change Name',
    // Before: 'Before',
    // After: 'After',
    // ChangeDate: 'Change Date',
    // Name: 'Name',
    // ShouldCapi: 'Should Capi',
    // ShouldDate: 'Should Date',
    // ShouldType: 'Should Type',
    // RealCapi: 'Real Capi',
    // RealDate: 'Real Date',
    // RealType: 'Real Type',
    // Form: 'Form',
    // InvestmentRatio: 'Investment Ratio',
    // KeyNo: 'Key No',
    // ShareholdingRatio: 'Shareholding Ratio',
    // Creditor: 'Creditor',
    // Debtor: 'Debtor',
    // CreditorCategory: 'Creditor Category',
    // CreditorAmount: 'Creditor Amount',
    // FulfillObligation: 'Fulfill Obligation',
    // AssuranceDurn: 'Assurance Durn',
    // AssuranceType: 'Assurance Type',
    // AssuranceScope: 'Assurance Scope',
    // Type: 'Type',
    // WebSite: 'Web Site',
    // EndDate: 'End Date',
    // principal: 'principal',
    // Job: 'Job',
    // CerNo: 'Cer No',
    // ScertName: 'Scert Name',
    // ers_AreaCode: 'Area Code',
    // ers_RecCap: 'Rec Cap',
    // ers_EntType: 'Ent Type',
    // ers_ImageUrl: 'Image Url',
    // ers_StockType: 'Stock Type',
    // ers_StockNumber: 'Stock Number',
    // ers_IsOnStock: 'Is On Stock',
    // ers_OrgNo: 'Org No',
    // ers_CheckDate: 'Check Date',
    // ers_TeamEnd: 'Team End',
    // ers_TermStart: 'Term Start',
    // ers_Scope: 'Scope',
    // ers_Address: 'Address',
    // ers_EconKind: 'Econ Kind',
    // ers_RegistCapi: 'Regist Capi',
    // ers_CreditCode: 'Credit Code',
    // ers_UpdatedDate: 'Updated Date',
    // ers_Province: 'Province',
    // ers_Status: 'Status',
    // ers_EndDate: 'End Date',
    // ers_StartDate: 'Start Date',
    // ers_OperName: 'Oper Name',
    // ers_OperId: 'Oper Id',
    // ers_BelongOrg: 'Belong Org',
    // ers_No: 'No',
    // ers_Name: 'Name',
    // ers_KeyNo: 'Key No',
    // ers_IXCode: 'I X Code',
    // ers_PersonScope: 'Person Scope',
    // ers_EnglishName: 'English Name',
    // ers_InsuredCount: 'Insured Count',
    // ers_pi_Name: 'Name',
    // ers_pi_Province: 'Province',
    // ers_pi_Liandate: 'Liandate',
    // ers_pi_CaseNo: 'Case No',
    // ers_pi_DocNo: 'Doc No',
    // ers_pi_PenaltyType: 'Penalty Type',
    // ers_pi_OfficeName: 'Office Name',
    // ers_pi_Content: 'Content',
    // ers_pi_PenaltyDate: 'Penalty Date',
    // ers_pi_PublicDate: 'Public Date',
    // ers_pi_Remark: 'Remark',
    // ers_pi_AddReason: 'Add Reason',
    // ers_pi_AddDate: 'Add Date',
    // ers_pi_RomoveReason: 'Romove Reason',
    // ers_pi_RemoveDate: 'Remove Date',
    // ers_pi_DecisionOffice: 'Decision Office',
    // ers_pi_RemoveDecisionOffice: 'Remove Decision Office',
    // ers_pi_Anno: 'Anno',
    // ers_pi_Orgno: 'Orgno',
    // ers_pi_Execute: 'Execute',
    // ers_pi_Publicdate: 'Publicdate',
    // ers_pi_Executestatus: 'Executestatus',
    // ers_pi_Actionremark: 'Actionremark',
    // ers_pi_Executegov: 'Executegov',
    // ers_pi_Id: 'Id',
    // ers_pi_Sourceid: 'Sourceid',
    // ers_pi_ExecuteGov: 'Execute Gov',
    // ers_pi_Biaodi: 'Biaodi',
    // ers_pi_Status: 'Status',
    // ers_pi_PartyCardNum: 'Party Card Num',
    // ers_pi_Updatedate: 'Updatedate',
    // ers_pi_RegisterNo: 'Register No',
    // ers_pi_RegisterDate: 'Register Date',
    // ers_pi_RegisterOffice: 'Register Office',
    // ers_pi_DebtSecuredAmount: 'Debt Secured Amount',
    // ers_pi_Leader: 'Leader',
    // ers_pi_Member: 'Member',
    // ers_pi_CompanyId: 'Company Id',
    // ers_pi_RegistNo: 'Regist No',
    // ers_pi_Pledgor: 'Pledgor',
    // ers_pi_PledgorNo: 'Pledgor No',
    // ers_pi_Pledge: 'Pledge',
    // ers_pi_PledgeNo: 'Pledge No',
    // ers_pi_PledgedAmount: 'Pledged Amount',
    // ers_pi_RegDate: 'Reg Date',
    // ers_pi_No: 'No',
    // ers_pi_ExecutiveOrg: 'Executive Org',
    // ers_pi_Type: 'Type',
    // ers_pi_Date: 'Date',
    // ers_pi_Consequence: 'Consequence',
    // ers_pi_Year: 'Year',
    // ers_pi_Level: 'Level',
    // ers_pi_CompanyName: 'Company Name',
    // ers_pi_Link: 'Link',
    // ers_pi_ImageUrl: 'Image Url',
    // ers_pi_Domain: 'Domain',
    // ers_pi_Tags: 'Tags',
    // ers_pi_Description: 'Description',
    // ers_pi_Category: 'Category',
    // ers_pi_LicensesDocNo: 'Licenses Doc No',
    // ers_pi_LicensesDocName: 'Licenses Doc Name',
    // ers_pi_ValidityFrom: 'Validity From',
    // ers_pi_ValidityTo: 'Validity To',
    // ers_pi_LicensOffice: 'Licens Office',
    // ers_pi_LicensesContent: 'Licenses Content',
    // ers_pi_OwnerName: 'Owner Name',
    // ers_pi_CaseReason: 'Case Reason',
    // ers_pi_KeyNo: 'Key No',
    // ers_pi_StockName: 'Stock Name',
    // ers_pi_StockType: 'Stock Type',
    // ers_pi_StockPercent: 'Stock Percent',
    // ers_pi_ShouldCapi: 'Should Capi',
    // ers_pi_ShouldDate: 'Should Date',
    // ers_pi_InvestType: 'Invest Type',
    // ers_pi_InvestName: 'Invest Name',
    // ers_pi_RealCapi: 'Real Capi',
    // ers_pi_CapiDate: 'Capi Date',
    // ers_pi_TagsList: 'Tags List',
    // ers_pi_FinalBenefitPercent: 'Final Benefit Percent',
    // ers_pi_RelatedProduct: 'Related Product',
    // ers_pi_RelatedOrg: 'Related Org',
    // ers_pi_Job: 'Job',
    // ers_pi_RegNo: 'Reg No',
    // ers_pi_BelongOrg: 'Belong Org',
    // ers_pi_CreditCode: 'Credit Code',
    // ers_pi_OperName: 'Oper Name',
    // ers_pi_ProjectName: 'Project Name',
    // ers_pi_BeforeContent: 'Before Content',
    // ers_pi_AfterContent: 'After Content',
    // ers_pi_ChangeDate: 'Change Date',
    // ers_pi_name: 'name',
    // ers_pi_WebSite: 'Web Site',
    // ers_pi_PhoneNumber: 'Phone Number',
    // ers_pi_Email: 'Email',
    // ers_pi_IndustryCode: 'Industry Code',
    // ers_pi_Industry: 'Industry',
    // ers_pi_SubIndustryCode: 'Sub Industry Code',
    // ers_pi_SubIndustry: 'Sub Industry',
    // ers_pi_MiddleCategoryCode: 'Middle Category Code',
    // ers_pi_MiddleCategory: 'Middle Category',
    // ers_pi_SmallCategoryCode: 'Small Category Code',
    // ers_pi_SmallCategory: 'Small Category',
    // ers_pi_ContactNo: 'Contact No',
    // ers_pi_EmailAddress: 'Email Address',
    // ers_pi_Address: 'Address',
    // ers_Liquidation: 'Liquidation',
    // ers_ContactInfo: 'Contact Info',
    // ers_Industry: 'Industry',
    // ers_Area: 'Area',
    // ers_area_Province: 'Province',
    // ers_area_City: 'City',
    // ers_area_County: 'County',
    // ers_rev_CancelDate: 'Cancel Date',
    // ers_rev_CancelReason: 'Cancel Reason',
    // ers_rev_RevokeDate: 'Revoke Date',
    // ers_rev_RevokeReason: 'Revoke Reason',
    // ers_RevokeInfo: 'Revoke Info',
    // ers_ind_IndustryCode: 'Industry Code',
    // ers_ind_Industry: 'Industry',
    // ers_ind_SubIndustryCode: 'Sub Industry Code',
    // ers_ind_SubIndustry: 'Sub Industry',
    // ers_ind_MiddleCategoryCode: 'Middle Category Code',
    // ers_ind_MiddleCategory: 'Middle Category',
    // ers_ind_SmallCategoryCode: 'Small Category Code',
    // ers_ind_SmallCategory: 'Small Category',
    // ers_PermissionInfo: 'Permission Info',
    // ers_Penalty: 'Penalty',
    // ers_Exceptions: 'Exceptions',
    // ers_ShiXinItems: 'Shi Xin Items',
    // ers_ZhiXingItems: 'Zhi Xing Items',
    // ers_MPledge: 'M Pledge',
    // ers_Pledge: 'Pledge',
    // ers_SpotCheck: 'Spot Check',
    // ers_CompanyTaxCreditItems: 'Company Tax Credit Items',
    // ers_CompanyProducts: 'Company Products',
    // ers_PermissionEciInfo: 'Permission Eci Info',
    // ers_PenaltyCreditChina: 'Penalty Credit China',
    // ers_Partners: 'Partners',
    // ers_Employees: 'Employees',
    // ers_Branches: 'Branches',
    // ers_ChangeRecords: 'Change Records',
    // ers_EmergingIndustyList: 'Emerging Industy List',
    // ers_TagList: 'Tag List',
    // ers_ARContactList: 'A R Contact List',
    // ers_OriginalName: 'Original Name'
  },
  atb_home: {
    price_description: "Стоимость 1 запроса",
    service_price_for_privileged: "для клиентов АТБ",

    find_parnter_410_description:
      "Найдем и проведем первичный анализ контрагентов или бизнес партнеров в Китае по направлению бизнес-деятельности",

    service_monitoring_title:
      "Мониторинг и&nbsp;проверка потенциальных контрагентов",
    service_monitoring_description:
      "<ul><li>Санкционные списки</li><li>Отчёты кредитных бюро</li><li>Отчёты комиссий по ценным бумагам</li><li>Биржи</li></ul><p>Разовая проверка или регулярный мониторинг юридических и физических лиц по международным базам данных</p>",
    service_find_title: "Поиск зарубежных контрагентов",
    service_find_description:
      "<p>Найдем для вас контрагентов или бизнес партнеров в Китае по направлению бизнес-деятельности</p>",

    service_note_title: "Бизнес справка о&nbsp;контрагенте",
    service_note_description:
      "<ul><li>Основные сведения</li><li>Информация о годовом отчёте компании</li><li>Судебные уведомления</li><li>Сканирование корпоративных рисков</li></ul>",

    banner_title: "Специальные условия для&nbsp;клиентов АТБ",
    banner_text:
      "Получите 3000 приветственных баллов.<br>Получите специальные тарифы на услуги АТТИС",
    banner_button_1: "Стать клиентом АТБ",
    banner_button_2: "Об условиях",

    contact_form_title: "Форма обратной связи",
    contact_form_subject: "Тема сообщения",
    contact_form_name: "Ваше имя",
    contact_form_email: "Почта",
    contact_form_message: "Сообщение",
    contact_form_accept:
      "Я выражаю свое согласие на обработку и передачу моих персональных данных",
    contact_form_submit: "Подтвердить",
    contact_form_submit_success: "Сообщение отправлено",
    contact_form_submit_sending: "Отправка...",
    contact_form_subject_placeholder: "Укажите цель обращения",
    contact_form_name_placeholder: "ФИО",
    contact_form_email_placeholder: "E-mail",
    contact_form_message_placeholder: "Текст сообщения",

    footer_address: "630005, г. Новосибирск, ул. Некрасова, д. 48, офис 502 ",
  },
  kz_home: {
    footer_address:
      "010000, г. Астана, Алматинский район, проспект Р. Кошкарбаева, 28, н.п. 10",
  },
  hypertable: {
    date_since: "Дата с",
    date_till: "по",
    or: "или",
    monthly_report: "Отчет за месяц",
    records_per_page: "Записей на страницу",
    choose_month: "Выбрать месяц",
    year: "Год",
    month: "Месяц",
    show_report: "Показать отчет",
    month_0: "январь",
    month_1: "февраль",
    month_2: "март",
    month_3: "апрель",
    month_4: "май",
    month_5: "июнь",
    month_6: "июль",
    month_7: "август",
    month_8: "сентябрь",
    month_9: "октябрь",
    month_10: "ноябрь",
    month_11: "декабрь",
  },
  billing: {
    price: "Цена",
    your_balance: "Ваш баланс",
    not_enough_funds: "Недостаточно средств",
    not_enough_funds_history:
      "Детальная информация по этой истории не была куплена. И у вас недостаточно средств для покупки.",
    not_enough_funds_search:
      "У вас недостаточно средств для поиска/покупки этой информации.",
    buy_search: "Купить и искать?",
    buy_search_history:
      "Детальная информация по этой истории не была куплена. Хотите купить?",
    search_buy: "Хотите искать/купить эту информацию?",
  },
  service_430: {
    KeyNo: "Номер ключа",
    Name: "Имя",
    OperId: "ID оператора",
    OperName: "Имя оператора",
    Status: "Статус",
    StartDate: "Дата начала",
    RegistCapi: "Зарегистрированный капитал",
    RecCap: "Полученный капитал",
    CheckDate: "Дата проверки",
    OrgNo: "Номер организации",
    No: "Номер",
    CreditCode: "Код кредита",
    EconKind: "Экономический вид",
    TermStart: "Начало срока",
    TermEnd: "Окончание срока",
    TaxpayerType: "Тип налогоплательщика",
    BelongOrg: "Принадлежащая организация",
    PersonScope: "Область действия лица",
    InsuredCount: "Количество застрахованных",
    EnglishName: "Английское имя",
    IXCode: "Код IX",
    Address: "Адрес",
    Scope: "Область действия",
    IsOnStock: "Находится на складе",
    StockNumber: "Номер акции",
    StockType: "Тип акции",
    ImageUrl: "URL изображения",
    PhoneNumber: "Номер телефона",
    Email: "Электронная почта",
    WebSiteUrl: "URL веб-сайта",
    EntNature: "Характер предприятия",
    AreaCode: "Код города",
    RevokeInfo: "Информация об отзыве",
    ControlList: "Контрольный список",
    ParentInfo: "Информация о родительской организации",
  },
  code_must_be_12_symbols: "Налоговый код или код социального кредита должен состоять из 15 или 18 символов.",
  request_error_messages: {
    connection_issue_retrying: "Интернет соединение прервано. Повторная попытка.",
    connection_issue: "Интернет соединение прервано.",
    connection_unstable: "Ваше интернет соединение нестабильно. Получение результатов может занять очень много времени. Поменяйте интернет - провайдера и повторите снова."
  }
};
